"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[880],{

/***/ 37040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgMappointlogo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6.99964C0 3.14005 3.14015 0 7 0C10.8599 0 14 3.14005 14 6.99964C14 13.2818 7.99828 15.7547 7.74285 15.8568C7.50446 15.9518 7.25223 15.9997 7 15.9997C6.74778 15.9997 6.49556 15.9518 6.25729 15.8568C6.00175 15.7547 0 13.2818 0 6.99964ZM2.00008 6.99964C2.00008 11.9998 7 13.9998 7 13.9998C7 13.9998 12 11.9998 12 6.99964C12 4.23873 9.76147 1.99996 7 1.99996C4.23866 1.99996 2.00008 4.23873 2.00008 6.99964ZM5.00004 6.99964C5.00004 5.89523 5.89543 5.00044 7 5.00044C8.1046 5.00044 8.99999 5.89523 8.99999 6.99964C8.99999 8.10456 8.1046 8.99986 7 8.99986C5.89543 8.99986 5.00004 8.10456 5.00004 6.99964Z",
  fill: "#860935"
});

function SvgMappointlogo({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDYuOTk5NjRDMCAzLjE0MDA1IDMuMTQwMTUgMCA3IDBDMTAuODU5OSAwIDE0IDMuMTQwMDUgMTQgNi45OTk2NEMxNCAxMy4yODE4IDcuOTk4MjggMTUuNzU0NyA3Ljc0Mjg1IDE1Ljg1NjhDNy41MDQ0NiAxNS45NTE4IDcuMjUyMjMgMTUuOTk5NyA3IDE1Ljk5OTdDNi43NDc3OCAxNS45OTk3IDYuNDk1NTYgMTUuOTUxOCA2LjI1NzI5IDE1Ljg1NjhDNi4wMDE3NSAxNS43NTQ3IDAgMTMuMjgxOCAwIDYuOTk5NjRaTTIuMDAwMDggNi45OTk2NEMyLjAwMDA4IDExLjk5OTggNyAxMy45OTk4IDcgMTMuOTk5OEM3IDEzLjk5OTggMTIgMTEuOTk5OCAxMiA2Ljk5OTY0QzEyIDQuMjM4NzMgOS43NjE0NyAxLjk5OTk2IDcgMS45OTk5NkM0LjIzODY2IDEuOTk5OTYgMi4wMDAwOCA0LjIzODczIDIuMDAwMDggNi45OTk2NFpNNS4wMDAwNCA2Ljk5OTY0QzUuMDAwMDQgNS44OTUyMyA1Ljg5NTQzIDUuMDAwNDQgNyA1LjAwMDQ0QzguMTA0NiA1LjAwMDQ0IDguOTk5OTkgNS44OTUyMyA4Ljk5OTk5IDYuOTk5NjRDOC45OTk5OSA4LjEwNDU2IDguMTA0NiA4Ljk5OTg2IDcgOC45OTk4NkM1Ljg5NTQzIDguOTk5ODYgNS4wMDAwNCA4LjEwNDU2IDUuMDAwMDQgNi45OTk2NFoiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 93245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgClose; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M6.66667 8L0.266667 1.51111C0.0888889 1.33333 0 1.15556 0 0.888889C0 0.622222 0.0888889 0.444444 0.266667 0.266667C0.444444 0.0888889 0.8 0 1.06667 0C1.33333 0 1.6 0.0888889 1.77778 0.266667L8 6.57778L14.2222 0.266667C14.4 0.0888889 14.6667 0 14.9333 0C15.2 0 15.4667 0.0888889 15.6444 0.266667C15.8222 0.444444 16 0.622222 16 0.888889C16 1.15556 15.9111 1.33333 15.7333 1.51111L9.33333 8L15.8222 14.5778C15.9111 14.7556 16 14.9333 16 15.1111C16 15.3778 15.9111 15.5556 15.7333 15.7333C15.5556 15.9111 15.2889 16 14.9333 16C14.5778 16 14.4 15.9111 14.2222 15.7333L8 9.33333L1.77778 15.7333C1.6 15.9111 1.33333 16 1.06667 16C0.8 16 0.533333 15.9111 0.355556 15.7333C0.177778 15.5556 0 15.3778 0 15.1111C0 14.9333 0.0888889 14.7556 0.177778 14.5778L6.66667 8Z",
  fill: "black"
});

function SvgClose({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjY2NjcgOEwwLjI2NjY2NyAxLjUxMTExQzAuMDg4ODg4OSAxLjMzMzMzIDAgMS4xNTU1NiAwIDAuODg4ODg5QzAgMC42MjIyMjIgMC4wODg4ODg5IDAuNDQ0NDQ0IDAuMjY2NjY3IDAuMjY2NjY3QzAuNDQ0NDQ0IDAuMDg4ODg4OSAwLjggMCAxLjA2NjY3IDBDMS4zMzMzMyAwIDEuNiAwLjA4ODg4ODkgMS43Nzc3OCAwLjI2NjY2N0w4IDYuNTc3NzhMMTQuMjIyMiAwLjI2NjY2N0MxNC40IDAuMDg4ODg4OSAxNC42NjY3IDAgMTQuOTMzMyAwQzE1LjIgMCAxNS40NjY3IDAuMDg4ODg4OSAxNS42NDQ0IDAuMjY2NjY3QzE1LjgyMjIgMC40NDQ0NDQgMTYgMC42MjIyMjIgMTYgMC44ODg4ODlDMTYgMS4xNTU1NiAxNS45MTExIDEuMzMzMzMgMTUuNzMzMyAxLjUxMTExTDkuMzMzMzMgOEwxNS44MjIyIDE0LjU3NzhDMTUuOTExMSAxNC43NTU2IDE2IDE0LjkzMzMgMTYgMTUuMTExMUMxNiAxNS4zNzc4IDE1LjkxMTEgMTUuNTU1NiAxNS43MzMzIDE1LjczMzNDMTUuNTU1NiAxNS45MTExIDE1LjI4ODkgMTYgMTQuOTMzMyAxNkMxNC41Nzc4IDE2IDE0LjQgMTUuOTExMSAxNC4yMjIyIDE1LjczMzNMOCA5LjMzMzMzTDEuNzc3NzggMTUuNzMzM0MxLjYgMTUuOTExMSAxLjMzMzMzIDE2IDEuMDY2NjcgMTZDMC44IDE2IDAuNTMzMzMzIDE1LjkxMTEgMC4zNTU1NTYgMTUuNzMzM0MwLjE3Nzc3OCAxNS41NTU2IDAgMTUuMzc3OCAwIDE1LjExMTFDMCAxNC45MzMzIDAuMDg4ODg4OSAxNC43NTU2IDAuMTc3Nzc4IDE0LjU3NzhMNi42NjY2NyA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 46479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_A1_A1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
;// CONCATENATED MODULE: ./src/assets/images/Layout/Footer/A1.png
/* harmony default export */ var A1 = ("/_next/static/images/A1-dccd9b550cb9dfb5a67a2d5c4f7f7f00.png");
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/A1/A1.tsx









function A1_A1({
  title
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, {
      to: `tel:${title}`,
      children: [(0,common/* getCurrentProject */.vo)() === 'dveri' ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
        src: A1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: title
      })]
    })
  });
}

/* harmony default export */ var components_A1_A1 = (A1_A1);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "A1__Component",
  componentId: "sc-13vvka8-0"
})(["cursor:pointer;display:flex;align-items:center;min-height:34px;min-width:140px;max-width:320px;img{height:18px;}span{font-style:normal;font-weight:600;font-size:16px;line-height:20px;margin-left:4px;white-space:nowrap;}& > a{display:flex;}"]);

/***/ }),

/***/ 18176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _A1__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _A1__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46479);


/***/ }),

/***/ 99492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ButtonLink; },
  "Co": function() { return /* binding */ Button_Button; }
});

// UNUSED EXPORTS: Button

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Spinner/index.ts + 1 modules
var Spinner = __webpack_require__(66595);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
;// CONCATENATED MODULE: ./src/components/Button/Button.style.ts


const primaryOutlineMixin = (0,styled_components_browser_esm.css)(["border:1px solid ", ";color:", ";&:hover{color:", ";background:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary);
const primaryContainedMixin = (0,styled_components_browser_esm.css)(["background:", ";color:", ";border:1px solid ", ";&:hover{background:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary, theme/* colors.primary100 */.O9.primary100);
const largeSizeMixin = (0,styled_components_browser_esm.css)(["line-height:40px;padding:0 20px;"]);
const customSizeMixin = (0,styled_components_browser_esm.css)(["font-style:normal;font-weight:500;font-size:13px;line-height:20px;padding:7px 20px;"]);
const smallSizeMixin = (0,styled_components_browser_esm.css)(["height:30px;line-height:28px;padding:0 12px;"]);
const variantCssMap = {
  outlined: (0,styled_components_browser_esm.css)(["background-color:#24292e;opacity:0.95;color:white;border:1px solid #24292e;&:hover{background-color:black;}"]),
  contained: (0,styled_components_browser_esm.css)(["background-color:white;color:#24292e;border:1px solid #24292e;&:hover{background-color:#24292e;opacity:0.95;color:white;}"]),
  'call-me-solid': (0,styled_components_browser_esm.css)(["background:transparent;border:1px solid #b7b7b7;font-size:13px;color:inherit;", ";&:hover{color:", ";background:#eeeeee;}&:hover[disabled]{background:transparent;}"], smallSizeMixin, theme/* colors.black */.O9.black),
  'call-me-dashed': (0,styled_components_browser_esm.css)(["border:1px dashed #dfdfdf;background:transparent;font-size:13px;", ";&:hover{border-color:", ";}&:hover[disabled]{border-color:#dfdfdf;}"], smallSizeMixin, theme/* colors.black */.O9.black),
  'outlined-primary': (0,styled_components_browser_esm.css)(["font-size:16px;font-weight:600;", " ", " &:hover{background:", ";color:", ";}&:hover[disabled]{background:", ";color:", ";}"], primaryOutlineMixin, largeSizeMixin, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary),
  'contained-primary': (0,styled_components_browser_esm.css)(["font-size:16px;font-weight:500;", ";", ";&:hover[disabled]{background-color:", ";}"], largeSizeMixin, primaryContainedMixin, theme/* colors.primary */.O9.primary),
  'contained-primary-w100': (0,styled_components_browser_esm.css)(["font-size:20px;font-weight:500;width:100%;", ";", " &:hover[disabled]{background-color:", ";}"], primaryContainedMixin, largeSizeMixin, theme/* colors.primary */.O9.primary),
  'contained-primary-w100-f13': (0,styled_components_browser_esm.css)(["font-size:13px;font-weight:500;width:100%;", ";", " &:hover[disabled]{background-color:", ";}"], primaryContainedMixin, largeSizeMixin, theme/* colors.primary */.O9.primary),
  'outlined-primary-w100': (0,styled_components_browser_esm.css)(["font-weight:500;font-size:15px;width:100%;", " ", " &:hover[disabled]{background:", ";color:", ";}"], largeSizeMixin, primaryOutlineMixin, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary),
  'outlined-primary-w100-f14': (0,styled_components_browser_esm.css)(["font-weight:500;font-size:14px;width:100%;", " ", " &:hover[disabled]{background:", ";color:", ";}"], largeSizeMixin, primaryOutlineMixin, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary),
  'outlined-primary-w100-f13': (0,styled_components_browser_esm.css)(["", " ", " &:hover[disabled]{background:", ";color:", ";}"], customSizeMixin, primaryOutlineMixin, theme/* colors.white */.O9.white, theme/* colors.primary */.O9.primary)
};
const StyledButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "Buttonstyle__StyledButton",
  componentId: "sc-crigw0-0"
})(["", ";display:block;position:relative;text-align:center;text-decoration:none;border-radius:5px;transition:0.3s;cursor:pointer;", ";&:disabled{cursor:default;opacity:70%;}", ""], props => typeof props.variant === 'string' ? variantCssMap[props.variant] : props.variant, props => props.loading ? (0,styled_components_browser_esm.css)(["pointer-events:none;opacity:70%;"]) : (0,styled_components_browser_esm.css)([""]), props => props.width ? (0,styled_components_browser_esm.css)(["width:", ";"], props.width) : null);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Button/Button.tsx


const _excluded = ["type", "loading", "children", "onClick", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







const Button = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    type = 'button',
    loading = false,
    children,
    onClick,
    width
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, _objectSpread(_objectSpread({
    onClick: onClick,
    width: width,
    ref: ref,
    type: type,
    loading: loading
  }, rest), {}, {
    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* Overlay */.a, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
          color: "primary",
          absolute: true
        })
      })]
    }) : children
  }));
});
const ButtonLink = /*#__PURE__*/react.forwardRef((props, ref) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, _objectSpread({
    as: "a",
    ref: ref
  }, props));
});
/* harmony default export */ var Button_Button = (Button);

/***/ }),

/***/ 91533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Co; },
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.ZP; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99492);



/***/ }),

/***/ 64283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);

const ContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "ContentContainer",
  componentId: "sc-cuhhxr-0"
})(["overflow:hidden;width:100%;padding:0 15px;"]);
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);

/***/ }),

/***/ 98133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84229);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






function FormControl({
  className,
  error,
  children
}) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: className,
    children: [children, error ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ErrorMessage, {
      children: error
    }) : null]
  });
}

const ErrorMessage = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  displayName: "FormControl__ErrorMessage",
  componentId: "sc-8ogwqi-0"
})(["position:absolute;display:block;font-size:11px;line-height:15px;color:", ";text-align:right;margin-top:2px;"], _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.red */ .O9.red);
/* harmony default export */ __webpack_exports__["Z"] = (FormControl);

/***/ }),

/***/ 29117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Forms_SuccessForm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/assets/svg/thank.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M503.562 272.168c0-25.965-21.124-47.088-47.088-47.088h-85.375c13.222-23.935 20.253-46.525 20.253-77.724v-5.042-.008c-.005-16.782-6.491-32.607-18.267-44.559-11.769-11.945-27.482-18.669-44.245-18.931-.16-.002-.321-.004-.481-.004-16.247 0-30.455 12.922-31.789 29.023-6.361 76.781-80.346 116.349-129.835 140.415v-7.945c0-8.3-6.729-15.028-15.028-15.028H23.466c-8.3 0-15.028 6.729-15.028 15.028v256.48c0 8.299 6.729 15.028 15.028 15.028h96.18c18.422 0 34.396-10.639 42.129-26.091C215.299 508.972 261.799 512 315.199 512c9.121 0 18.452-.088 28.046-.179 10.609-.1 21.579-.204 33.079-.204h47.515c25.965 0 47.088-21.124 47.088-47.088 0-8.73-2.388-16.912-6.545-23.929 13.529-8.283 22.575-23.199 22.575-40.191 0-8.73-2.387-16.912-6.545-23.929 13.529-8.283 22.575-23.199 22.575-40.191 0-12.228-4.687-23.379-12.356-31.758 8.004-8.446 12.931-19.837 12.931-32.363zM136.678 464.724c0 9.392-7.64 17.032-17.032 17.032h-17.032v-49.092c0-8.3-6.729-15.028-15.028-15.028s-15.028 6.729-15.028 15.028v49.092H38.495V255.332h98.184v209.392zm287.736-145.468h31.485c9.392 0 17.032 7.64 17.032 17.032s-7.64 17.032-17.032 17.032h-31.485c-8.3 0-15.028 6.729-15.028 15.028s6.729 15.028 15.028 15.028h15.455c9.392 0 17.032 7.64 17.032 17.032s-7.64 17.032-17.032 17.032h-16.03c-8.3 0-15.028 6.729-15.028 15.028s6.729 15.028 15.028 15.028c9.392 0 17.032 7.64 17.032 17.032s-7.64 17.032-17.032 17.032h-47.515c-11.642 0-22.684.104-33.363.206-66.992.633-116.21 1.101-176.029-26.674V281.537h-.001c1.564-.756 3.169-1.531 4.806-2.32 26.125-12.596 61.904-29.846 92.668-55.973 37.661-31.986 58.562-69.981 62.119-112.929.042-.51 1.022-1.449 1.829-1.449h.016c18.156.284 32.927 15.293 32.927 33.457v5.032c0 31.24-8.147 51.006-25.188 77.724h-23.904c-8.3 0-15.028 6.729-15.028 15.028 0 8.3 6.729 15.028 15.028 15.028h144.27c9.392 0 17.032 7.64 17.032 17.032s-7.64 17.032-17.032 17.032h-32.06c-8.3 0-15.028 6.729-15.028 15.028 0 8.3 6.729 15.029 15.028 15.029zM472.307 111.062h-32.06c-8.3 0-15.028 6.729-15.028 15.028s6.729 15.028 15.028 15.028h32.06c8.3 0 15.028-6.729 15.028-15.028s-6.728-15.028-15.028-15.028z"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M247.887 111.062h-32.06c-8.3 0-15.028 6.729-15.028 15.028s6.729 15.028 15.028 15.028h32.06c8.299 0 15.028-6.729 15.028-15.028s-6.729-15.028-15.028-15.028zM308.991 35.282l-16.03-27.765c-4.15-7.188-13.341-9.651-20.528-5.5-7.188 4.15-9.65 13.341-5.5 20.528l16.03 27.765c2.783 4.822 7.835 7.516 13.028 7.516 2.549 0 5.134-.649 7.5-2.016 7.187-4.149 9.65-13.34 5.5-20.528zM415.701 2.017c-7.188-4.152-16.38-1.687-20.528 5.5l-16.03 27.765c-4.151 7.187-1.688 16.379 5.5 20.528a14.95 14.95 0 007.5 2.016c5.194 0 10.246-2.695 13.028-7.516l16.03-27.765c4.15-7.187 1.688-16.378-5.5-20.528z"
});

function SvgThank({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#860935",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

/* harmony default export */ var thank = ("data:image/svg+xml;base64,IDxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZmlsbD0iIzg2MDkzNSI+CiAgPHBhdGgKICAgICAgICBkPSJNNTAzLjU2MiAyNzIuMTY4YzAtMjUuOTY1LTIxLjEyNC00Ny4wODgtNDcuMDg4LTQ3LjA4OGgtODUuMzc1YzEzLjIyMi0yMy45MzUgMjAuMjUzLTQ2LjUyNSAyMC4yNTMtNzcuNzI0di01LjA0Mi0uMDA4Yy0uMDA1LTE2Ljc4Mi02LjQ5MS0zMi42MDctMTguMjY3LTQ0LjU1OS0xMS43NjktMTEuOTQ1LTI3LjQ4Mi0xOC42NjktNDQuMjQ1LTE4LjkzMS0uMTYtLjAwMi0uMzIxLS4wMDQtLjQ4MS0uMDA0LTE2LjI0NyAwLTMwLjQ1NSAxMi45MjItMzEuNzg5IDI5LjAyMy02LjM2MSA3Ni43ODEtODAuMzQ2IDExNi4zNDktMTI5LjgzNSAxNDAuNDE1di03Ljk0NWMwLTguMy02LjcyOS0xNS4wMjgtMTUuMDI4LTE1LjAyOEgyMy40NjZjLTguMyAwLTE1LjAyOCA2LjcyOS0xNS4wMjggMTUuMDI4djI1Ni40OGMwIDguMjk5IDYuNzI5IDE1LjAyOCAxNS4wMjggMTUuMDI4aDk2LjE4YzE4LjQyMiAwIDM0LjM5Ni0xMC42MzkgNDIuMTI5LTI2LjA5MUMyMTUuMjk5IDUwOC45NzIgMjYxLjc5OSA1MTIgMzE1LjE5OSA1MTJjOS4xMjEgMCAxOC40NTItLjA4OCAyOC4wNDYtLjE3OSAxMC42MDktLjEgMjEuNTc5LS4yMDQgMzMuMDc5LS4yMDRoNDcuNTE1YzI1Ljk2NSAwIDQ3LjA4OC0yMS4xMjQgNDcuMDg4LTQ3LjA4OCAwLTguNzMtMi4zODgtMTYuOTEyLTYuNTQ1LTIzLjkyOSAxMy41MjktOC4yODMgMjIuNTc1LTIzLjE5OSAyMi41NzUtNDAuMTkxIDAtOC43My0yLjM4Ny0xNi45MTItNi41NDUtMjMuOTI5IDEzLjUyOS04LjI4MyAyMi41NzUtMjMuMTk5IDIyLjU3NS00MC4xOTEgMC0xMi4yMjgtNC42ODctMjMuMzc5LTEyLjM1Ni0zMS43NTggOC4wMDQtOC40NDYgMTIuOTMxLTE5LjgzNyAxMi45MzEtMzIuMzYzek0xMzYuNjc4IDQ2NC43MjRjMCA5LjM5Mi03LjY0IDE3LjAzMi0xNy4wMzIgMTcuMDMyaC0xNy4wMzJ2LTQ5LjA5MmMwLTguMy02LjcyOS0xNS4wMjgtMTUuMDI4LTE1LjAyOHMtMTUuMDI4IDYuNzI5LTE1LjAyOCAxNS4wMjh2NDkuMDkySDM4LjQ5NVYyNTUuMzMyaDk4LjE4NHYyMDkuMzkyem0yODcuNzM2LTE0NS40NjhoMzEuNDg1YzkuMzkyIDAgMTcuMDMyIDcuNjQgMTcuMDMyIDE3LjAzMnMtNy42NCAxNy4wMzItMTcuMDMyIDE3LjAzMmgtMzEuNDg1Yy04LjMgMC0xNS4wMjggNi43MjktMTUuMDI4IDE1LjAyOHM2LjcyOSAxNS4wMjggMTUuMDI4IDE1LjAyOGgxNS40NTVjOS4zOTIgMCAxNy4wMzIgNy42NCAxNy4wMzIgMTcuMDMycy03LjY0IDE3LjAzMi0xNy4wMzIgMTcuMDMyaC0xNi4wM2MtOC4zIDAtMTUuMDI4IDYuNzI5LTE1LjAyOCAxNS4wMjhzNi43MjkgMTUuMDI4IDE1LjAyOCAxNS4wMjhjOS4zOTIgMCAxNy4wMzIgNy42NCAxNy4wMzIgMTcuMDMycy03LjY0IDE3LjAzMi0xNy4wMzIgMTcuMDMyaC00Ny41MTVjLTExLjY0MiAwLTIyLjY4NC4xMDQtMzMuMzYzLjIwNi02Ni45OTIuNjMzLTExNi4yMSAxLjEwMS0xNzYuMDI5LTI2LjY3NFYyODEuNTM3aC0uMDAxYzEuNTY0LS43NTYgMy4xNjktMS41MzEgNC44MDYtMi4zMiAyNi4xMjUtMTIuNTk2IDYxLjkwNC0yOS44NDYgOTIuNjY4LTU1Ljk3MyAzNy42NjEtMzEuOTg2IDU4LjU2Mi02OS45ODEgNjIuMTE5LTExMi45MjkuMDQyLS41MSAxLjAyMi0xLjQ0OSAxLjgyOS0xLjQ0OWguMDE2YzE4LjE1Ni4yODQgMzIuOTI3IDE1LjI5MyAzMi45MjcgMzMuNDU3djUuMDMyYzAgMzEuMjQtOC4xNDcgNTEuMDA2LTI1LjE4OCA3Ny43MjRoLTIzLjkwNGMtOC4zIDAtMTUuMDI4IDYuNzI5LTE1LjAyOCAxNS4wMjggMCA4LjMgNi43MjkgMTUuMDI4IDE1LjAyOCAxNS4wMjhoMTQ0LjI3YzkuMzkyIDAgMTcuMDMyIDcuNjQgMTcuMDMyIDE3LjAzMnMtNy42NCAxNy4wMzItMTcuMDMyIDE3LjAzMmgtMzIuMDZjLTguMyAwLTE1LjAyOCA2LjcyOS0xNS4wMjggMTUuMDI4IDAgOC4zIDYuNzI5IDE1LjAyOSAxNS4wMjggMTUuMDI5ek00NzIuMzA3IDExMS4wNjJoLTMyLjA2Yy04LjMgMC0xNS4wMjggNi43MjktMTUuMDI4IDE1LjAyOHM2LjcyOSAxNS4wMjggMTUuMDI4IDE1LjAyOGgzMi4wNmM4LjMgMCAxNS4wMjgtNi43MjkgMTUuMDI4LTE1LjAyOHMtNi43MjgtMTUuMDI4LTE1LjAyOC0xNS4wMjh6Ii8+CiAgPHBhdGggZD0iTTI0Ny44ODcgMTExLjA2MmgtMzIuMDZjLTguMyAwLTE1LjAyOCA2LjcyOS0xNS4wMjggMTUuMDI4czYuNzI5IDE1LjAyOCAxNS4wMjggMTUuMDI4aDMyLjA2YzguMjk5IDAgMTUuMDI4LTYuNzI5IDE1LjAyOC0xNS4wMjhzLTYuNzI5LTE1LjAyOC0xNS4wMjgtMTUuMDI4ek0zMDguOTkxIDM1LjI4MmwtMTYuMDMtMjcuNzY1Yy00LjE1LTcuMTg4LTEzLjM0MS05LjY1MS0yMC41MjgtNS41LTcuMTg4IDQuMTUtOS42NSAxMy4zNDEtNS41IDIwLjUyOGwxNi4wMyAyNy43NjVjMi43ODMgNC44MjIgNy44MzUgNy41MTYgMTMuMDI4IDcuNTE2IDIuNTQ5IDAgNS4xMzQtLjY0OSA3LjUtMi4wMTYgNy4xODctNC4xNDkgOS42NS0xMy4zNCA1LjUtMjAuNTI4ek00MTUuNzAxIDIuMDE3Yy03LjE4OC00LjE1Mi0xNi4zOC0xLjY4Ny0yMC41MjggNS41bC0xNi4wMyAyNy43NjVjLTQuMTUxIDcuMTg3LTEuNjg4IDE2LjM3OSA1LjUgMjAuNTI4YTE0Ljk1IDE0Ljk1IDAgMDA3LjUgMi4wMTZjNS4xOTQgMCAxMC4yNDYtMi42OTUgMTMuMDI4LTcuNTE2bDE2LjAzLTI3Ljc2NWM0LjE1LTcuMTg3IDEuNjg4LTE2LjM3OC01LjUtMjAuNTI4eiIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Forms/SuccessForm.tsx







function SuccessForm({
  title,
  text,
  textNote
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgThank, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: title
    }), textNote ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextNote, {
      children: textNote
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
      children: text
    })]
  });
}

const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SuccessForm__Container",
  componentId: "sc-pxhzsl-0"
})(["height:min(calc(var(--vh,1) * 100),500px);display:flex;justify-content:center;flex-direction:column;text-align:center;font-size:16px;font-weight:500;padding:40px 50px;"]);
const IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SuccessForm__IconWrapper",
  componentId: "sc-pxhzsl-1"
})(["width:64px;height:64px;margin:0 auto 30px;svg{fill:", ";}"], theme/* colors.primary */.O9.primary);
const Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "SuccessForm__Title",
  componentId: "sc-pxhzsl-2"
})(["font-size:21px;display:block;font-weight:500;"]);
const Text = styled_components_browser_esm["default"].p.withConfig({
  displayName: "SuccessForm__Text",
  componentId: "sc-pxhzsl-3"
})(["font-size:14px;line-height:20px;display:block;margin-top:15px;"]);
const TextNote = (0,styled_components_browser_esm["default"])(Text).withConfig({
  displayName: "SuccessForm__TextNote",
  componentId: "sc-pxhzsl-4"
})(["margin-top:20px;"]);
/* harmony default export */ var Forms_SuccessForm = (SuccessForm);

/***/ }),

/***/ 851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/providers/LogoTriggerProvider/LogoTriggerProvider.tsx


const defaultState = {
  isTriggered: false
};
const LogoContext = /*#__PURE__*/react.createContext(defaultState);

function LogoProvider({
  children
}) {
  const {
    0: triggered,
    1: setTriggered
  } = (0,react.useState)(false);

  const triggerLogo = state => {
    setTriggered(prev => state);
    setTimeout(() => setTriggered(false), 0);
  };

  const values = {
    isTriggered: triggered,
    triggerLogo
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LogoContext.Provider, {
    value: values,
    children: children
  });
}

/* harmony default export */ var LogoTriggerProvider = (LogoProvider);
;// CONCATENATED MODULE: ./src/components/MenuLayout/MenuLayout.tsx








function MenuLayout({
  children
}) {
  const {
    triggerLogo
  } = (0,react.useContext)(LogoContext);
  const ref = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    return () => triggerLogo && triggerLogo(false);
  }, [triggerLogo]);
  (0,react.useEffect)(() => {
    const target = ref.current;
    const options = {
      reserveScrollBarGap: true,
      allowTouchMove: el => el.classList.contains('scrollable')
    };

    if (target) {
      (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(target, options);
    }

    return () => {
      if (target) {
        (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(target);
      }
    };
  }, []);
  (0,react.useEffect)(() => {
    const offset = window.pageYOffset;
    return () => {
      window.scrollTo(0, offset);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalOverlay, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Scrolling, {
        ref: ref,
        className: "scrollable",
        children: children
      })
    })]
  });
}

/* harmony default export */ var MenuLayout_MenuLayout = (MenuLayout);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MenuLayout__Component",
  componentId: "sc-887k2d-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:5;margin:45px auto 0;@media (min-width:", "px){margin-top:80px;padding-bottom:80px;}@media (min-width:", "px){margin-top:70px;padding-bottom:70px;}@media (min-width:", "px){margin-top:60px;padding-bottom:60px;}"], theme/* breakpoints.laptop */.AV.laptop, theme/* breakpoints.tabletLarge */.AV.tabletLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Scrolling = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MenuLayout__Scrolling",
  componentId: "sc-887k2d-1"
})(["height:100%;-webkit-overflow-scrolling:touch !important;overflow:auto !important;"]);
const ModalOverlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MenuLayout__ModalOverlay",
  componentId: "sc-887k2d-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);"]);
const ModalContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MenuLayout__ModalContainer",
  componentId: "sc-887k2d-3"
})(["position:absolute;top:0;left:0;right:0;bottom:0;width:100%;max-width:1260px;margin:0 auto;transform:translateX(0);background-color:#fff;-webkit-overflow-scrolling:touch !important;overflow:auto !important;"]);
;// CONCATENATED MODULE: ./src/components/MenuLayout/index.ts

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/components/Portal/Portal.tsx






function Portal({
  children
}) {
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)(Portal_Component, {
    children: children
  }), document.body);
}

const Portal_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Portal__Component",
  componentId: "sc-18syr7i-0"
})(["position:fixed;width:100vw;height:calc(100vh - 45px);top:45px;z-index:10;@media (min-width:", "px){height:calc(100vh - 80px);top:80px;}@media (min-width:", "px){height:calc(100vh - 70px);top:70px;}@media (min-width:", "px){height:calc(100vh - 60px);top:60px;}"], theme/* breakpoints.laptop */.AV.laptop, theme/* breakpoints.tabletLarge */.AV.tabletLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
/* harmony default export */ var Portal_Portal = (Portal);
;// CONCATENATED MODULE: ./src/components/Portal/index.ts

// EXTERNAL MODULE: ./src/components/Mts/index.ts + 2 modules
var Mts = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/assets/svg/Footer/Map.point.icon/Map.point.logo.svg
var Map_point_logo = __webpack_require__(37040);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
;// CONCATENATED MODULE: ./src/components/MapPointer/MapPointer.tsx









function MapPointer() {
  const link = (0,hooks/* useSettingItem */.qT)('FOOTER_LOCATION_BUTTON_URL');
  const text = (0,hooks/* useSettingItem */.qT)('FOOTER_LOCATION_BUTTON_TEXT');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MapPointer_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      to: link
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Map_point_logo/* ReactComponent */.r, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      children: text
    })]
  });
}

const StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).withConfig({
  displayName: "MapPointer__StyledLink",
  componentId: "sc-1mgrzl1-0"
})(["position:absolute;inset:0;z-index:10;margin:0 auto;width:100%;height:100%;"]);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MapPointer__Description",
  componentId: "sc-1mgrzl1-1"
})(["white-space:nowrap;margin-left:5px;"]);
const MapPointer_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MapPointer__Component",
  componentId: "sc-1mgrzl1-2"
})(["cursor:pointer;position:relative;margin-bottom:20px;display:flex;align-items:center;justify-content:center;align-self:center;width:100%;min-height:34px;max-width:290px;padding:5px;font-weight:600;font-size:13px;line-height:22px;border:1px solid ", ";border-radius:6px;color:", ";"], theme/* colors.darkRed */.O9.darkRed, theme/* colors.darkRed */.O9.darkRed);
const Icon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "MapPointer__Icon",
  componentId: "sc-1mgrzl1-3"
})(["display:flex;align-items:center;justify-content:center;"]);
/* harmony default export */ var MapPointer_MapPointer = (MapPointer);
;// CONCATENATED MODULE: ./src/components/MapPointer/index.ts

// EXTERNAL MODULE: ./src/typings/model.ts
var model = __webpack_require__(77771);
// EXTERNAL MODULE: ./src/components/A1/A1.tsx + 1 modules
var A1 = __webpack_require__(46479);
// EXTERNAL MODULE: ./src/components/SocialMediaLink/index.ts + 4 modules
var SocialMediaLink = __webpack_require__(12199);
;// CONCATENATED MODULE: ./src/components/MenuLayout/components/Menu/Menu.tsx














function Menu({
  menuStateHandler
}) {
  const router = (0,next_router.useRouter)();
  const topMenu = (0,hooks/* useMenuItem */.iX)(model/* MenuItemTypes.Top */.m.Top);
  const a1 = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_A1');
  const mts = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_MTS');
  const viber = (0,hooks/* useSettingItem */.qT)('CONTACTS_VIBER');
  const whatsUp = (0,hooks/* useSettingItem */.qT)('CONTACTS_WHATSAPP');
  const telegram = (0,hooks/* useSettingItem */.qT)('CONTACTS_TELEGRAM');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Menu_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Contancts, {
        children: [a1 && /*#__PURE__*/(0,jsx_runtime.jsx)(A1/* default */.Z, {
          title: a1
        }), mts && /*#__PURE__*/(0,jsx_runtime.jsx)(Mts/* default */.Z, {
          title: mts
        })]
      }), viber || whatsUp || telegram ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Messengers, {
        children: [viber && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
          type: "Viber",
          reference: viber
        }), whatsUp && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
          type: "WhatsUp",
          reference: whatsUp
        }), telegram && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialMediaLink/* default */.Z, {
          type: "Telegram",
          reference: telegram
        })]
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MapPointer_MapPointer, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
        children: (topMenu !== null && topMenu !== void 0 ? topMenu : []).map(({
          id,
          label,
          link
        }) => /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
          onClick: () => {
            router.push(link !== null && link !== void 0 ? link : '');
            menuStateHandler();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: label
          })
        }, id))
      })]
    })
  });
}

const HighLight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__HighLight",
  componentId: "sc-ndm4zj-0"
})(["display:inline-block;font-style:normal;font-weight:600;font-size:12px;line-height:20px;color:", ";"], theme/* colors.darkRed */.O9.darkRed);
const Map = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Map",
  componentId: "sc-ndm4zj-1"
})(["margin-top:24px;min-width:0;max-width:320px;"]);
const Menu_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Component",
  componentId: "sc-ndm4zj-2"
})(["overflow:auto;&:first-child{overflow:auto;-webkit-overflow-scrolling:touch;}"]);
const Contancts = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Contancts",
  componentId: "sc-ndm4zj-3"
})(["margin-top:20px;span{margin-left:10px;}&:last-child{margin-top:10px;}"]);
const Messengers = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Messengers",
  componentId: "sc-ndm4zj-4"
})(["display:grid;grid-template-columns:auto;justify-content:start;grid-auto-flow:column;gap:13px;margin-top:18px;"]);
const Discount = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Discount",
  componentId: "sc-ndm4zj-5"
})(["display:inline-block;margin-top:13px;font-style:normal;font-weight:normal;font-size:12px;line-height:20px;"]);
const List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Menu__List",
  componentId: "sc-ndm4zj-6"
})(["ul{margin-top:18px;}li{font-size:13px;line-height:36px;}"]);
const Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Menu__Item",
  componentId: "sc-ndm4zj-7"
})(["cursor:pointer;"]);
/* harmony default export */ var Menu_Menu = (Menu);
;// CONCATENATED MODULE: ./src/components/MenuLayout/components/Menu/index.ts

;// CONCATENATED MODULE: ./src/components/Burger/Burger.tsx










function Burger({
  catalogState,
  trigger
}) {
  const {
    0: isOpen,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    0: animate,
    1: setAnimate
  } = (0,react.useState)(false);
  const {
    isTriggered: logoClicked
  } = (0,react.useContext)(LogoContext);
  const menuOnClose = (0,react.useCallback)(() => {
    trigger(false);
    setAnimate(false);
    setTimeout(() => {
      setOpen(false);
    }, 0);
  }, [trigger]);
  const menuOnOpen = (0,react.useCallback)(() => {
    trigger(true);
    setAnimate(true);
    setOpen(true);
  }, [trigger]);

  const burgerStateHandler = () => {
    if (!isOpen) {
      menuOnOpen();
    } else {
      menuOnClose();
    }
  };

  (0,react.useEffect)(() => {
    if (logoClicked || catalogState) {
      menuOnClose();
    }
  }, [catalogState, logoClicked, menuOnClose]);
  (0,react.useEffect)(() => () => trigger(false));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(Portal_Portal, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuLayout_MenuLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Menu_Menu, {
          menuStateHandler: menuOnClose
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BurgerElement, {
      open: animate,
      onClick: burgerStateHandler,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})
    })]
  });
}

/* harmony default export */ var Burger_Burger = (Burger);
const BurgerElement = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Burger__BurgerElement",
  componentId: "sc-10em48r-0"
})(["border:none;cursor:pointer;width:24px;height:14px;margin-left:15px;position:relative;z-index:10;&:focus{outline:none;}div{transition:opacity 0.2s ease;opacity:1;position:absolute;top:6px;height:2px;width:100%;background-color:#000;", "}&::before,&::after{transition:transform 0.1s ease;display:block;content:'';position:absolute;height:2px;width:100%;background-color:#000;}&::before{top:0;", "}&::after{bottom:0;", "}"], ({
  open
}) => open && (0,styled_components_browser_esm.css)(["opacity:0;"]), ({
  open
}) => open && (0,styled_components_browser_esm.css)(["transform:rotate(45deg);top:6px;"]), ({
  open
}) => open && (0,styled_components_browser_esm.css)(["transform:rotate(-45deg);bottom:6px;"]));
;// CONCATENATED MODULE: ./src/components/Burger/index.ts

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
;// CONCATENATED MODULE: ./src/assets/svg/Menu/search.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.7 22.3L16 14.6C17.2 13.1 18 11.1 18 9C18 4 14 0 9 0C4 0 0 4 0 9C0 14 4 18 9 18C11.1 18 13.1 17.3 14.6 16L22.3 23.7C22.7 24.1 23.3 24.1 23.7 23.7C24.1 23.3 24.1 22.7 23.7 22.3ZM9 16C5.1 16 2 12.9 2 9C2 5.1 5.1 2 9 2C12.9 2 16 5.1 16 9C16 12.9 12.9 16 9 16Z",
  fill: "#101010"
});

function SvgSearch({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var search = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy43IDIyLjNMMTYgMTQuNkMxNy4yIDEzLjEgMTggMTEuMSAxOCA5QzE4IDQgMTQgMCA5IDBDNCAwIDAgNCAwIDlDMCAxNCA0IDE4IDkgMThDMTEuMSAxOCAxMy4xIDE3LjMgMTQuNiAxNkwyMi4zIDIzLjdDMjIuNyAyNC4xIDIzLjMgMjQuMSAyMy43IDIzLjdDMjQuMSAyMy4zIDI0LjEgMjIuNyAyMy43IDIyLjNaTTkgMTZDNS4xIDE2IDIgMTIuOSAyIDlDMiA1LjEgNS4xIDIgOSAyQzEyLjkgMiAxNiA1LjEgMTYgOUMxNiAxMi45IDEyLjkgMTYgOSAxNloiIGZpbGw9IiMxMDEwMTAiLz4KPC9zdmc+Cg==");

// EXTERNAL MODULE: ./src/store/reducers/pages/search.ts
var pages_search = __webpack_require__(64611);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./src/components/Input/SearchInput/SearchInput.style.tsx


const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchInputstyle__Container",
  componentId: "sc-4qycit-0"
})(["position:relative;"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "SearchInputstyle__Input",
  componentId: "sc-4qycit-1"
})(["width:100%;border:", ";height:40px;font-size:16px;padding:0 50px 0 15px;border-radius:5px;background:", ";&::placeholder{color:", ";opacity:0.7;}&:focus{border-color:", ";}"], props => props.variant === 'default' || props.borderColor === 'none' ? `none` : `1px solid ${props.borderColor === 'gray' ? theme/* colors.gray200 */.O9.gray200 : theme/* colors.primary */.O9.primary}`, ({
  variant
}) => variant === 'default' ? theme/* colors.gray100 */.O9.gray100 : theme/* colors.white */.O9.white, theme/* colors.gray500 */.O9.gray500, theme/* colors.primary100 */.O9.primary100);
const prefixCss = (0,styled_components_browser_esm.css)(["display:block;height:18px;width:18px;cursor:pointer;transition:all 0.3s ease-in-out;fill:", ";&:hover{fill:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary100 */.O9.primary100);
const IconComponent = styled_components_browser_esm["default"].svg.withConfig({
  displayName: "SearchInputstyle__IconComponent",
  componentId: "sc-4qycit-2"
})(["", ";"], prefixCss);
const SearchButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "SearchInputstyle__SearchButton",
  componentId: "sc-4qycit-3"
})(["position:absolute;right:15px;top:50%;transform:translateY(-50%);"]);
;// CONCATENATED MODULE: ./src/components/Input/SearchInput/SearchInput.tsx


const _excluded = ["className", "variant", "borderColor", "onClickButton"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function SearchInput(_ref, ref) {
  let {
    className,
    variant,
    borderColor,
    onClickButton
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, _objectSpread({
      ref: ref,
      variant: variant,
      borderColor: borderColor
    }, rest)), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchButton, {
      onClick: onClickButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconComponent, {
        as: SvgSearch
      })
    })]
  });
}

/* harmony default export */ var SearchInput_SearchInput = (/*#__PURE__*/react.forwardRef(SearchInput));
// EXTERNAL MODULE: ./src/hooks/useModalsOpen.tsx
var useModalsOpen = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
;// CONCATENATED MODULE: ./src/components/Input/SearchInput/index.ts

// EXTERNAL MODULE: ./src/assets/svg/Modals/close.svg
var Modals_close = __webpack_require__(93245);
;// CONCATENATED MODULE: ./src/components/TabsBlock/TabsBlock.tsx





function TabsBlock({
  variant,
  activeTab,
  setActiveTab,
  tabs,
  className
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs, {
    className: className,
    children: tabs.map(tab => /*#__PURE__*/(0,jsx_runtime.jsx)(TabButton, {
      variant: variant,
      onClick: () => setActiveTab(tab.value),
      isActive: activeTab === tab.value,
      children: tab.name
    }, tab.name))
  });
}

const Tabs = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TabsBlock__Tabs",
  componentId: "sc-1blbhvz-0"
})(["background:", ";display:flex;align-items:center;"], theme/* colors.gray */.O9.gray);
const TabButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "TabsBlock__TabButton",
  componentId: "sc-1blbhvz-1"
})(["position:relative;color:", ";", ";&:hover{color:", ";}&:before{content:'';position:absolute;bottom:0;height:2px;left:0;right:0;background:", ";display:", ";}"], props => props.isActive ? theme/* colors.primary */.O9.primary : theme/* colors.black */.O9.black, props => props.variant === 'big' ? (0,styled_components_browser_esm.css)(["font-size:18px;margin-right:75px;line-height:55px;font-weight:600;"]) : (0,styled_components_browser_esm.css)(["font-size:14px;margin-right:35px;line-height:40px;font-weight:500;"]), theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, props => props.isActive ? 'block' : 'none');
/* harmony default export */ var TabsBlock_TabsBlock = (TabsBlock);
;// CONCATENATED MODULE: ./src/components/TabsBlock/index.ts

// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
;// CONCATENATED MODULE: ./src/components/Title/SearchTitle.tsx




function SearchModalResultTitle({
  title
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
    children: title
  });
}

const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchTitle__Title",
  componentId: "sc-a7p7xd-0"
})(["padding:70px 0;text-align:center;font-size:18px;font-weight:500;line-height:30px;"]);
/* harmony default export */ var SearchTitle = (SearchModalResultTitle);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
;// CONCATENATED MODULE: ./src/components/PlaceholderCard/PlaceholderCard.tsx






function PlaceholderCard({
  height,
  color
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
    height: height,
    color: color,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoaderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LoaderComponent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
      })
    })
  });
}

const Content = styled_components_browser_esm["default"].a.withConfig({
  displayName: "PlaceholderCard__Content",
  componentId: "sc-12houog-0"
})(["display:flex;position:relative;transition:0.3s;border:1px solid ", ";cursor:pointer;min-height:75px;height:", "px;width:100%;background:", ";&:hover{box-shadow:0 0 20px rgba(0,0,0,0.06);}"], theme/* colors.gray100 */.O9.gray100, props => props.height, props => props.color ? props.color : theme/* colors.white */.O9.white);
const LoaderWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlaceholderCard__LoaderWrapper",
  componentId: "sc-12houog-1"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;"]);
const LoaderComponent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlaceholderCard__LoaderComponent",
  componentId: "sc-12houog-2"
})(["display:inline-block;position:relative;width:64px;height:64px;div{position:absolute;border:4px solid ", ";opacity:1;border-radius:50%;animation:lds-ripple 1s cubic-bezier(0,0.2,0.8,1) infinite;}div:nth-child(2){animation-delay:-0.5s;}@keyframes lds-ripple{0%{top:28px;left:28px;width:0;height:0;opacity:1;}100%{top:-1px;left:-1px;width:58px;height:58px;opacity:0;}}"], theme/* colors.primary100 */.O9.primary100);
/* harmony default export */ var PlaceholderCard_PlaceholderCard = (PlaceholderCard);
;// CONCATENATED MODULE: ./src/components/PlaceholderCard/index.ts

// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/utils/mixin.ts
var mixin = __webpack_require__(26542);
// EXTERNAL MODULE: ./src/components/Spinner/index.ts + 1 modules
var Spinner = __webpack_require__(66595);
;// CONCATENATED MODULE: ./src/components/Picture/Picture.tsx


const Picture_excluded = (/* unused pure expression or super */ null && (["src"])),
      _excluded2 = ["src"];

function Picture_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Picture_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Picture_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Picture_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






const MEDIA_QUERY_LIST = [{
  name: 'desktop',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: theme/* breakpoints.desktop */.AV.desktop
  })
}, {
  name: 'laptop',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: theme/* breakpoints.laptop */.AV.laptop
  })
}, {
  name: 'tabletLarge',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: theme/* breakpoints.tabletLarge */.AV.tabletLarge
  })
}, {
  name: 'tabletSmall',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: theme/* breakpoints.tabletSmall */.AV.tabletSmall
  })
}, {
  name: 'mobileLarge',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: 480
  })
}, {
  name: 'mobileSmall',
  value: (0,web_components_esm/* createMediaQuery */.Ne)({
    min: theme/* breakpoints.mobileSmall */.AV.mobileSmall
  })
}];
const BasePlainPicture = (0,web_components_esm/* createPlainPictureComponent */.yb)({
  mediaQueryList: MEDIA_QUERY_LIST
});
function PlainPicture(_ref) {
  let {
    src
  } = _ref,
      props = _objectWithoutProperties(_ref, Picture_excluded);

  return /*#__PURE__*/_jsx(BasePlainPicture, Picture_objectSpread(Picture_objectSpread({}, props), {}, {
    src: src === null || src === void 0 ? void 0 : src.replace('http://', 'https://')
  }));
}
const BasePicture = (0,web_components_esm/* createPictureComponent */.o4)({
  mediaQueryList: MEDIA_QUERY_LIST
});
function Picture(_ref2) {
  let {
    src
  } = _ref2,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(BasePicture, Picture_objectSpread(Picture_objectSpread({}, props), {}, {
    src: src === null || src === void 0 ? void 0 : src.replace('http://', 'https://'),
    spinnerComponent: Spinner/* default */.Z
  }));
}
;// CONCATENATED MODULE: ./src/assets/images/placeholder.png
/* harmony default export */ var placeholder = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAIAAAAHjs1qAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0MjY4QTU4ODI2NkRFMjExQTA5QkU3NzkzRUE5Qjc5QiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2MTg5MDlGMEZFRUUxMUU0QTc2QkNEMjY5OTFDODIxMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2MTg5MDlFRkZFRUUxMUU0QTc2QkNEMjY5OTFDODIxMSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCQkY0NTk2QjEwQjRFMjExQkVBN0JFQTA3MEQ2OTg2QSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0MjY4QTU4ODI2NkRFMjExQTA5QkU3NzkzRUE5Qjc5QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpgPJHAAAAjLSURBVHja7N3rUlrLFkBhY0RRoxK1NJX3f7fEC4qK3NR4ZjnrdK0Nxu1WQHB94wdFiAL2Gj179nV9eXx8XAHqwaoiAN0BugN0B+gO0B2gO0B3gO4A3QG6A3QH3QG6A3QH6A7QHaA7QHeA7gDdAboDdAfdAboDdAfoDtAdoDtAd4DuAN0BugN0B90BugN0B+gO0B2gO0B3gO4A3QG6A3QH3QG6A3QH6A7QHaA7QHeA7gDdAboDdAfoDroDdAfoDtAdoDtAd4DuAN0BugN0B+gOugN0B+gO0B2gO0B3gO4A3QG6A3QH6A66A3QH6A7QHaA7sACs1edPfXx8vL6+7vf78cSFL3z58uXbE7X4Y2ty7f/8+XN6etrtdvn9rPF7e3uHh4ei+yeh+8TqquTtH5ZHFIjHbPe2t7c3Nzfl7p+B4XBYUhqil6JI19P70Wgkun+eS5vxLB9JXwJ8rQpktVbXNS/q4xN1jvST5ZDlQ/dPHtX8+bVibaWuZEirp/G1bdbqq3v2z1qt1u7ubjypz199cXHR6/XqWc/rq3te+0ajsb6+Xq9Lvlbfi173cegaNut1HpUy7QK6A3QH6A4sSTddEfytP1cdqhsOh/1+fzQa5ZqqRqOxubnZbDZrO1FF909F8ThE73Q6vV4vRK+uqbq6ulpfX2+1Wtvb24qL7p+B29vb8/Pz+/v7L/9npbL8ZjAYnJyc7O3tHRwcKCu5+9K7fnp6mq5PRv3yPGL/5eWl4qL7EhOWt9vtSGDGdoRMztGE9GF8ZPYKje7LSrfbvbu7e81C8PiZh4eHMN4aerovJSFuZDLVHSH/anzk8VE9FB3dlzKTydC+8ooVJmW4puwPBN2XiVwP/J/G1EN30Z3uy5rMvCERN+VE9+UslNXVN+xWnvU68me/j/4x3d/Lf9rzkRUjakiz2Zyp5c+2HpoUur+XPEfuNSMz8TO5uGBra2tG0b18gfig6A0bAnoPFhE8Tx6p1e/3Xz54LEN7iN5qtWYXaMPym5ubEP3+/j5bkmh8okLGl3QuGt2nwNevXw8PD3///j22iGAyusf/7u/vb2xszOK0lojonU7n6urq4eGhGubjW93e3kb6FB8dDYvrJZl5L2Hw8fFxxNEcl6x2CnPoJpcYRK3Y3d2dVhpdHRQajUa/fv26uLjIDyrL1PJ5PEbUjwrZbrfLr+i5iu5vJ8Lnz58/I752u92Ir+V8jrAtwn9kO5HDRK1Ymd5BXOVNer1eLlCbTFeqndd4Hl8vfixqXXwlPVe6vzerOTg4CK0jdc7tHeFfJOtRExqNxoxGSKLPcHZ29qzrz1aPrI3RFsW3dcnoPgXpt594IYOf1mdFpRpz/eVJgPzoqCHRGhwdHTFe7j5bpuj63d3dyclJGF99z5cz8jJgWvKflbdODNMd8yMSkvA1OqBviNA5QJnG54ZaeTzdF5dwNHKYHOl/24qdzKniHaJ9iJqjSOm+WFQHEMP199xOp1pDIsbnjIESpvvCJf1harvdLq6/LecuqUumMbltnPF0Xzg6nc719XXV1/dXoTS+9FxB94Xg6upqugcZlFHRHKuJrMaSMrovBBHUz8/PZ9QlyLGa4XAoq6H7xxPJeqTsK9Oeka1G95WnrSphvKyG7h9JpBlnZ2cZgKc7HzQ2BZtj8P1+X1ZD97lSLMwJ/8mFlrOgRPqS1dR5ibw1M/Ojurilun59bp+eYzXPNgJ0x/RJ11/eMjKjhiWXyOfhfplB1dB4ycz8iOzl8vJybPnX3EJ7WUlWlhvI3THLsl5dPTo6Ojg4+BDVyoeWYcr63E2W7tPvgL7m9bW1tf39/VyVXm7bPeeMYlrTt3Svbwf02Vz5b7+yvb19fHwc6pc7glisS/dlYjAY3N7eVjezvhzym83mjx8/Go1GSS2U4RwwMvNeHh4erp6IJ5ubm7nHr7qNdTLk55ONjY3IaspYOOPpvuj0er2Li4vhcFiG+SLMdzqdra2tnZ2dsP/lpDli/OHhYdl/pDzpvli90iJlxPLLy8vr6+vqizlhGf9180ToHtKH+pOb8cpvRVPw/fv3qDOvzPtB93n3SiNNz6CeJxyt/HOSsvxY/4n19fWQfizDqQq9t7eXx+KVdwPdF4K7u7sI6t1uN1d3jQ0jVgNzmc0ZjUbtdjuS+2/fvoX3k2cL57F7YXzeMqSe0/t0X7hMJgJw5OUpZXYux3LuSdfLi9EfjXoS7xBhfnd3N88eK0TgD+NzQQvX6f7BRISO7CVymJXKBtOVianKat0Ye4esHjmME43DzhNV6fPM4fgIh/rS/cOI+B2CRpf0neu6xg52jPeMSB/GR+KeOX28Hs/dn5XuHzYCE/JFBpIKTiWrrmY7WZEinIflkd7k/T8i3g8GAx1Wus91BKZMHuUc0Cy6j1l/4v3Pz88jvWm1WrO7BQjo/ldy8iijbBkyr66hnWIzkjl9bicN1+e/7YPuNUpaxl6pTh5NdhlnIWK1CpV7F4PuM0laqv/MyaPcfvEhi1i4Tvd56BUJdIh+c3NT1uLmgdH8o/snSWOK1tFNzKCe2UvJ0d9zYiPovnBxPR4jTf/zRBl+qZ7KK7rT/VPF+DwHvTpR+nJfFkuN+WrQHaA7QHeA7guGYRbUSPcaHpr1Gmp18sdqfS5qdW8Rxhq9mhRLXXQvCxsNpf9N+jrcXb4uuu/s7JQjuzCZ5jWbzbFTcT5nra6PAbk1aTAY8Hssrofo+/v7k0ck0H3pM3h35Jrk2SP+6P4Zuqqoc+E4wQc1ol6zqup2zYtFdIfoDtAdoDtAd4DuAN0BugN0B+gO0B2gO+gO0B2gO0B3gO4A3QG6A3QH6A7QHaA76A7QHaA7QHeA7gDdAboDdAfoDtAdoDvoDtAdoDtAd4DuAN0BugN0B+gO0B2gO+gO0B2gO0B3gO4A3QG6A3QH6A7QHaA7QHfQHaA7QHeA7gDdAboDdAfoDtAdoDtAd9AdoDtAd4DuAN0BugN0B+gO0B2gO0B30B2gO0B3YPn4nwADAIH6GwYUX3ZzAAAAAElFTkSuQmCC");
// EXTERNAL MODULE: ./src/components/ProductCard/ProductCard.constants.ts
var ProductCard_constants = __webpack_require__(63181);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductBadge.tsx





function ProductBadge({
  text,
  className
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductBadge_Container, {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Inner, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
        children: text
      })
    })
  });
}

const ProductBadge_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductBadge__Container",
  componentId: "sc-zo279f-0"
})(["position:relative;width:fit-content;padding-left:14px;&:before{content:'';position:absolute;left:0;top:0;bottom:0;width:0;height:0;border-style:solid;border-width:11px 14px 11px 0;border-color:transparent ", " transparent transparent;z-index:1;}&:after{content:'';position:absolute;left:1px;top:1px;bottom:0;width:0;height:0;border-style:solid;border-width:10px 13px 10px 0;border-color:transparent ", " transparent transparent;z-index:1;}"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
const Text = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductBadge__Text",
  componentId: "sc-zo279f-1"
})(["color:", ";font-size:13px;line-height:20px;font-weight:500;"], theme/* colors.primary */.O9.primary);
const Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductBadge__Inner",
  componentId: "sc-zo279f-2"
})(["border:1px solid ", ";color:", ";background-color:", ";border-left:0;padding:0 5px 0 3px;white-space:nowrap;font-size:13px;line-height:20px;font-weight:500;position:relative;"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
/* harmony default export */ var components_ProductBadge = (ProductBadge);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ParamsBasis.style.ts


const Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ParamsBasisstyle__Label",
  componentId: "sc-13my3h9-0"
})(["color:", ";font-size:13px;line-height:100%;"], theme/* colors.gray400 */.O9.gray400);
const Value = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ParamsBasisstyle__Value",
  componentId: "sc-13my3h9-1"
})(["font-size:13px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
const MainParam = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ParamsBasisstyle__MainParam",
  componentId: "sc-13my3h9-2"
})(["display:flex;flex:1;margin:10px 0;", "{margin-right:5px;}", "{flex:1;font-size:12px;}"], Label, Value);
const ParamShort = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ParamsBasisstyle__ParamShort",
  componentId: "sc-13my3h9-3"
})(["display:flex;flex-direction:column;width:80px;", "{margin-bottom:5px;}"], Label);
const ParamFull = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ParamsBasisstyle__ParamFull",
  componentId: "sc-13my3h9-4"
})(["display:flex;font-size:13px;line-height:100%;margin-bottom:10px;&:last-child{margin-bottom:0;}", "{width:75px;}", "{white-space:nowrap;}"], Label, Value);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ParamsBasis.tsx






function ParamsBasis({
  param
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [param.label ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
      children: param.label
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Value, {
      children: param.value
    })]
  });
}

/* harmony default export */ var components_ParamsBasis = (ParamsBasis);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ProductCardParamsBasicShort/ProductCardParamsBasicShort.tsx








function ProductCardParamsBasicShort({
  fields,
  brand,
  className
}) {
  const mechanismField = fields.find(field => field.name === 'MEHANIZM-TRANSFORMACII');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Short, {
    className: className,
    children: [brand && /*#__PURE__*/(0,jsx_runtime.jsx)(MainParam, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
        param: {
          label: t('manufacturer'),
          value: brand
        }
      })
    }), mechanismField && /*#__PURE__*/(0,jsx_runtime.jsx)(MainParam, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
        param: mechanismField
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ParamWrapper, {
      children: fields.map((field, index) => {
        var _field$name;

        return !(field === mechanismField) ? /*#__PURE__*/(0,jsx_runtime.jsx)(ParamShort, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
            param: field
          })
        }, (_field$name = field.name) !== null && _field$name !== void 0 ? _field$name : index) : null;
      })
    })]
  });
}

const Short = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardParamsBasicShort__Short",
  componentId: "sc-pgfljc-0"
})(["width:230px;"]);
const ParamWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardParamsBasicShort__ParamWrapper",
  componentId: "sc-pgfljc-1"
})(["display:flex;margin:10px 0 0;"]);
/* harmony default export */ var ProductCardParamsBasicShort_ProductCardParamsBasicShort = (ProductCardParamsBasicShort);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ProductCardParamsBasicShort/index.ts

;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ProductCardParamsBasicFull/ProductCardParamsBasicFull.tsx








function ProductCardParamsBasicFull({
  fields,
  brand,
  className
}) {
  const t = (0,production/* useTranslations */.T_)();
  const fullFields = (0,react.useMemo)(() => {
    const mechanism = [];
    const sizeSleepValue = [];
    const sizeValues = [];
    const result = [];
    const brands = [{
      label: null,
      value: brand !== null && brand !== void 0 ? brand : ''
    }];
    fields.forEach(field => {
      if (field.name === 'DLINA' || field.name === 'GLUBINA' || field.name === 'VYSOTA') {
        sizeValues.push({
          label: field.label,
          value: field.value
        });
      }

      if (field.name === 'DLINA-SPALNOGO-MESTA' || field.name === 'SHIRINA-SPALNOGO-MESTA') {
        sizeSleepValue.push({
          label: field.label,
          value: field.value
        });
      }

      if (field.name === 'MEHANIZM-TRANSFORMACII') {
        mechanism.push({
          label: null,
          value: field.value
        });
      }
    });
    if (!!sizeValues.length) result.push({
      name: t('params.param_3'),
      values: sizeValues
    });
    if (!!sizeSleepValue.length) result.push({
      name: t('params.param_2'),
      values: sizeSleepValue
    });
    if (!!mechanism.length) result.push({
      name: t('params.param_1'),
      values: mechanism
    });
    if (brand) result.push({
      name: t('manufacturer'),
      values: brands
    });
    return result;
  }, [brand, fields]);
  const brandsAndMechanismList = [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Full, {
    className: className,
    children: [fullFields.map(field => {
      if (field.name === t('params.param_3') || field.name === t('manufacturer')) {
        brandsAndMechanismList.unshift(field);
        return null;
      }

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardParamsBasicFull_Title, {
          children: field.name
        }), Array.isArray(field.values) ? field.values.map((value, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(ParamFull, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
            param: value
          })
        }, index)) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParamFull, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
            param: field.values
          })
        }, field.values)]
      }, field.name);
    }), !!brandsAndMechanismList.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerContainer, {
      children: brandsAndMechanismList.map(field => /*#__PURE__*/(0,jsx_runtime.jsxs)(Cell, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardParamsBasicFull_Title, {
          children: field.name
        }), Array.isArray(field.values) ? field.values.map((value, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(ParamFull, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
            param: value
          })
        }, index)) : /*#__PURE__*/(0,jsx_runtime.jsx)(ParamFull, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ParamsBasis, {
            param: field.values
          })
        }, field.values)]
      }, field.name))
    }) : null]
  });
}

const Full = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardParamsBasicFull__Full",
  componentId: "sc-1n23qov-0"
})(["display:flex;max-width:320px;"]);
const Cell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardParamsBasicFull__Cell",
  componentId: "sc-1n23qov-1"
})(["flex:1;margin-right:10px;&:last-child{margin-right:0;}"]);
const InnerContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardParamsBasicFull__InnerContainer",
  componentId: "sc-1n23qov-2"
})(["flex:1;display:flex;flex-direction:column;margin-left:15px;& > div{margin-bottom:15px;}"]);
const ProductCardParamsBasicFull_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardParamsBasicFull__Title",
  componentId: "sc-1n23qov-3"
})(["display:block;font-weight:500;font-size:13px;line-height:100%;margin-bottom:10px;"]);
/* harmony default export */ var ProductCardParamsBasicFull_ProductCardParamsBasicFull = (ProductCardParamsBasicFull);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/components/ProductCardParamsBasicFull/index.ts

;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/ProductCardParams.tsx





function ProductCardParams({
  value,
  brand,
  dataMode,
  className
}) {
  switch (dataMode) {
    case 'SHORT':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardParamsBasicShort_ProductCardParamsBasicShort, {
        brand: brand,
        fields: value,
        className: className
      });

    case 'FULL':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardParamsBasicFull_ProductCardParamsBasicFull, {
        brand: brand,
        fields: value,
        className: className
      });

    default:
      return null;
  }
}

/* harmony default export */ var ProductCardParams_ProductCardParams = (ProductCardParams);
;// CONCATENATED MODULE: ./src/components/ProductCard/components/ProductCardParams/index.ts

;// CONCATENATED MODULE: ./src/components/ProductCard/ProductCardProductCardVertical.tsx


function ProductCardProductCardVertical_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductCardProductCardVertical_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductCardProductCardVertical_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductCardProductCardVertical_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















function ProductCardVertical({
  image,
  name,
  subtitle,
  badge,
  brand,
  price,
  availability,
  discountPrice,
  monthPayment,
  stockStatus,
  fields
}) {
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCardProductCardVertical_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ImageWrapper, {
      children: [image ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture, ProductCardProductCardVertical_objectSpread(ProductCardProductCardVertical_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image)), {}, {
        alt: name,
        useSpinner: true
      })) : /*#__PURE__*/(0,jsx_runtime.jsx)(Picture, {
        src: placeholder
      }), badge ? /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProductBadge, {
          text: badge
        })
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCardProductCardVertical_Title, {
          children: [" ", name, " "]
        }), subtitle ? /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle, {
          children: subtitle
        }) : null]
      }), !!fields.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledProductParams, {
        brand: brand,
        value: fields,
        dataMode: "FULL"
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceWrapper, {
      children: !price || stockStatus === 'NO' ? stockStatus ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductStock, {
        isStock: stockStatus,
        children: (0,common/* getStockLabel */.Vc)(t, stockStatus)
      }) : null : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
          children: [discountPrice !== price && discountPrice ? /*#__PURE__*/(0,jsx_runtime.jsxs)(OldPrice, {
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(Price, {
            children: [(0,common/* normalizePrice */.nQ)(discountPrice !== null && discountPrice !== void 0 ? discountPrice : price), " ", currency]
          })]
        }), stockStatus ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductStock, {
          isStock: stockStatus,
          children: (0,common/* getStockLabel */.Vc)(t, stockStatus)
        }) : null, monthPayment ? /*#__PURE__*/(0,jsx_runtime.jsx)(Credit, {
          children: `${t('rassrochka_from')} ${(0,common/* normalizePrice */.nQ)(monthPayment)} ${currency} / ${t('dimensions.months')}`
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Availability, {
          children: availability && /*#__PURE__*/(0,jsx_runtime.jsx)(AvailabilityLabel, {
            color: availability,
            children: (0,ProductCard_constants/* convertLabel */.T)(t, availability)
          })
        })]
      })
    })]
  });
}

const ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__ImageWrapper",
  componentId: "sc-1infqux-0"
})(["width:300px;display:flex;align-items:center;justify-content:center;position:relative;img{max-height:130px;}", ""], mixin/* media.laptop */.B.laptop((0,styled_components_browser_esm.css)(["width:250px;"])));
const Availability = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__Availability",
  componentId: "sc-1infqux-1"
})(["display:block;margin-top:20px;min-height:18.4px;"]);
const AvailabilityLabel = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__AvailabilityLabel",
  componentId: "sc-1infqux-2"
})(["font-size:14px;font-weight:500;", ""], ({
  color
}) => ProductCard_constants/* variantCssMap */.n[color]);
const BadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__BadgeWrapper",
  componentId: "sc-1infqux-3"
})(["position:absolute;right:0;top:0;"]);
const InfoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__InfoWrapper",
  componentId: "sc-1infqux-4"
})(["display:flex;flex-direction:column;justify-content:center;flex:1;margin-top:20px;"]);
const TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__TitleWrapper",
  componentId: "sc-1infqux-5"
})(["display:flex;flex-direction:column;& > span:last-child{margin-top:10px;}"]);
const ProductCardProductCardVertical_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__Title",
  componentId: "sc-1infqux-6"
})(["font-size:22px;font-weight:500;line-height:24px;overflow:hidden;"]);
const Subtitle = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__Subtitle",
  componentId: "sc-1infqux-7"
})(["font-size:11px;font-weight:500;color:", ";"], theme/* colors.gray300 */.O9.gray300);
const StyledProductParams = (0,styled_components_browser_esm["default"])(ProductCardParams_ProductCardParams).withConfig({
  displayName: "ProductCardProductCardVertical__StyledProductParams",
  componentId: "sc-1infqux-8"
})(["margin-top:20px;"]);
const PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__PriceWrapper",
  componentId: "sc-1infqux-9"
})(["display:flex;flex-direction:column;justify-content:center;white-space:nowrap;min-width:225px;"]);
const Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__Wrapper",
  componentId: "sc-1infqux-10"
})(["display:flex;flex-direction:column;& > span:last-child{margin-top:10px;}"]);
const OldPrice = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__OldPrice",
  componentId: "sc-1infqux-11"
})(["color:", ";font-weight:500;text-decoration:line-through;margin-right:10px;"], theme/* colors.gray500 */.O9.gray500);
const Price = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__Price",
  componentId: "sc-1infqux-12"
})(["font-size:26px;line-height:100%;font-weight:600;"]);
const ProductStock = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__ProductStock",
  componentId: "sc-1infqux-13"
})(["font-size:13px;color:", ";font-weight:500;margin-top:15px;"], props => props.isStock === 'SHOP' || props.isStock === 'IN_SHOP' ? theme/* colors.primary */.O9.primary : props.isStock === 'STOCK' ? theme/* colors.green */.O9.green : theme/* colors.black */.O9.black);
const Credit = styled_components_browser_esm["default"].span.withConfig({
  displayName: "ProductCardProductCardVertical__Credit",
  componentId: "sc-1infqux-14"
})(["font-size:13px;font-weight:500;color:", ";line-height:35px;border:1px solid ", ";border-radius:5px;text-align:center;padding:0 10px;margin-top:15px;"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary);
const ProductCardProductCardVertical_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCardProductCardVertical__Container",
  componentId: "sc-1infqux-15"
})(["width:100%;min-height:170px;display:flex;flex-direction:column;background:", ";border:1px solid ", ";transition:0.3s;padding:15px;&:hover{box-shadow:0 0 20px rgba(0,0,0,0.06);}&:hover ", "{color:", ";}"], theme/* colors.white */.O9.white, theme/* colors.gray100 */.O9.gray100, ProductCardProductCardVertical_Title, theme/* colors.primary */.O9.primary);
/* harmony default export */ var ProductCardProductCardVertical = (ProductCardVertical);
// EXTERNAL MODULE: ./src/components/Button/index.ts
var Button = __webpack_require__(91533);
;// CONCATENATED MODULE: ./src/components/Search/components/SearchModal/components/SearchModalResultCatalog.tsx


function SearchModalResultCatalog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SearchModalResultCatalog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SearchModalResultCatalog_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SearchModalResultCatalog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















function SearchModalResultCatalog() {
  const t = (0,production/* useTranslations */.T_)();
  const categories = (0,store/* useTypedSelector */.ix)(state => (0,pages_search/* selectFindCategoryListResource */.lX)(state, 'searchInput'));
  const products = (0,store/* useTypedSelector */.ix)(state => (0,pages_search/* selectFindProductListResource */.BX)(state, 'searchInput'));
  const searchQuery = (0,store/* useTypedSelector */.ix)(pages_search/* selectQuery */.xM);

  if (!categories.data.length && categories.status === web_core_esm.FETCH_STATUSES.SUCCESS && !products.data.length && products.status === web_core_esm.FETCH_STATUSES.SUCCESS) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchTitle, {
      title: t('search.not_found_query')
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchModalResultCatalog_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ResultWrapper, {
      children: categories.data.map(category => /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CategoryLink, {
          to: `/catalog${category.urlPath}`,
          children: [category.name, category.productsCount ? /*#__PURE__*/(0,jsx_runtime.jsx)(Count, {
            children: `${category.productsCount} ${(0,common/* getProductsOrPostsOrCategoriesWord */.rL)(t, category.productsCount, 'Products')}`
          }) : null]
        })
      }, category.id))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ResultWrapper, {
      children: products.status === web_core_esm.FETCH_STATUSES.LOADING ? (0,web_core_esm.generateNumberArray)(1).map(num => /*#__PURE__*/(0,jsx_runtime.jsx)(ProductWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlaceholderCard_PlaceholderCard, {
          height: 170
        })
      }, num)) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [products.data.slice(0, 5).map(product => /*#__PURE__*/(0,jsx_runtime.jsx)(ProductWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkContainer, {
            to: `/products/${product.urlAlias}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardProductCardVertical, SearchModalResultCatalog_objectSpread({}, product))
          })
        }, product.id)), products.data.length > 5 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: `/search?query=${searchQuery}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.C, {
            variant: "outlined-primary-w100",
            children: t('search.show_more')
          })
        }) : null]
      })
    })]
  });
}

/* harmony default export */ var components_SearchModalResultCatalog = (SearchModalResultCatalog);
const SearchModalResultCatalog_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchModalResultCatalog__Container",
  componentId: "sc-ibrhzw-0"
})(["display:flex;flex-direction:column;"]);
const ResultWrapper = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "SearchModalResultCatalog__ResultWrapper",
  componentId: "sc-ibrhzw-1"
})([""]);
const CategoryWrapper = styled_components_browser_esm["default"].li.withConfig({
  displayName: "SearchModalResultCatalog__CategoryWrapper",
  componentId: "sc-ibrhzw-2"
})(["display:flex;margin-bottom:15px;"]);
const CategoryLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).withConfig({
  displayName: "SearchModalResultCatalog__CategoryLink",
  componentId: "sc-ibrhzw-3"
})(["display:inline-block;font-size:14px;font-weight:600;&:hover{color:", ";}"], theme/* colors.primary */.O9.primary);
const Count = styled_components_browser_esm["default"].span.withConfig({
  displayName: "SearchModalResultCatalog__Count",
  componentId: "sc-ibrhzw-4"
})(["font-size:14px;font-weight:500;color:#9b9b9b;margin-left:10px;"]);
const ProductWrapper = styled_components_browser_esm["default"].li.withConfig({
  displayName: "SearchModalResultCatalog__ProductWrapper",
  componentId: "sc-ibrhzw-5"
})(["margin-bottom:10px;&:last-child{margin-bottom:0;}"]);
const LinkContainer = (0,styled_components_browser_esm["default"])(Link/* default */.Z).withConfig({
  displayName: "SearchModalResultCatalog__LinkContainer",
  componentId: "sc-ibrhzw-6"
})(["width:100%;"]);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var components_Picture = __webpack_require__(97377);
;// CONCATENATED MODULE: ./src/components/PostCard/components/PostCardSmall.tsx


const PostCardSmall_excluded = ["coverImage", "categoryHidden"];

function PostCardSmall_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PostCardSmall_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PostCardSmall_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PostCardSmall_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function PostCardSmall(_ref) {
  var _convertThumbnailToPi, _post$category;

  let {
    coverImage,
    categoryHidden
  } = _ref,
      post = (0,objectWithoutProperties/* default */.Z)(_ref, PostCardSmall_excluded);

  const pictureProps = (0,web_core_esm.isStringGuard)(coverImage) ? {
    src: coverImage
  } : (_convertThumbnailToPi = (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(coverImage)) !== null && _convertThumbnailToPi !== void 0 ? _convertThumbnailToPi : {
    src: ''
  };
  const category = categoryHidden ? null : (_post$category = post.category) === null || _post$category === void 0 ? void 0 : _post$category.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSmall_StyledLink, {
    to: `/blog/${post === null || post === void 0 ? void 0 : post.urlAlias}`,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PostCardSmall_Content, {
      children: [coverImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(PostCover, PostCardSmall_objectSpread(PostCardSmall_objectSpread({}, pictureProps), {}, {
        loading: "lazy",
        useSpinner: true
      })) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostCover, {
        src: placeholder,
        loading: "lazy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSmall_Title, {
        children: post.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSmall_Text, {
        children: post.excerpt
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
        children: category
      })]
    })
  });
}

const PostCardSmall_StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z).withConfig({
  displayName: "PostCardSmall__StyledLink",
  componentId: "sc-ptldby-0"
})(["width:100%;"]);
const PostCover = (0,styled_components_browser_esm["default"])(components_Picture/* default */.Z).withConfig({
  displayName: "PostCardSmall__PostCover",
  componentId: "sc-ptldby-1"
})(["display:inline-block;overflow:hidden;width:100%;img{object-fit:cover;width:100%;transition:all 0.45s ease-in-out 0s;height:200px;}"]);
const PostCardSmall_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PostCardSmall__Title",
  componentId: "sc-ptldby-2"
})(["padding:20px 15px 10px;font-size:21px;line-height:28px;font-weight:500;display:block;text-align:left;"]);
const PostCardSmall_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostCardSmall__Content",
  componentId: "sc-ptldby-3"
})(["display:block;background:", ";height:100%;padding-bottom:35px;position:relative;transition:0.3s;color:", ";border:1px solid ", ";&:hover{box-shadow:0 0 20px rgba(0,0,0,0.06);}&:hover ", "{img{transform:scale(1.1);}}&:hover ", "{color:", ";}"], theme/* colors.white */.O9.white, theme/* colors.black */.O9.black, theme/* colors.gray100 */.O9.gray100, PostCover, PostCardSmall_Title, theme/* colors.primary */.O9.primary);
const PostCardSmall_Text = styled_components_browser_esm["default"].p.withConfig({
  displayName: "PostCardSmall__Text",
  componentId: "sc-ptldby-4"
})(["padding:0 20px;font-size:13px;line-height:22px;display:-webkit-box;height:44px;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
const Category = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PostCardSmall__Category",
  componentId: "sc-ptldby-5"
})(["position:absolute;right:0;bottom:0;background:", ";color:", ";line-height:30px;padding:0 20px;font-size:13px;&:hover{background:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white, theme/* colors.primary100 */.O9.primary100);
/* harmony default export */ var components_PostCardSmall = (PostCardSmall);
;// CONCATENATED MODULE: ./src/components/PostCard/components/PostCardBig.tsx


const PostCardBig_excluded = ["coverImage", "categoryHidden"];

function PostCardBig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PostCardBig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PostCardBig_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PostCardBig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function PostCardBig(_ref) {
  var _convertThumbnailToPi, _post$category;

  let {
    coverImage,
    categoryHidden
  } = _ref,
      post = (0,objectWithoutProperties/* default */.Z)(_ref, PostCardBig_excluded);

  const pictureProps = (0,web_core_esm.isStringGuard)(coverImage) ? {
    src: coverImage
  } : (_convertThumbnailToPi = (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(coverImage)) !== null && _convertThumbnailToPi !== void 0 ? _convertThumbnailToPi : {
    src: ''
  };
  const category = categoryHidden ? null : (_post$category = post.category) === null || _post$category === void 0 ? void 0 : _post$category.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
    to: `/blog/${post === null || post === void 0 ? void 0 : post.urlAlias}`,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PostCardBig_Content, {
      children: [coverImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardBig_PostCover, PostCardBig_objectSpread(PostCardBig_objectSpread({}, pictureProps), {}, {
        loading: "lazy",
        useSpinner: true
      })) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardBig_PostCover, {
        src: placeholder
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardBig_Title, {
        children: post.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardBig_Text, {
        children: post.excerpt
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardBig_Category, {
        children: category
      })]
    })
  });
}

const PostCardBig_PostCover = (0,styled_components_browser_esm["default"])(components_Picture/* default */.Z).withConfig({
  displayName: "PostCardBig__PostCover",
  componentId: "sc-ymffmx-0"
})(["display:block;position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;background:-webkit-linear-gradient(rgba(0,0,0,0.3),rgb(0,0,0,1) 70%);img{object-fit:cover;width:100%;height:100%;opacity:60%;}"]);
const PostCardBig_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PostCardBig__Title",
  componentId: "sc-ymffmx-1"
})(["font-size:22px;line-height:28px;color:", ";font-weight:500;display:block;margin-bottom:15px;z-index:100;"], theme/* colors.white */.O9.white);
const PostCardBig_Text = styled_components_browser_esm["default"].p.withConfig({
  displayName: "PostCardBig__Text",
  componentId: "sc-ymffmx-2"
})(["font-size:13px;line-height:22px;display:block;color:", ";z-index:100;"], theme/* colors.white */.O9.white);
const PostCardBig_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostCardBig__Content",
  componentId: "sc-ymffmx-3"
})(["height:300px;display:flex;flex-direction:column;justify-content:flex-end;position:relative;padding:30px 40px;transition:0.3s;&:hover{box-shadow:0 0 15px rgba(0,0,0,0.2);opacity:0.85;}&:hover ", ",&:hover ", "{color:rgba(255,255,255,0.85);}"], PostCardBig_Title, PostCardBig_Text);
const PostCardBig_Category = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PostCardBig__Category",
  componentId: "sc-ymffmx-4"
})(["position:absolute;right:0;bottom:0;background:", ";color:", ";line-height:30px;padding:0 20px;font-size:13px;&:hover{background:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white, theme/* colors.primary100 */.O9.primary100);
/* harmony default export */ var components_PostCardBig = (PostCardBig);
;// CONCATENATED MODULE: ./src/components/PostCard/components/PostCardSearch.tsx


const PostCardSearch_excluded = ["coverImage"];

function PostCardSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PostCardSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PostCardSearch_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PostCardSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function PostCardSearch(_ref) {
  var _convertThumbnailToPi;

  let {
    coverImage
  } = _ref,
      post = (0,objectWithoutProperties/* default */.Z)(_ref, PostCardSearch_excluded);

  const pictureProps = (0,web_core_esm.isStringGuard)(coverImage) ? {
    src: coverImage
  } : (_convertThumbnailToPi = (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(coverImage)) !== null && _convertThumbnailToPi !== void 0 ? _convertThumbnailToPi : {
    src: ''
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
    to: `/blog/${post === null || post === void 0 ? void 0 : post.urlAlias}`,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PostCardSearch_Content, {
      children: [coverImage ? /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_PostCover, PostCardSearch_objectSpread({}, pictureProps))
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_PostCover, {
          src: placeholder
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_Title, {
          children: post.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PostCardSearch_Text, {
          children: post.excerpt
        })]
      })]
    })
  });
}

const PostCardSearch_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostCardSearch__ImageWrapper",
  componentId: "sc-19b78i0-0"
})(["height:140px;margin-bottom:15px;@media (min-width:", "px){height:200px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const PostCardSearch_PostCover = (0,styled_components_browser_esm["default"])(components_Picture/* PlainPicture */.J).withConfig({
  displayName: "PostCardSearch__PostCover",
  componentId: "sc-19b78i0-1"
})(["img{width:100%;height:100%;object-fit:cover;}"]);
const PostCardSearch_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "PostCardSearch__Title",
  componentId: "sc-19b78i0-2"
})(["font-size:16px;line-height:20px;font-weight:500;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
const PostCardSearch_Text = styled_components_browser_esm["default"].p.withConfig({
  displayName: "PostCardSearch__Text",
  componentId: "sc-19b78i0-3"
})(["display:block;margin-top:10px;font-size:13px;line-height:20px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
const PostCardSearch_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostCardSearch__Content",
  componentId: "sc-19b78i0-4"
})(["display:flex;flex-direction:column;background:", ";height:100%;padding:14px;position:relative;transition:0.3s;color:", ";border:1px solid ", ";&:hover{box-shadow:0 0 20px rgba(0,0,0,0.06);}&:hover ", "{color:", ";}"], theme/* colors.white */.O9.white, theme/* colors.black */.O9.black, theme/* colors.gray100 */.O9.gray100, PostCardSearch_Title, theme/* colors.primary */.O9.primary);
/* harmony default export */ var components_PostCardSearch = (PostCardSearch);
;// CONCATENATED MODULE: ./src/components/PostCard/PostCard.tsx


function PostCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PostCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PostCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PostCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getContentHeight(variant) {
  switch (variant) {
    case 'big':
      return 300;

    case 'small':
      return 343;

    case 'search':
      return 170;

    default:
      return 0;
  }
}

function PostCard({
  post,
  variant,
  loading = false,
  categoryHidden
}) {
  var _post$image, _post$image2, _post$image3;

  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PlaceholderCard_PlaceholderCard, {
      height: getContentHeight(variant)
    });
  }

  switch (variant) {
    case 'big':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_PostCardBig, PostCard_objectSpread(PostCard_objectSpread({}, post), {}, {
        coverImage: (_post$image = post.image) === null || _post$image === void 0 ? void 0 : _post$image.coverBig,
        categoryHidden: categoryHidden
      }));

    case 'small':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_PostCardSmall, PostCard_objectSpread(PostCard_objectSpread({}, post), {}, {
        coverImage: (_post$image2 = post.image) === null || _post$image2 === void 0 ? void 0 : _post$image2.cover,
        categoryHidden: categoryHidden
      }));

    case 'search':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_PostCardSearch, PostCard_objectSpread(PostCard_objectSpread({}, post), {}, {
        coverImage: (_post$image3 = post.image) === null || _post$image3 === void 0 ? void 0 : _post$image3.cover
      }));

    default:
      return null;
  }
}

/* harmony default export */ var PostCard_PostCard = (PostCard);
;// CONCATENATED MODULE: ./src/components/PostCard/index.ts

;// CONCATENATED MODULE: ./src/components/Search/components/SearchModal/components/SearchModalResultBlog.tsx


function SearchModalResultBlog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SearchModalResultBlog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SearchModalResultBlog_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SearchModalResultBlog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function SearchModalResultBlog() {
  const posts = (0,store/* useTypedSelector */.ix)(state => (0,pages_search/* selectFindPostListResource */.w_)(state, 'searchInput'));
  const t = (0,production/* useTranslations */.T_)();

  if (!posts.data.length && posts.status === web_core_esm.FETCH_STATUSES.SUCCESS) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchTitle, {
      title: t('search.not_found_query')
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchModalResultBlog_Component, {
    children: posts.status === web_core_esm.FETCH_STATUSES.LOADING ? [1].map(num => /*#__PURE__*/(0,jsx_runtime.jsx)(PostWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlaceholderCard_PlaceholderCard, {
        height: 170
      })
    }, num)) : posts.data.map(post => /*#__PURE__*/(0,jsx_runtime.jsx)(PostWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostCard_PostCard, {
        variant: "search",
        post: SearchModalResultBlog_objectSpread({
          name: post.title,
          image: post.coverImage,
          category: post.categories[0]
        }, post)
      })
    }, post.id))
  });
}

const SearchModalResultBlog_Component = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "SearchModalResultBlog__Component",
  componentId: "sc-1vw4008-0"
})(["display:flex;flex-direction:column;margin-top:15px;"]);
const PostWrapper = styled_components_browser_esm["default"].li.withConfig({
  displayName: "SearchModalResultBlog__PostWrapper",
  componentId: "sc-1vw4008-1"
})(["margin-bottom:10px;&:last-child{margin-bottom:0;}"]);
/* harmony default export */ var components_SearchModalResultBlog = (SearchModalResultBlog);
// EXTERNAL MODULE: ./src/hooks/useBodyPositionFixed.tsx
var useBodyPositionFixed = __webpack_require__(35535);
;// CONCATENATED MODULE: ./src/components/Search/components/SearchModal/SearchModal.tsx


















function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}

function SearchModal({
  closeModal
}) {
  const {
    0: isActiveTab,
    1: setActiveTabs
  } = (0,react.useState)('CATALOG');
  const t = (0,production/* useTranslations */.T_)();
  const tabs = [{
    name: t('search.in_catalog'),
    value: 'CATALOG'
  }, {
    name: t('search.in_blog'),
    value: 'BLOG'
  }];
  const dispatch = (0,es/* useDispatch */.I0)();
  const searchQuery = (0,es/* useSelector */.v9)(pages_search/* selectQuery */.xM);
  const debouncedSearchQuery = (0,web_core_esm.useDebounce)(searchQuery, 300);
  const router = (0,next_router.useRouter)();
  const prevPath = usePrevious(router.asPath);
  const {
    closeModalState,
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  (0,web_core_esm.useUpdateEffect)(() => {
    dispatch((0,pages_search/* getSearchProductListThunk */.GS)(debouncedSearchQuery, 'searchInput'));
    dispatch((0,pages_search/* getSearchPostListThunk */.Ko)(debouncedSearchQuery, 'searchInput'));
    dispatch((0,pages_search/* getSearchCategoryListThunk */.K0)(debouncedSearchQuery, 'searchInput'));
  }, [debouncedSearchQuery, dispatch]);
  const ref = (0,react.useRef)(null);
  const inputRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (prevPath && prevPath !== router.asPath) {
      closeModal();
    }
  }, [router.asPath, prevPath, closeModal]);
  (0,react.useEffect)(() => {
    openModalState();
    return () => closeModalState();
  }, [closeModalState, openModalState]);

  const openPage = () => {
    if (!searchQuery.trim().length) {
      return;
    }

    router.push(`/search?query=${searchQuery}`);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchModal_Component, {
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Search, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput_SearchInput, {
          ref: inputRef,
          variant: "default",
          placeholder: t('search.placeholder'),
          value: searchQuery,
          onChange: e => {
            dispatch((0,pages_search/* queryAdded */.Wx)(e.target.value));
          },
          onKeyDown: event => event.keyCode === 13 && !!searchQuery.trim().length ? (router.push(`/search?query=${searchQuery}`), dispatch((0,pages_search/* queryAdded */.Wx)(''))) : null,
          onClickButton: openPage
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close, {
          onClick: () => {
            closeModal();

            if (debouncedSearchQuery) {
              dispatch((0,pages_search/* queryAdded */.Wx)(''));
            }
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabsBlock, {
        variant: "small",
        tabs: tabs,
        activeTab: isActiveTab,
        setActiveTab: setActiveTabs
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Result, {
      children: !searchQuery ? /*#__PURE__*/(0,jsx_runtime.jsx)(SearchTitle, {
        title: t('search.input')
      }) : isActiveTab === 'CATALOG' ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_SearchModalResultCatalog, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_SearchModalResultBlog, {})
    })]
  });
}

/* harmony default export */ var SearchModal_SearchModal = (SearchModal);
const SearchModal_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchModal__Component",
  componentId: "sc-18riwbw-0"
})(["z-index:20;height:min(calc(var(--vh,1) * 100),100vh);min-width:min(100vw,1260px);overflow:auto !important;background:#fff;padding-bottom:10px;"]);
const Search = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchModal__Search",
  componentId: "sc-18riwbw-1"
})(["padding:15px;display:flex;align-items:center;& > div:first-child{flex:1;}"]);
const Close = (0,styled_components_browser_esm["default"])(Modals_close/* ReactComponent */.r).withConfig({
  displayName: "SearchModal__Close",
  componentId: "sc-18riwbw-2"
})(["cursor:pointer;margin-left:10px;"]);
const Result = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchModal__Result",
  componentId: "sc-18riwbw-3"
})(["margin-top:125px;padding:0 15px;"]);
const StyledTabsBlock = (0,styled_components_browser_esm["default"])(TabsBlock_TabsBlock).withConfig({
  displayName: "SearchModal__StyledTabsBlock",
  componentId: "sc-18riwbw-4"
})(["padding:0 20px;"]);
const Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SearchModal__Header",
  componentId: "sc-18riwbw-5"
})(["position:fixed;left:0;right:0;z-index:1;background-color:#fff;"]);
;// CONCATENATED MODULE: ./src/components/Search/components/SearchModal/index.ts

;// CONCATENATED MODULE: ./src/components/Search/Search.tsx
















function Search_Search() {
  const dispatch = (0,es/* useDispatch */.I0)();
  const searchQuery = (0,es/* useSelector */.v9)(pages_search/* selectQuery */.xM);
  const {
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  const router = (0,next_router.useRouter)();
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const {
    triggerLogo
  } = (0,react.useContext)(LogoContext);

  const OpenSearchModal = () => {
    openModalState();
    triggerLogo === null || triggerLogo === void 0 ? void 0 : triggerLogo(true);
    openModal(SearchModal_SearchModal, {}, {
      withAnimation: false,
      scrollLockDisabled: true
    });
  };

  const openModalOrPage = !!searchQuery.trim().length ? () => router.push(`/search?query=${searchQuery}`) : OpenSearchModal;
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Search_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledSearchInput, {
      variant: "default",
      placeholder: t('search.placeholder'),
      value: searchQuery,
      onChange: e => {
        dispatch((0,pages_search/* queryAdded */.Wx)(e.target.value));
        OpenSearchModal();
      },
      onKeyDown: event => event.keyCode === 13 && !!searchQuery.trim().length ? (router.push(`/search?query=${searchQuery}`), dispatch((0,pages_search/* queryAdded */.Wx)(''))) : OpenSearchModal,
      onClickButton: openModalOrPage
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSearchIcon, {
      onClick: OpenSearchModal
    })]
  });
}

const StyledSearchInput = (0,styled_components_browser_esm["default"])(SearchInput_SearchInput).withConfig({
  displayName: "Search__StyledSearchInput",
  componentId: "sc-bclmpp-0"
})(["width:100%;display:none;@media (min-width:", "px){display:block;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Search_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Search__Component",
  componentId: "sc-bclmpp-1"
})(["cursor:pointer;margin-right:10px;display:flex;align-items:center;"]);
const StyledSearchIcon = (0,styled_components_browser_esm["default"])(SvgSearch).withConfig({
  displayName: "Search__StyledSearchIcon",
  componentId: "sc-bclmpp-2"
})(["display:block;@media (min-width:", "px){display:none;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
/* harmony default export */ var components_Search_Search = (Search_Search);
;// CONCATENATED MODULE: ./src/components/Search/index.ts

;// CONCATENATED MODULE: ./src/providers/LogoTriggerProvider/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/Header/CatalogBtn.sofa/CatalogBtn.sofa_menu.svg
function CatalogBtn_sofa_menu_extends() { CatalogBtn_sofa_menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CatalogBtn_sofa_menu_extends.apply(this, arguments); }



var CatalogBtn_sofa_menu_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 4.2434C14.4 4.2434 14 4.64804 14 5.255V8.28978H2V5.255C2 4.64804 1.6 4.2434 1 4.2434C0.4 4.2434 0 4.64804 0 5.255V9.30138C0 9.90834 0.4 10.313 1 10.313H2V11.3246C2 11.9315 2.4 12.3362 3 12.3362C3.6 12.3362 4 11.9315 4 11.3246V10.313H12V11.3246C12 11.9315 12.4 12.3362 13 12.3362C13.6 12.3362 14 11.9315 14 11.3246V10.313H15C15.6 10.313 16 9.90834 16 9.30138V5.255C16 4.64804 15.6 4.2434 15 4.2434ZM13 1.20862C13 0.60166 12.6 0.197021 12 0.197021H4C3.4 0.197021 3 0.60166 3 1.20862V7.27819H13V1.20862Z",
  fill: "#BCBCBC"
});

function SvgCatalogBtnsofaMenu({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", CatalogBtn_sofa_menu_extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, CatalogBtn_sofa_menu_ref);
}

/* harmony default export */ var CatalogBtn_sofa_menu = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSA0LjI0MzRDMTQuNCA0LjI0MzQgMTQgNC42NDgwNCAxNCA1LjI1NVY4LjI4OTc4SDJWNS4yNTVDMiA0LjY0ODA0IDEuNiA0LjI0MzQgMSA0LjI0MzRDMC40IDQuMjQzNCAwIDQuNjQ4MDQgMCA1LjI1NVY5LjMwMTM4QzAgOS45MDgzNCAwLjQgMTAuMzEzIDEgMTAuMzEzSDJWMTEuMzI0NkMyIDExLjkzMTUgMi40IDEyLjMzNjIgMyAxMi4zMzYyQzMuNiAxMi4zMzYyIDQgMTEuOTMxNSA0IDExLjMyNDZWMTAuMzEzSDEyVjExLjMyNDZDMTIgMTEuOTMxNSAxMi40IDEyLjMzNjIgMTMgMTIuMzM2MkMxMy42IDEyLjMzNjIgMTQgMTEuOTMxNSAxNCAxMS4zMjQ2VjEwLjMxM0gxNUMxNS42IDEwLjMxMyAxNiA5LjkwODM0IDE2IDkuMzAxMzhWNS4yNTVDMTYgNC42NDgwNCAxNS42IDQuMjQzNCAxNSA0LjI0MzRaTTEzIDEuMjA4NjJDMTMgMC42MDE2NiAxMi42IDAuMTk3MDIxIDEyIDAuMTk3MDIxSDRDMy40IDAuMTk3MDIxIDMgMC42MDE2NiAzIDEuMjA4NjJWNy4yNzgxOUgxM1YxLjIwODYyWiIgZmlsbD0iI0JDQkNCQyIvPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/Menu/arrowForward.svg
function arrowForward_extends() { arrowForward_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowForward_extends.apply(this, arguments); }



var arrowForward_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.3 0.313818C-0.1 0.713818 -0.1 1.31382 0.3 1.71382L3.5 4.91382L0.3 8.21382C-0.1 8.61382 -0.1 9.21382 0.3 9.61382C0.5 9.81382 0.7 9.91382 1 9.91382C1.2 9.91382 1.5 9.81382 1.7 9.61382L5.6 5.61382C6 5.21382 6 4.61382 5.6 4.21382L1.7 0.213819C1.3 -0.0861816 0.7 -0.0861816 0.3 0.313818Z",
  fill: "#9F9F9F"
});

function SvgArrowForward({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", arrowForward_extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrowForward_ref);
}

/* harmony default export */ var arrowForward = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4zIDAuMzEzODE4Qy0wLjEgMC43MTM4MTggLTAuMSAxLjMxMzgyIDAuMyAxLjcxMzgyTDMuNSA0LjkxMzgyTDAuMyA4LjIxMzgyQy0wLjEgOC42MTM4MiAtMC4xIDkuMjEzODIgMC4zIDkuNjEzODJDMC41IDkuODEzODIgMC43IDkuOTEzODIgMSA5LjkxMzgyQzEuMiA5LjkxMzgyIDEuNSA5LjgxMzgyIDEuNyA5LjYxMzgyTDUuNiA1LjYxMzgyQzYgNS4yMTM4MiA2IDQuNjEzODIgNS42IDQuMjEzODJMMS43IDAuMjEzODE5QzEuMyAtMC4wODYxODE2IDAuNyAtMC4wODYxODE2IDAuMyAwLjMxMzgxOFoiIGZpbGw9IiM5RjlGOUYiLz4KPC9zdmc+Cg==");

// EXTERNAL MODULE: ./src/store/reducers/tager/menus.ts
var menus = __webpack_require__(67463);
;// CONCATENATED MODULE: ./src/hooks/useCatalogCategories.ts


function useCatalogMenuResource() {
  return (0,store/* useTypedSelector */.ix)(state => (0,menus/* selectCatalogMenuResource */.CR)(state));
}
;// CONCATENATED MODULE: ./src/assets/svg/Menu/closeCatalog.svg
function closeCatalog_extends() { closeCatalog_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return closeCatalog_extends.apply(this, arguments); }



var closeCatalog_ref = /*#__PURE__*/react.createElement("path", {
  d: "M6.66667 8.85565L0.266667 2.36676C0.0888889 2.18899 0 2.01121 0 1.74454C0 1.47787 0.0888889 1.3001 0.266667 1.12232C0.444444 0.944541 0.8 0.855652 1.06667 0.855652C1.33333 0.855652 1.6 0.944541 1.77778 1.12232L8 7.43343L14.2222 1.12232C14.4 0.944541 14.6667 0.855652 14.9333 0.855652C15.2 0.855652 15.4667 0.944541 15.6444 1.12232C15.8222 1.3001 16 1.47787 16 1.74454C16 2.01121 15.9111 2.18899 15.7333 2.36676L9.33333 8.85565L15.8222 15.4334C15.9111 15.6112 16 15.789 16 15.9668C16 16.2334 15.9111 16.4112 15.7333 16.589C15.5556 16.7668 15.2889 16.8557 14.9333 16.8557C14.5778 16.8557 14.4 16.7668 14.2222 16.589L8 10.189L1.77778 16.589C1.6 16.7668 1.33333 16.8557 1.06667 16.8557C0.8 16.8557 0.533333 16.7668 0.355556 16.589C0.177778 16.4112 0 16.2334 0 15.9668C0 15.789 0.0888889 15.6112 0.177778 15.4334L6.66667 8.85565Z",
  fill: "#860935"
});

function SvgCloseCatalog({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", closeCatalog_extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, closeCatalog_ref);
}

/* harmony default export */ var closeCatalog = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjY2NjcgOC44NTU2NUwwLjI2NjY2NyAyLjM2Njc2QzAuMDg4ODg4OSAyLjE4ODk5IDAgMi4wMTEyMSAwIDEuNzQ0NTRDMCAxLjQ3Nzg3IDAuMDg4ODg4OSAxLjMwMDEgMC4yNjY2NjcgMS4xMjIzMkMwLjQ0NDQ0NCAwLjk0NDU0MSAwLjggMC44NTU2NTIgMS4wNjY2NyAwLjg1NTY1MkMxLjMzMzMzIDAuODU1NjUyIDEuNiAwLjk0NDU0MSAxLjc3Nzc4IDEuMTIyMzJMOCA3LjQzMzQzTDE0LjIyMjIgMS4xMjIzMkMxNC40IDAuOTQ0NTQxIDE0LjY2NjcgMC44NTU2NTIgMTQuOTMzMyAwLjg1NTY1MkMxNS4yIDAuODU1NjUyIDE1LjQ2NjcgMC45NDQ1NDEgMTUuNjQ0NCAxLjEyMjMyQzE1LjgyMjIgMS4zMDAxIDE2IDEuNDc3ODcgMTYgMS43NDQ1NEMxNiAyLjAxMTIxIDE1LjkxMTEgMi4xODg5OSAxNS43MzMzIDIuMzY2NzZMOS4zMzMzMyA4Ljg1NTY1TDE1LjgyMjIgMTUuNDMzNEMxNS45MTExIDE1LjYxMTIgMTYgMTUuNzg5IDE2IDE1Ljk2NjhDMTYgMTYuMjMzNCAxNS45MTExIDE2LjQxMTIgMTUuNzMzMyAxNi41ODlDMTUuNTU1NiAxNi43NjY4IDE1LjI4ODkgMTYuODU1NyAxNC45MzMzIDE2Ljg1NTdDMTQuNTc3OCAxNi44NTU3IDE0LjQgMTYuNzY2OCAxNC4yMjIyIDE2LjU4OUw4IDEwLjE4OUwxLjc3Nzc4IDE2LjU4OUMxLjYgMTYuNzY2OCAxLjMzMzMzIDE2Ljg1NTcgMS4wNjY2NyAxNi44NTU3QzAuOCAxNi44NTU3IDAuNTMzMzMzIDE2Ljc2NjggMC4zNTU1NTYgMTYuNTg5QzAuMTc3Nzc4IDE2LjQxMTIgMCAxNi4yMzM0IDAgMTUuOTY2OEMwIDE1Ljc4OSAwLjA4ODg4ODkgMTUuNjExMiAwLjE3Nzc3OCAxNS40MzM0TDYuNjY2NjcgOC44NTU2NVoiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/Menu/arrowBack.svg
function arrowBack_extends() { arrowBack_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowBack_extends.apply(this, arguments); }



var arrowBack_ref = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#clip0_1_1746)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 3.14429H3.4L4.7 1.84429C5.1 1.44429 5.1 0.844287 4.7 0.444287C4.3 0.0442871 3.7 0.0442871 3.3 0.444287L0.3 3.44429C0.2 3.44429 0.1 3.54429 0.1 3.74429V3.84429C0.1 3.94429 0.1 4.04429 0.1 4.04429C0 4.04429 0 4.14429 0 4.14429C0 4.24429 0 4.34429 0.1 4.44429C0.1 4.54429 0.2 4.64429 0.3 4.74429L3.3 7.74429C3.5 7.94429 3.7 8.04429 4 8.04429C4.3 8.04429 4.5 7.94429 4.7 7.74429C5.1 7.34429 5.1 6.74429 4.7 6.34429L3.4 5.14429H15C15.6 5.14429 16 4.74429 16 4.14429C16 3.54429 15.6 3.14429 15 3.14429Z",
  fill: "#860935"
}));

var _ref2 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "clip0_1_1746"
}, /*#__PURE__*/react.createElement("rect", {
  width: 16,
  height: 7.9,
  fill: "white",
  transform: "translate(0 0.144287)"
})));

function SvgArrowBack({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", arrowBack_extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrowBack_ref, _ref2);
}

/* harmony default export */ var arrowBack = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xXzE3NDYpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAzLjE0NDI5SDMuNEw0LjcgMS44NDQyOUM1LjEgMS40NDQyOSA1LjEgMC44NDQyODcgNC43IDAuNDQ0Mjg3QzQuMyAwLjA0NDI4NzEgMy43IDAuMDQ0Mjg3MSAzLjMgMC40NDQyODdMMC4zIDMuNDQ0MjlDMC4yIDMuNDQ0MjkgMC4xIDMuNTQ0MjkgMC4xIDMuNzQ0MjlWMy44NDQyOUMwLjEgMy45NDQyOSAwLjEgNC4wNDQyOSAwLjEgNC4wNDQyOUMwIDQuMDQ0MjkgMCA0LjE0NDI5IDAgNC4xNDQyOUMwIDQuMjQ0MjkgMCA0LjM0NDI5IDAuMSA0LjQ0NDI5QzAuMSA0LjU0NDI5IDAuMiA0LjY0NDI5IDAuMyA0Ljc0NDI5TDMuMyA3Ljc0NDI5QzMuNSA3Ljk0NDI5IDMuNyA4LjA0NDI5IDQgOC4wNDQyOUM0LjMgOC4wNDQyOSA0LjUgNy45NDQyOSA0LjcgNy43NDQyOUM1LjEgNy4zNDQyOSA1LjEgNi43NDQyOSA0LjcgNi4zNDQyOUwzLjQgNS4xNDQyOUgxNUMxNS42IDUuMTQ0MjkgMTYgNC43NDQyOSAxNiA0LjE0NDI5QzE2IDMuNTQ0MjkgMTUuNiAzLjE0NDI5IDE1IDMuMTQ0MjlaIiBmaWxsPSIjODYwOTM1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMV8xNzQ2Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjcuOSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4xNDQyODcpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/components/CatalogContent/CatalogContent.tsx


function CatalogContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CatalogContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CatalogContent_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CatalogContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















const CatalogContent = ({
  trigger
}) => {
  var _CategorieIsOpen$data, _CategorieIsOpen$data2, _CategorieIsOpen$data3, _CategorieIsOpen$data4, _CategorieIsOpen$data5, _CategorieIsOpen$data6, _CategorieIsOpen$data7, _CategorieIsOpen$data8;

  const {
    0: catalogIsOpen,
    1: setOpenCatalog
  } = (0,react.useState)(false);
  const {
    0: CategorieIsOpen,
    1: setCategorieOpen
  } = (0,react.useState)({
    isOpen: false
  });
  const modalContent = (0,react.useRef)(null);
  const {
    triggerLogo
  } = (0,react.useContext)(LogoContext);
  const catalogResources = useCatalogMenuResource();
  const catalogList = catalogResources === null || catalogResources === void 0 ? void 0 : catalogResources.data;

  const handleItemClick = item => {
    setCategorieOpen({
      isOpen: true,
      data: item
    });
  };

  const handleCatalogClick = () => {
    setOpenCatalog(!catalogIsOpen);
  };

  const handleCategoriesClick = () => {
    setCategorieOpen(prevState => CatalogContent_objectSpread(CatalogContent_objectSpread({}, prevState), {}, {
      isOpen: false
    }));
  };

  (0,react.useEffect)(() => {
    return () => {
      triggerLogo && triggerLogo(false);
    };
  }, [triggerLogo]);
  (0,react.useEffect)(() => trigger(false), [trigger]);
  (0,react.useEffect)(() => {
    const target = modalContent.current;
    const options = {
      reserveScrollBarGap: true,
      allowTouchMove: el => el.classList.contains('scrollable')
    };

    if (target) {
      (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(target, options);
    }

    return () => {
      if (target) {
        (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(target);
      }
    };
  }, []);
  (0,react.useEffect)(() => {
    const offset = window.pageYOffset;
    return () => {
      window.scrollTo(0, offset);
    };
  }, []);
  const t = (0,production/* useTranslations */.T_)();

  if ((0,common/* getCurrentProject */.vo)() === 'dveri') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContainer, {
        ref: modalContent,
        className: "scrollable",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_List, {
          style: {
            paddingTop: '10px'
          },
          children: (catalogList !== null && catalogList !== void 0 ? catalogList : []).map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(Categorie, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Label, {
                categorieOpened: true,
                children: item.label
              })
            })
          }, item.entityId))
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContainer, {
      ref: modalContent,
      className: "scrollable",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CatalogContent_List, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Heading, {
          hideBorder: catalogIsOpen,
          active: true,
          open: catalogIsOpen,
          onClick: handleCatalogClick,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CatalogContent_Label, {
            active: !!catalogIsOpen,
            children: [catalogIsOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowBack, {}), t('catalog.all')]
          }), catalogIsOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Close, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgArrowForward, {})]
        }), catalogIsOpen && //full catalog
        (catalogList !== null && catalogList !== void 0 ? catalogList : []).map(item => {
          var _item$children$header;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Categorie, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: item.url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Label, {
                categorieOpened: true,
                children: item.label
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategorieInner, {
              children: ((_item$children$header = item.children.header) !== null && _item$children$header !== void 0 ? _item$children$header : []).map((item, index) => {
                var _item$icon$url, _item$icon, _item$icon$url2, _item$icon2, _item$icon$url3, _item$icon3, _item$icon$url4, _item$icon4;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                  to: item.url,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentItem, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Picture/* default */.Z, {
                      src2x: (_item$icon$url = item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.url) !== null && _item$icon$url !== void 0 ? _item$icon$url : '',
                      srcWebp: (_item$icon$url2 = item === null || item === void 0 ? void 0 : (_item$icon2 = item.icon) === null || _item$icon2 === void 0 ? void 0 : _item$icon2.url) !== null && _item$icon$url2 !== void 0 ? _item$icon$url2 : '',
                      src: (_item$icon$url3 = item === null || item === void 0 ? void 0 : (_item$icon3 = item.icon) === null || _item$icon3 === void 0 ? void 0 : _item$icon3.url) !== null && _item$icon$url3 !== void 0 ? _item$icon$url3 : '',
                      srcWebp2x: (_item$icon$url4 = item === null || item === void 0 ? void 0 : (_item$icon4 = item.icon) === null || _item$icon4 === void 0 ? void 0 : _item$icon4.url) !== null && _item$icon$url4 !== void 0 ? _item$icon$url4 : ''
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Description, {
                      children: item.label
                    })]
                  })
                }, index);
              })
            })]
          }, item.entityId);
        }), !catalogIsOpen && //categories
        (catalogList !== null && catalogList !== void 0 ? catalogList : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Heading, {
          onClick: () => handleItemClick(item),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Label, {
            children: item.label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgArrowForward, {})]
        }, index)), (CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : CategorieIsOpen.isOpen) && /*#__PURE__*/(0,jsx_runtime.jsx)(Portal_Portal, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubCategories, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CatalogContent_List, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Heading, {
                hideBorder: CategorieIsOpen.isOpen,
                active: true,
                open: CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : CategorieIsOpen.isOpen,
                onClick: handleCategoriesClick,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CatalogContent_Label, {
                  active: true,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArrowBack, {}), CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : (_CategorieIsOpen$data = CategorieIsOpen.data) === null || _CategorieIsOpen$data === void 0 ? void 0 : _CategorieIsOpen$data.label]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Close, {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Categorie, {
                hideBorder: !!(CategorieIsOpen !== null && CategorieIsOpen !== void 0 && (_CategorieIsOpen$data2 = CategorieIsOpen.data) !== null && _CategorieIsOpen$data2 !== void 0 && (_CategorieIsOpen$data3 = _CategorieIsOpen$data2.children) !== null && _CategorieIsOpen$data3 !== void 0 && (_CategorieIsOpen$data4 = _CategorieIsOpen$data3.inner) !== null && _CategorieIsOpen$data4 !== void 0 && _CategorieIsOpen$data4.length),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CategorieInner, {
                  children: ((_CategorieIsOpen$data5 = CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : (_CategorieIsOpen$data6 = CategorieIsOpen.data) === null || _CategorieIsOpen$data6 === void 0 ? void 0 : _CategorieIsOpen$data6.children.header) !== null && _CategorieIsOpen$data5 !== void 0 ? _CategorieIsOpen$data5 : []).map((item, index) => {
                    var _item$icon$url5, _item$icon5, _item$icon$url6, _item$icon6, _item$icon$url7, _item$icon7, _item$icon$url8, _item$icon8;

                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                      to: item.url,
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentItem, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Picture/* default */.Z, {
                          src2x: (_item$icon$url5 = item === null || item === void 0 ? void 0 : (_item$icon5 = item.icon) === null || _item$icon5 === void 0 ? void 0 : _item$icon5.url) !== null && _item$icon$url5 !== void 0 ? _item$icon$url5 : '',
                          srcWebp: (_item$icon$url6 = item === null || item === void 0 ? void 0 : (_item$icon6 = item.icon) === null || _item$icon6 === void 0 ? void 0 : _item$icon6.url) !== null && _item$icon$url6 !== void 0 ? _item$icon$url6 : '',
                          src: (_item$icon$url7 = item === null || item === void 0 ? void 0 : (_item$icon7 = item.icon) === null || _item$icon7 === void 0 ? void 0 : _item$icon7.url) !== null && _item$icon$url7 !== void 0 ? _item$icon$url7 : '',
                          srcWebp2x: (_item$icon$url8 = item === null || item === void 0 ? void 0 : (_item$icon8 = item.icon) === null || _item$icon8 === void 0 ? void 0 : _item$icon8.url) !== null && _item$icon$url8 !== void 0 ? _item$icon$url8 : ''
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Description, {
                          children: item.label
                        })]
                      })
                    }, item.label + index);
                  })
                })
              }), (CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : (_CategorieIsOpen$data7 = CategorieIsOpen.data) === null || _CategorieIsOpen$data7 === void 0 ? void 0 : _CategorieIsOpen$data7.children.inner) && /*#__PURE__*/(0,jsx_runtime.jsx)(SubCategorie, {
                children: CategorieIsOpen === null || CategorieIsOpen === void 0 ? void 0 : (_CategorieIsOpen$data8 = CategorieIsOpen.data) === null || _CategorieIsOpen$data8 === void 0 ? void 0 : _CategorieIsOpen$data8.children.inner.map((item, index) => {
                  var _item$children;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Categorie, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_Label, {
                      active: true,
                      children: item.label
                    }), ((_item$children = item === null || item === void 0 ? void 0 : item.children) !== null && _item$children !== void 0 ? _item$children : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                      to: item.url,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubCategorieInner, {
                        children: item.label
                      })
                    }, item.label + index))]
                  }, item.label + index);
                })
              })]
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var CatalogContent_CatalogContent = (CatalogContent);
const Overlay = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__Overlay",
  componentId: "sc-11p9rv2-0"
})(["position:fixed;inset:0;margin-top:45px;padding-bottom:43px;z-index:5;min-height:100%;max-height:100vh;background:rgba(0,0,0,0.5);@media (min-width:", "px){margin-top:80px;padding-bottom:80px;}@media (min-width:", "px){margin-top:70px;padding-bottom:70px;}@media (min-width:", "px){margin-top:60px;padding-bottom:60px;}"], theme/* breakpoints.laptop */.AV.laptop, theme/* breakpoints.tabletLarge */.AV.tabletLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const CatalogContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__CatalogContainer",
  componentId: "sc-11p9rv2-1"
})(["max-width:1260px;margin:0 auto;width:100%;height:100%;background-color:#fff;transform:translateX(0);-webkit-overflow-scrolling:touch !important;overflow:auto !important;"]);
const Heading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__Heading",
  componentId: "sc-11p9rv2-2"
})(["cursor:pointer;display:flex;justify-content:space-between;align-items:center;padding:0 15px;", " ", " border-bottom:1px solid ", ";"], ({
  active
}) => active && (0,styled_components_browser_esm.css)(["span{color:", ";}svg path{fill:", ";}"], theme/* colors.darkRed */.O9.darkRed, theme/* colors.darkRed */.O9.darkRed), ({
  open
}) => open && (0,styled_components_browser_esm.css)(["background-color:#f0f0f0;"]), ({
  hideBorder
}) => hideBorder ? 'transparent' : theme/* colors.gray70 */.O9.gray70);
const CatalogContent_Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CatalogContent__Label",
  componentId: "sc-11p9rv2-3"
})(["font-style:normal;font-weight:500;line-height:40px;font-size:", ";color:#000;"], ({
  active,
  categorieOpened
}) => !active && !categorieOpened ? '13px' : categorieOpened ? '18px' : '16px');
const ArrowBack = (0,styled_components_browser_esm["default"])(SvgArrowBack).withConfig({
  displayName: "CatalogContent__ArrowBack",
  componentId: "sc-11p9rv2-4"
})(["margin-right:12px;"]);
const CatalogContent_List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "CatalogContent__List",
  componentId: "sc-11p9rv2-5"
})(["height:100%;width:100%;overflow:auto;"]);
const CatalogContent_Close = (0,styled_components_browser_esm["default"])(SvgCloseCatalog).withConfig({
  displayName: "CatalogContent__Close",
  componentId: "sc-11p9rv2-6"
})(["height:15px;"]);
const SubCategorieInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__SubCategorieInner",
  componentId: "sc-11p9rv2-7"
})(["padding:6px 0;"]);
const SubCategories = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__SubCategories",
  componentId: "sc-11p9rv2-8"
})(["height:100%;width:100%;background:#fff;"]);
const Categorie = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__Categorie",
  componentId: "sc-11p9rv2-9"
})(["width:100%;padding:11px 15px 15px;border-bottom:1px solid ", ";"], ({
  hideBorder
}) => !hideBorder ? ' #f0f0f0;' : 'transparent;');
const CategorieInner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__CategorieInner",
  componentId: "sc-11p9rv2-10"
})(["margin-top:10px;display:grid;grid-template-columns:1fr 1fr;align-items:flex-end;gap:32px 45px;@media (min-width:768px){grid-template-columns:calc(25% - 25px) calc(25% - 25px) calc(25% - 25px);justify-content:center;};"]);
const ContentItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__ContentItem",
  componentId: "sc-11p9rv2-11"
})(["display:flex;flex-direction:column;align-items:center;max-width:140px;width:100%;margin:0 auto;picture{width:100%;height:100%;}img{height:100%;width:120px;display:block;position:relative;max-height:80px;overflow:hidden;object-fit:contain;}& > div:first-child{margin-bottom:12.5px;}"]);
const CatalogContent_Description = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CatalogContent__Description",
  componentId: "sc-11p9rv2-12"
})(["font-style:normal;font-weight:600;font-size:12px;line-height:18px;text-align:center;"]);
const SubCategorie = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogContent__SubCategorie",
  componentId: "sc-11p9rv2-13"
})(["& > div{border:0;border-top:1px solid #f0f0f0;}& > div:last-child{padding-bottom:100px;}"]);
;// CONCATENATED MODULE: ./src/components/CatalogContent/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Header/components/CatalogBtn/CatalogBtn.tsx














function CatalogBtn({
  menuState,
  trigger
}) {
  const {
    0: clicked,
    1: setClicked
  } = (0,react.useState)(false);
  const {
    0: toUnmount,
    1: setToUnmount
  } = (0,react.useState)(false);
  const {
    isTriggered
  } = (0,react.useContext)(LogoContext);
  const t = (0,production/* useTranslations */.T_)();

  const stateHandler = () => {
    if (!clicked) {
      trigger(true);
      setClicked(true);
    } else {
      trigger(false);
      setToUnmount(true);
      setClicked(false);
      setToUnmount(false);
    }
  };

  (0,react.useEffect)(() => {
    if (!isTriggered) {
      return;
    }

    setToUnmount(true);
    setClicked(false);
    setToUnmount(false);
    trigger(false);
  }, [isTriggered, trigger]);
  (0,react.useEffect)(() => {
    if (clicked && menuState) {
      setToUnmount(true);
      setClicked(!clicked);
      setToUnmount(false);
      trigger(false);
    }
  }, [menuState, trigger]);
  (0,react.useEffect)(() => trigger(false), [trigger]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CatalogBtn_Component, {
      toUnmount: toUnmount,
      active: clicked,
      onClick: stateHandler,
      children: [(0,common/* getCurrentProject */.vo)() !== 'dveri' && /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogBtn_Icon, {
        active: clicked,
        toUnmount: toUnmount,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCatalogBtnsofaMenu, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogBtn_Title, {
        toUnmount: toUnmount,
        active: clicked,
        children: t('catalog.title')
      })]
    }), clicked && /*#__PURE__*/(0,jsx_runtime.jsx)(Portal_Portal, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogContent_CatalogContent, {
        trigger: trigger
      })
    })]
  });
}

/* harmony default export */ var CatalogBtn_CatalogBtn = (CatalogBtn);
const CatalogBtn_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogBtn__Component",
  componentId: "sc-hcyuqg-0"
})(["cursor:pointer;display:flex;align-items:center;max-width:92px;padding:3px 11px 3px 8px;border:1px solid ", ";border-radius:5px;@media (min-width:", "px){max-width:100px;}", ""], theme/* colors.gray70 */.O9.gray70, theme/* breakpoints.tabletSmall */.AV.tabletSmall, ({
  active,
  toUnmount
}) => active && !toUnmount && (0,styled_components_browser_esm.css)(["border-color:", ";background-color:", ";"], theme/* colors.darkRed */.O9.darkRed, theme/* colors.darkRed */.O9.darkRed));
const CatalogBtn_Icon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogBtn__Icon",
  componentId: "sc-hcyuqg-1"
})(["display:flex;margin-right:7px;line-height:0;", ""], ({
  active,
  toUnmount
}) => active && !toUnmount && (0,styled_components_browser_esm.css)(["svg path{fill:#fff;}"]));
const CatalogBtn_Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CatalogBtn__Title",
  componentId: "sc-hcyuqg-2"
})(["font-style:normal;font-weight:500;font-size:12px;line-height:18px;color:", ";@media (min-width:", "px){font-size:14px;}", ""], theme/* colors.black100 */.O9.black100, theme/* breakpoints.tabletSmall */.AV.tabletSmall, ({
  active,
  toUnmount
}) => active && !toUnmount && (0,styled_components_browser_esm.css)(["color:#fff;"]));
;// CONCATENATED MODULE: ./src/components/Layout/components/Header/components/CatalogBtn/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/Header/Logo/BelMebel.mobile.logo.svg
function BelMebel_mobile_logo_extends() { BelMebel_mobile_logo_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BelMebel_mobile_logo_extends.apply(this, arguments); }



var BelMebel_mobile_logo_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.11985 6.43408H8.59311C10.5128 6.43408 12.0669 7.99328 12.0669 9.89643C12.0669 11.8225 10.5128 13.3817 8.59311 13.3817H1.11985C0.502788 13.3817 0 12.8773 0 12.2582V7.55762C0 6.93853 0.502788 6.43408 1.11985 6.43408Z",
  fill: "#003C68"
});

var BelMebel_mobile_logo_ref2 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.20468 14.4788H9.2441C11.3093 14.4788 12.9811 16.1611 12.9811 18.2144C12.9811 20.2926 11.3093 21.9749 9.2441 21.9749H1.20468C0.540878 21.9749 0 21.4306 0 20.7626V15.691C0 15.023 0.540878 14.4788 1.20468 14.4788Z",
  fill: "#003C68"
});

var _ref3 = /*#__PURE__*/react.createElement("path", {
  d: "M26.1009 9.53489C26.526 9.53489 26.9063 9.37828 27.2196 9.08742C27.5104 8.77419 27.667 8.41621 27.667 7.96874C27.667 7.54364 27.5104 7.16329 27.2196 6.85006C26.9063 6.5592 26.5484 6.40259 26.1009 6.40259H16.5026C16.0775 6.40259 15.6972 6.5592 15.3839 6.85006C15.0931 7.16329 14.9365 7.52127 14.9365 7.96874V20.4085C14.9365 20.8336 15.0931 21.2139 15.3839 21.5271C15.6972 21.818 16.0551 21.9746 16.5026 21.9746H26.1009C26.526 21.9746 26.9063 21.818 27.2196 21.5271C27.5104 21.2139 27.667 20.8559 27.667 20.4085C27.667 19.9834 27.5104 19.603 27.2196 19.2898C26.9063 18.9989 26.5484 18.8423 26.1009 18.8423H18.0688V15.7324H25.2283C25.6534 15.7324 26.0114 15.5758 26.3246 15.2849C26.6379 14.9717 26.7945 14.6137 26.7945 14.1662C26.7945 13.7411 26.6379 13.3608 26.3246 13.0476C26.0338 12.7567 25.6758 12.6001 25.2283 12.6001H18.0688V9.53489H26.1009Z",
  fill: "#003C68"
});

var _ref4 = /*#__PURE__*/react.createElement("path", {
  d: "M39.0776 18.8423H33.8869V7.96874C33.8869 7.54364 33.7303 7.18566 33.4394 6.87243C33.1262 6.5592 32.7682 6.40259 32.3207 6.40259C31.8956 6.40259 31.5153 6.5592 31.2021 6.87243C30.9112 7.16329 30.7546 7.52127 30.7546 7.96874V20.4085C30.7546 20.8336 30.9112 21.1915 31.2021 21.5048C31.5153 21.818 31.8733 21.9746 32.3207 21.9746H39.0776C39.5027 21.9746 39.883 21.818 40.1963 21.5048C40.4871 21.2139 40.6437 20.8559 40.6437 20.4085C40.6437 19.9834 40.4871 19.603 40.1963 19.2898C39.8607 18.9989 39.5027 18.8423 39.0776 18.8423Z",
  fill: "#003C68"
});

var _ref5 = /*#__PURE__*/react.createElement("path", {
  d: "M46.2612 1.21621C45.5802 0.761232 44.4452 0.988719 44.4452 2.23991V20.4391C45.1262 22.4865 47.9637 22.4865 48.4177 20.4391V13.1594L50.4607 15.2068V20.4391C51.0282 22.3727 53.7521 22.3727 54.3196 20.4391V15.2068L56.4761 13.1594V20.4391C56.9301 22.259 59.8811 22.259 60.3351 20.4391V8.38212C60.3351 6.7897 58.5191 6.22097 57.3841 7.01719L52.3901 11.567V7.8134C52.3901 7.01719 51.8227 6.33472 50.9147 5.42476L46.2612 1.21621Z",
  fill: "#8B1230",
  stroke: "#8B1230"
});

var _ref6 = /*#__PURE__*/react.createElement("path", {
  d: "M106.457 9.53489C106.882 9.53489 107.263 9.37828 107.576 9.08742C107.867 8.77419 108.023 8.41621 108.023 7.96874C108.023 7.54364 107.867 7.16329 107.576 6.85006C107.263 6.5592 106.905 6.40259 106.457 6.40259H96.8589C96.4338 6.40259 96.0534 6.5592 95.7402 6.85006C95.4494 7.16329 95.2927 7.52127 95.2927 7.96874V20.4085C95.2927 20.8336 95.4494 21.2139 95.7402 21.5271C96.0534 21.818 96.4114 21.9746 96.8589 21.9746H106.457C106.882 21.9746 107.263 21.818 107.576 21.5271C107.867 21.2139 108.023 20.8559 108.023 20.4085C108.023 19.9834 107.867 19.603 107.576 19.2898C107.263 18.9989 106.905 18.8423 106.457 18.8423H98.425V15.7324H105.585C106.01 15.7324 106.368 15.5758 106.681 15.2849C106.994 14.9717 107.151 14.6137 107.151 14.1662C107.151 13.7411 106.994 13.3608 106.681 13.0476C106.39 12.7567 106.032 12.6001 105.585 12.6001H98.425V9.53489H106.457Z",
  fill: "#8B1230"
});

var _ref7 = /*#__PURE__*/react.createElement("path", {
  d: "M119.434 18.8426H114.243V7.96899C114.243 7.54389 114.087 7.18591 113.796 6.87268C113.482 6.55945 113.124 6.40283 112.677 6.40283C112.252 6.40283 111.872 6.55945 111.558 6.87268C111.267 7.16353 111.111 7.52151 111.111 7.96899V20.4087C111.111 20.8338 111.267 21.1918 111.558 21.505C111.872 21.8183 112.23 21.9749 112.677 21.9749H119.434C119.859 21.9749 120.239 21.8183 120.553 21.505C120.843 21.2142 121 20.8562 121 20.4087C121 19.9836 120.843 19.6033 120.553 19.29C120.217 18.9992 119.859 18.8426 119.434 18.8426Z",
  fill: "#8B1230"
});

var _ref8 = /*#__PURE__*/react.createElement("path", {
  d: "M74.6775 9.53489C75.1026 9.53489 75.4829 9.37828 75.7961 9.08742C76.087 8.77419 76.2436 8.41621 76.2436 7.96874C76.2436 7.54364 76.087 7.16329 75.7961 6.85006C75.4829 6.5592 75.1249 6.40259 74.6775 6.40259H65.0792C64.6541 6.40259 64.2737 6.5592 63.9605 6.85006C63.6696 7.16329 63.513 7.52127 63.513 7.96874V20.4085C63.513 20.8336 63.6696 21.2139 63.9605 21.5271C64.2737 21.818 64.6317 21.9746 65.0792 21.9746H74.6775C75.1026 21.9746 75.4829 21.818 75.7961 21.5271C76.087 21.2139 76.2436 20.8559 76.2436 20.4085C76.2436 19.9834 76.087 19.603 75.7961 19.2898C75.4829 18.9989 75.1249 18.8423 74.6775 18.8423H66.6453V15.7324H73.8049C74.23 15.7324 74.588 15.5758 74.9012 15.2849C75.2144 14.9717 75.371 14.6137 75.371 14.1662C75.371 13.7411 75.2144 13.3608 74.9012 13.0476C74.6103 12.7567 74.2524 12.6001 73.8049 12.6001H66.6453V9.53489H74.6775Z",
  fill: "#8B1230"
});

var _ref9 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.9394 6.40261H87.3622C92.441 6.40261 93.0228 10.5435 91.269 13.7993C94.7851 16.5244 92.8317 21.9746 88.1436 21.9746H79.9394C79.0642 21.9577 78.7715 21.741 78.7673 20.8067V7.18121C78.786 6.57337 79.0388 6.40031 79.9394 6.40261ZM88.5343 15.7458H81.9453V18.8602H88.5343C88.5343 18.8602 90.097 18.8602 90.097 17.303C90.097 15.7458 88.5343 15.7458 88.5343 15.7458ZM87.7529 9.12769L81.9453 9.10386V12.2818L87.7529 12.2421C87.7529 12.2421 89.3156 12.2421 89.3156 10.6849C89.3156 9.12769 87.7529 9.12769 87.7529 9.12769Z",
  fill: "#8B1230"
});

function SvgBelMebelmobilelogo({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", BelMebel_mobile_logo_extends({
    width: 121,
    height: 23,
    viewBox: "0 0 121 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, BelMebel_mobile_logo_ref, BelMebel_mobile_logo_ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

/* harmony default export */ var BelMebel_mobile_logo = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/components/Layout/components/Header/components/Logo/assets/dveri_logo.webp
/* harmony default export */ var dveri_logo = ("data:image/webp;base64,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");
;// CONCATENATED MODULE: ./src/components/Layout/components/Header/components/Logo/Logo.tsx









function Logo() {
  const {
    triggerLogo
  } = (0,react.useContext)(LogoContext);
  const project = (0,common/* getCurrentProject */.vo)();

  if (project === 'dveri') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DveriImage, {
      onClick: () => triggerLogo === null || triggerLogo === void 0 ? void 0 : triggerLogo(true),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: dveri_logo
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Logo_Component, {
    onClick: () => triggerLogo === null || triggerLogo === void 0 ? void 0 : triggerLogo(true),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Picture/* default */.Z, {
      src: BelMebel_mobile_logo
    })
  });
}

const Logo_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Logo__Component",
  componentId: "sc-mxi33m-0"
})(["img{cursor:pointer;height:20.97px;}"]);
const DveriImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Logo__DveriImage",
  componentId: "sc-mxi33m-1"
})(["img{height:30px;}"]);
/* harmony default export */ var Logo_Logo = (Logo);
;// CONCATENATED MODULE: ./src/components/Layout/components/Header/components/Logo/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Header/Header.tsx














function Header_Header() {
  const router = (0,next_router.useRouter)();
  const {
    isModalVisible
  } = (0,useModalsOpen/* default */.Z)();
  const {
    0: catalogActive,
    1: setCatalogActive
  } = (0,react.useState)(false);
  const {
    0: menuActive,
    1: setMenuActive
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LogoTriggerProvider, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header_Component, {
      onMobile: isModalVisible,
      className: "main-layout-header",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Header_Content, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
            onClick: () => {
              catalogActive && setCatalogActive(false);
              menuActive && setMenuActive(false);
              router.push('/');
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo_Logo, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderRight, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Search_Search, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogBtn_CatalogBtn, {
              menuState: menuActive,
              trigger: setCatalogActive
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Burger_Burger, {
              catalogState: catalogActive,
              trigger: setMenuActive
            })]
          })]
        })
      })
    })
  });
}

/* harmony default export */ var components_Header_Header = (Header_Header);
const Header_Component = styled_components_browser_esm["default"].header.withConfig({
  displayName: "Header__Component",
  componentId: "sc-1b6cl53-0"
})(["position:fixed;top:0;display:flex;padding:9.5px 0;margin:0 auto;left:0;right:0;max-width:1260px;transition:transform 0s ease;", " z-index:1000;background-color:#fff;box-shadow:0 3px 6px 0 #d0d0d0;overflow:hidden;@media (min-width:", "px){height:80px;}@media (min-width:", "px){height:70px;}@media (min-width:", "px){height:60px;}"], ({
  onMobile
}) => !onMobile && (0,styled_components_browser_esm.css)(["transform:translate3d(0,0,10px);"]), theme/* breakpoints.laptop */.AV.laptop, theme/* breakpoints.tabletLarge */.AV.tabletLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Header_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Content",
  componentId: "sc-1b6cl53-1"
})(["position:relative;display:flex;align-items:center;justify-content:space-between;height:100%;z-index:2;"]);
const HeaderRight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__HeaderRight",
  componentId: "sc-1b6cl53-2"
})(["display:flex;align-items:center;"]);
const LogoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__LogoWrapper",
  componentId: "sc-1b6cl53-3"
})([""]);
;// CONCATENATED MODULE: ./src/components/Layout/components/Header/index.ts

// EXTERNAL MODULE: ./src/components/A1/index.ts
var components_A1 = __webpack_require__(18176);
;// CONCATENATED MODULE: ./src/components/Phones/Phones.tsx








function Phones() {
  const mts = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_MTS');
  const a1 = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_MTS');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Phones_Component, {
    children: [mts && /*#__PURE__*/(0,jsx_runtime.jsx)(Mts/* default */.Z, {
      title: mts
    }), a1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_A1/* default */.Z, {
      title: a1
    })]
  });
}

/* harmony default export */ var Phones_Phones = (Phones);
const Phones_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Phones__Component",
  componentId: "sc-koxh13-0"
})(["display:flex;justify-content:center;max-width:320px;margin:0 auto 16px;& > div:last-child{margin-left:10px;}"]);
;// CONCATENATED MODULE: ./src/components/Phones/index.ts

// EXTERNAL MODULE: ./src/components/Forms/SuccessForm.tsx + 1 modules
var SuccessForm = __webpack_require__(29117);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/services/requests.ts
var requests = __webpack_require__(17146);
// EXTERNAL MODULE: ./src/components/TextInput/index.ts + 6 modules
var TextInput = __webpack_require__(28560);
// EXTERNAL MODULE: ./src/components/TextInput/formikHelpers/form.helpers.ts
var form_helpers = __webpack_require__(75901);
;// CONCATENATED MODULE: ./src/components/Forms/CallbackForm/CallbackFormRequest.tsx

const CallbackFormRequest_excluded = ["isSubmitting", "isValid", "values", "dirty"];












function validate(t, {
  phone,
  name
}) {
  const errors = {};

  if (!(0,form_helpers/* validatePhone */.a)(phone)) {
    errors.phone = t('forms.phone_error');
  }

  if (!phone) {
    errors.phone = t('forms.required');
  }

  if (!name) {
    errors.name = t('forms.required');
  }

  return errors;
}

const hasFrontendValidationErrors = (t, values) => !!Object.keys(validate(t, values)).length;

function CallbackFormRequest({
  setFormClosed
}) {
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();

  function handleSubmit(values, formikHelpers) {
    return (0,requests/* sendCallForm */.P6)(values).then(() => {
      setFormClosed();
      closeModalState();
      formikHelpers.setSubmitting(true);
    }).catch(() => {
      formikHelpers.setErrors({
        phone: t('forms.unknown_error')
      });
      formikHelpers.setStatus({
        hasBackendError: true
      });
    }).finally(() => {
      formikHelpers.setSubmitting(false);
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Body, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CallbackFormRequest_Text, {
      children: t('leave_contacts')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      initialValues: {
        name: '',
        phone: ''
      },
      onSubmit: handleSubmit,
      validate: fields => validate(t, fields),
      children: _ref => {
        let {
          isSubmitting,
          isValid,
          values,
          dirty
        } = _ref,
            props = (0,objectWithoutProperties/* default */.Z)(_ref, CallbackFormRequest_excluded);

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "name",
              icon: "profile",
              placeholder: t('forms.name'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "phone",
              icon: "phone",
              placeholder: t('forms.phone'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.C, {
            type: "submit",
            variant: "contained-primary-w100-f13",
            disabled: !(isValid || !hasFrontendValidationErrors(t, values)) && (0,form_helpers/* areAllErrorsVisible */.G)(props.errors, props.touched),
            children: t('forms.send'),
            loading: isSubmitting
          })]
        });
      }
    })]
  });
}

/* harmony default export */ var CallbackForm_CallbackFormRequest = (CallbackFormRequest);
const CallbackFormRequest_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormRequest__Text",
  componentId: "sc-1tuzpcv-0"
})(["font-size:13px;line-height:20px;margin-bottom:20px;"]);
const FormRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormRequest__FormRow",
  componentId: "sc-1tuzpcv-1"
})(["margin-bottom:30px;"]);
const Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormRequest__Body",
  componentId: "sc-1tuzpcv-2"
})(["margin-top:20px;padding:0 15px;"]);
;// CONCATENATED MODULE: ./src/components/Forms/CallbackForm/CallbackFormFooter.tsx











function CallbackFormFooter({
  closeModal,
  innerProps
}) {
  const {
    0: isFormClosed,
    1: setFormClosed
  } = (0,react.useState)(false);
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  const ref = (0,react.useRef)(null);
  const t = (0,production/* useTranslations */.T_)();
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CallbackFormFooter_Component, {
    className: "active",
    ref: ref,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CallbackFormFooter_Header, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderBody, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CallbackFormFooter_Title, {
          children: innerProps.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallbackFormFooter_Close, {
          onClick: () => {
            closeModal();
            closeModalState();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modals_close/* ReactComponent */.r, {})
        })]
      })
    }), isFormClosed ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessForm/* default */.Z, {
      title: t('forms.success_title'),
      text: t('forms.success_text')
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CallbackForm_CallbackFormRequest, {
      setFormClosed: () => setFormClosed(true)
    })]
  });
}

/* harmony default export */ var CallbackForm_CallbackFormFooter = (CallbackFormFooter);
const CallbackFormFooter_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormFooter__Component",
  componentId: "sc-huppm-0"
})(["height:calc(var(--vh,1) * 100);min-width:100vw;padding-bottom:15px;background:#fff;flex-shrink:1;-webkit-overflow-scrolling:touch !important;overflow:auto !important;"]);
const CallbackFormFooter_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormFooter__Header",
  componentId: "sc-huppm-1"
})(["box-shadow:0 1px 6px 0 #d0d0d0;"]);
const HeaderBody = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormFooter__HeaderBody",
  componentId: "sc-huppm-2"
})(["position:relative;display:flex;align-items:center;justify-content:center;padding:0 15px;min-height:45px;"]); //

const CallbackFormFooter_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormFooter__Title",
  componentId: "sc-huppm-3"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;text-align:center;"]);
const CallbackFormFooter_Close = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CallbackFormFooter__Close",
  componentId: "sc-huppm-4"
})(["cursor:pointer;position:absolute;right:15px;top:calc(50% - 8px);"]);
;// CONCATENATED MODULE: ./src/components/Forms/CallbackForm/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/components/Callback/Callback.tsx








function Callback() {
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const {
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Callback_Component, {
    onClick: () => {
      setTimeout(() => {
        openModalState();
        openModal(CallbackForm_CallbackFormFooter, {
          title: t('forms.call_title')
        }, {
          withAnimation: false,
          scrollLockDisabled: true
        });
      }, 0);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      children: t('forms.call_me')
    })
  });
}

const Callback_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Callback__Component",
  componentId: "sc-8ds6vk-0"
})(["cursor:pointer;display:flex;align-items:center;justify-content:center;min-height:34px;min-width:140px;max-width:290px;margin-left:9px;border-radius:6px;border:1px solid #860935;button{width:100%;height:100%;color:#860935;font-weight:bold;font-size:11px;line-height:22px;}"]);
/* harmony default export */ var Callback_Callback = (Callback);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/components/Callback/index.ts

;// CONCATENATED MODULE: ./src/components/TextArea/TextArea.style.ts



function getBorderColor(props = {}) {
  return props.invalid ? theme/* colors.red */.O9.red : props.isActive ? theme/* colors.gray500 */.O9.gray500 : theme/* colors.gray200 */.O9.gray200;
}

const TextArea_style_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextAreastyle__Container",
  componentId: "sc-ug0u5i-0"
})(["position:relative;width:100%;"]);
const TextArea = styled_components_browser_esm["default"].textarea.withConfig({
  displayName: "TextAreastyle__TextArea",
  componentId: "sc-ug0u5i-1"
})(["width:100%;font-size:14px;line-height:130%;border-radius:5px;border:1px solid ", ";padding:15px;min-height:120px;max-height:200px;resize:none;&::placeholder{color:", ";opacity:0.5;}&:focus{border-color:", ";}"], ({
  invalid
}) => getBorderColor({
  invalid
}), props => props.invalid ? theme/* colors.red */.O9.red : theme/* colors.black */.O9.black, ({
  invalid,
  readOnly
}) => getBorderColor({
  invalid,
  isActive: !readOnly
}));
const TextArea_style_Label = styled_components_browser_esm["default"].label.withConfig({
  displayName: "TextAreastyle__Label",
  componentId: "sc-ug0u5i-2"
})(["position:absolute;top:", ";left:15px;transform:", ";transform-origin:0 50%;color:", ";pointer-events:none;"], ({
  isActive,
  isFilled
}) => isActive || isFilled ? '10px' : 'calc(50% - 3px)', ({
  isActive,
  isFilled
}) => isActive || isFilled ? 'translateY(-50%) scale(.7)' : 'translateY(-50%)', props => props.invalid ? theme/* colors.red */.O9.red : theme/* colors.black */.O9.black);
;// CONCATENATED MODULE: ./src/components/TextArea/TextArea.tsx


const TextArea_excluded = ["label", "placeholder", "className", "autoFocus", "onBlur", "disabled", "required", "invalid", "autoHeight", "onChange"];

function TextArea_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextArea_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextArea_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextArea_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function TextArea_TextArea(_ref) {
  let {
    label,
    placeholder,
    className,
    autoFocus,
    onBlur,
    disabled,
    required,
    invalid,
    autoHeight,
    onChange
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextArea_excluded);

  const {
    0: isActive,
    1: setActive
  } = (0,react.useState)(false);
  const {
    0: isFilled,
    1: setFilled
  } = (0,react.useState)(false);
  const textAreaRef = (0,react.useRef)(null);

  function handleChange(event) {
    if (autoHeight) {
      const textAreaElement = event.target;
      textAreaElement.style.height = 'auto';
      textAreaElement.style.height = `${textAreaElement.scrollHeight}px`;
    }

    if (onChange) {
      onChange(event);
    }
  }

  function handleFocus() {
    if (!textAreaRef.current) return;
    setActive(true);
    toggleFilledState();
  }

  function handleBlur(e) {
    if (!textAreaRef.current) return;
    setActive(false);
    toggleFilledState();
    onBlur && onBlur(e);
  }

  function toggleFilledState() {
    const textAreaElem = textAreaRef.current;
    if (!textAreaElem) return;
    if (textAreaElem.value !== '') setFilled(true);else setFilled(false);
  }

  (0,react.useEffect)(() => {
    toggleFilledState();
    const textAreaElem = textAreaRef.current;
    if (textAreaElem && autoFocus) textAreaElem.focus();
  }, [autoFocus]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextArea_style_Container, {
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, TextArea_objectSpread({
      className: className,
      ref: textAreaRef,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      isActive: isActive,
      withLabel: !!label,
      disabled: disabled,
      invalid: invalid,
      placeholder: placeholder
    }, rest)), label ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea_style_Label, {
      isActive,
      isFilled,
      isInvalid: invalid,
      children: label
    }) : null]
  });
}

/* harmony default export */ var components_TextArea_TextArea = (TextArea_TextArea);
// EXTERNAL MODULE: ./src/components/FormControl.tsx
var FormControl = __webpack_require__(98133);
;// CONCATENATED MODULE: ./src/components/TextArea/TextArea.formik.tsx


const TextArea_formik_excluded = ["className", "name", "id", "parse", "error", "hideError", "clearErrorOnChange"];

function TextArea_formik_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextArea_formik_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextArea_formik_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextArea_formik_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function TextAreaFormik(_ref) {
  let {
    className,
    name,
    id,
    parse,
    error: customError,
    hideError,
    clearErrorOnChange
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextArea_formik_excluded);

  const [field, meta, helpers] = (0,formik_esm/* useField */.U$)({
    name
  });
  const error = (customError !== null && customError !== void 0 ? customError : meta.touched) ? meta.error : '';
  const {
    value,
    onChange,
    onBlur
  } = field;
  const {
    setError
  } = helpers;
  const handleChange = (0,react.useCallback)(event => {
    if (clearErrorOnChange) {
      setError('');
    }

    onChange(event);
  }, [clearErrorOnChange, onChange, setError]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
    className: className,
    error: error,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_TextArea_TextArea, TextArea_formik_objectSpread({
      id: id,
      invalid: Boolean(error),
      name: name,
      value: value,
      onBlur: onBlur,
      onChange: handleChange
    }, rest))
  });
}

/* harmony default export */ var TextArea_formik = (TextAreaFormik);
;// CONCATENATED MODULE: ./src/components/TextArea/index.ts


;// CONCATENATED MODULE: ./src/components/Forms/FeedbackForm/FeedbackRequest.tsx

const FeedbackRequest_excluded = ["isSubmitting", "isValid", "values", "dirty"];













function FeedbackRequest_validate(t, {
  phone,
  name
}) {
  const errors = {};

  if (!(0,form_helpers/* validatePhone */.a)(phone)) {
    errors.phone = t('forms.phone_error');
  }

  if (!phone) {
    errors.phone = t('forms.required');
  }

  if (!name) {
    errors.name = t('forms.required');
  }

  return errors;
}

const FeedbackRequest_hasFrontendValidationErrors = (t, values) => !!Object.keys(FeedbackRequest_validate(t, values)).length;

function FeedbackRequest({
  setFormClosed
}) {
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();

  function handleSubmit(values, formikHelpers) {
    return (0,requests/* sendFeedbackForm */.OX)(values).then(() => {
      setFormClosed();
      closeModalState();
      formikHelpers.setSubmitting(true);
    }).catch(() => {
      formikHelpers.setErrors({
        message: t('forms.unknown_error')
      });
      formikHelpers.setStatus({
        hasBackendError: true
      });
    }).finally(() => {
      formikHelpers.setSubmitting(false);
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FeedbackRequest_Body, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackRequest_Text, {
      children: t('leave_contacts')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      initialValues: {
        name: '',
        phone: '',
        message: ''
      },
      onSubmit: handleSubmit,
      validate: fields => FeedbackRequest_validate(t, fields),
      children: _ref => {
        let {
          isSubmitting,
          isValid,
          values,
          dirty
        } = _ref,
            props = (0,objectWithoutProperties/* default */.Z)(_ref, FeedbackRequest_excluded);

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "name",
              icon: "profile",
              placeholder: t('forms.name'),
              invalid: false,
              autoComplete: "off"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "phone",
              icon: "phone",
              placeholder: t('forms.phone'),
              invalid: false,
              autoComplete: "off"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTextArea, {
              placeholder: t('forms.message'),
              name: "message",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.C, {
            type: "submit",
            variant: "contained-primary-w100-f13",
            disabled: (!isValid || FeedbackRequest_hasFrontendValidationErrors(t, values)) && (0,form_helpers/* areAllErrorsVisible */.G)(props.errors, props.touched),
            children: t('forms.send'),
            loading: isSubmitting
          })]
        });
      }
    })]
  });
}

/* harmony default export */ var FeedbackForm_FeedbackRequest = (FeedbackRequest);
const FeedbackRequest_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackRequest__Text",
  componentId: "sc-1khu5f6-0"
})(["font-size:13px;line-height:20px;margin-bottom:20px;"]);
const FeedbackRequest_FormRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackRequest__FormRow",
  componentId: "sc-1khu5f6-1"
})(["margin-bottom:30px;"]);
const FeedbackRequest_Body = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackRequest__Body",
  componentId: "sc-1khu5f6-2"
})(["margin-top:20px;padding:0 15px;"]);
const StyledTextArea = (0,styled_components_browser_esm["default"])(TextArea_formik).withConfig({
  displayName: "FeedbackRequest__StyledTextArea",
  componentId: "sc-1khu5f6-3"
})(["textarea{height:160px;}"]);
;// CONCATENATED MODULE: ./src/components/Forms/FeedbackForm/FeedbackFormFooter.tsx











function FeedbackFormFooter({
  closeModal,
  innerProps
}) {
  const {
    0: isFormClosed,
    1: setFormClosed
  } = (0,react.useState)(false);
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FeedbackFormFooter_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackFormFooter_Header, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FeedbackFormFooter_HeaderBody, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackFormFooter_Title, {
          children: innerProps.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackFormFooter_Close, {
          onClick: () => {
            closeModal();
            setTimeout(() => closeModalState(), 350);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modals_close/* ReactComponent */.r, {})
        })]
      })
    }), isFormClosed ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessForm/* default */.Z, {
      title: t('forms,success_title'),
      textNote: t('forms.success_text'),
      text: t('forms.success_text_2')
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FeedbackForm_FeedbackRequest, {
      setFormClosed: () => setFormClosed(true)
    })]
  });
}

/* harmony default export */ var FeedbackForm_FeedbackFormFooter = (FeedbackFormFooter);
const FeedbackFormFooter_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackFormFooter__Container",
  componentId: "sc-1reiz6v-0"
})(["height:calc(var(--vh,1) * 100);min-width:100vw;padding-bottom:15px;background:#fff;flex-shrink:1;-webkit-overflow-scrolling:touch !important;overflow:auto !important;"]);
const FeedbackFormFooter_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackFormFooter__Header",
  componentId: "sc-1reiz6v-1"
})(["box-shadow:0 1px 6px 0 #d0d0d0;"]);
const FeedbackFormFooter_HeaderBody = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackFormFooter__HeaderBody",
  componentId: "sc-1reiz6v-2"
})(["position:relative;display:flex;align-items:center;justify-content:center;padding:0 15px;min-height:45px;"]); //

const FeedbackFormFooter_Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackFormFooter__Title",
  componentId: "sc-1reiz6v-3"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;text-align:center;"]);
const FeedbackFormFooter_Close = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeedbackFormFooter__Close",
  componentId: "sc-1reiz6v-4"
})(["cursor:pointer;position:absolute;right:15px;top:calc(50% - 8px);"]);
;// CONCATENATED MODULE: ./src/components/Forms/FeedbackForm/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/components/Feedback/Feedback.tsx








function Feedback() {
  const throwModal = (0,web_components_esm/* useModal */.dd)();
  const {
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Feedback_Component, {
    onClick: () => {
      setTimeout(() => {
        openModalState();
        throwModal(FeedbackForm_FeedbackFormFooter, {
          title: t('forms.write_message')
        }, {
          withAnimation: false,
          scrollLockDisabled: true
        });
      }, 0);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      children: t('forms.feedback')
    })
  });
}

/* harmony default export */ var Feedback_Feedback = (Feedback);
const Feedback_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Feedback__Component",
  componentId: "sc-9z2w9n-0"
})(["border:1px solid #860935;border-radius:6px;display:flex;align-items:center;justify-content:center;min-height:34px;max-width:290px;min-width:140px;cursor:pointer;button{width:auto;height:auto;color:#860935;font-weight:bold;font-size:11px;line-height:22px;}"]);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/components/Feedback/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/ContactUs.tsx







function ContactUs() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactUs_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Feedback_Feedback, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Callback_Callback, {})]
  });
}

/* harmony default export */ var ContactUs_ContactUs = (ContactUs);
const ContactUs_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ContactUs__Component",
  componentId: "sc-a6csg-0"
})(["max-width:320px;display:flex;justify-content:center;margin:0 auto 10px;"]);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/components/ContactUs/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/Contacts.tsx









function Contacts() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ContactsSection, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Contacts_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Phones_Phones, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUs_ContactUs, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(MapPointer_MapPointer, {})]
    })
  });
}

const ContactsSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__ContactsSection",
  componentId: "sc-1iy7ri4-0"
})(["border-bottom:1px solid ", ";& > div{display:flex;flex-direction:column;max-width:460px;margin:0 auto;}"], theme/* colors.grayDivider */.O9.grayDivider);
const Contacts_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Contacts__Wrapper",
  componentId: "sc-1iy7ri4-1"
})(["padding:0 15px;& > a > div:first-child{margin:0 auto 20px;}"]);
/* harmony default export */ var Contacts_Contacts = (Contacts);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Contacts/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/Footer/Arrow.icon/arrow.svg
function arrow_extends() { arrow_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_extends.apply(this, arguments); }



var arrow_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.313848 5.59999C0.713848 5.99999 1.31385 5.99999 1.71385 5.59999L4.91385 2.39999L8.21385 5.59999C8.61385 5.99999 9.21385 5.99999 9.61385 5.59999C9.81385 5.39999 9.91385 5.19999 9.91385 4.89999C9.91385 4.69999 9.81385 4.39999 9.61385 4.19999L5.61385 0.299994C5.21385 -0.100006 4.61385 -0.100006 4.21385 0.299994L0.213849 4.19999C-0.0861511 4.59999 -0.0861511 5.19999 0.313848 5.59999Z",
  fill: "black"
});

function SvgArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", arrow_extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrow_ref);
}

/* harmony default export */ var arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4zMTM4NDggNS41OTk5OUMwLjcxMzg0OCA1Ljk5OTk5IDEuMzEzODUgNS45OTk5OSAxLjcxMzg1IDUuNTk5OTlMNC45MTM4NSAyLjM5OTk5TDguMjEzODUgNS41OTk5OUM4LjYxMzg1IDUuOTk5OTkgOS4yMTM4NSA1Ljk5OTk5IDkuNjEzODUgNS41OTk5OUM5LjgxMzg1IDUuMzk5OTkgOS45MTM4NSA1LjE5OTk5IDkuOTEzODUgNC44OTk5OUM5LjkxMzg1IDQuNjk5OTkgOS44MTM4NSA0LjM5OTk5IDkuNjEzODUgNC4xOTk5OUw1LjYxMzg1IDAuMjk5OTk0QzUuMjEzODUgLTAuMTAwMDA2IDQuNjEzODUgLTAuMTAwMDA2IDQuMjEzODUgMC4yOTk5OTRMMC4yMTM4NDkgNC4xOTk5OUMtMC4wODYxNTExIDQuNTk5OTkgLTAuMDg2MTUxMSA1LjE5OTk5IDAuMzEzODQ4IDUuNTk5OTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/ListedLinks/ListedLinks.tsx









function ListedLinks({
  data,
  title
}) {
  const {
    0: arrowActive,
    1: setArrowActive
  } = (0,react.useState)(true);
  const {
    0: collapseHeight,
    1: setCollapseHeight
  } = (0,react.useState)(0);
  const collapseRef = (0,react.useRef)(null);

  const showServices = event => {
    setArrowActive(!arrowActive);
  };

  (0,react.useEffect)(() => {
    var _collapseRef$current;

    const size = collapseRef === null || collapseRef === void 0 ? void 0 : (_collapseRef$current = collapseRef.current) === null || _collapseRef$current === void 0 ? void 0 : _collapseRef$current.clientHeight;
    size && setCollapseHeight(size);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Trigger, {
      onClick: showServices,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowWrapper, {
        onClick: showServices,
        arrowActive: arrowActive,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgArrow, {})
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse, {
      arrowActive: arrowActive,
      ref: collapseRef,
      size: collapseHeight,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseContent, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListedLinks_List, {
          children: data === null || data === void 0 ? void 0 : data.map(({
            id,
            label,
            link
          }) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: link,
              children: label
            })
          }, id))
        })
      })
    })]
  });
}

const Trigger = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListedLinks__Trigger",
  componentId: "sc-1uml5sz-0"
})(["cursor:pointer;display:flex;justify-content:space-between;align-items:center;& > div{font-style:normal;font-weight:500;font-size:13px;line-height:18px;color:", ";}"], theme/* colors.black */.O9.black);
const ArrowWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListedLinks__ArrowWrapper",
  componentId: "sc-1uml5sz-1"
})(["display:inherit;cursor:pointer;transform:", ";transition:transform 0.2s linear;padding:0 2px;"], ({
  arrowActive
}) => arrowActive ? 'rotate(0deg)' : 'rotate(180deg)');
const ListedLinks_List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "ListedLinks__List",
  componentId: "sc-1uml5sz-2"
})(["& > li{font-size:13px;line-height:18px;}li:not(:first-child){margin-top:4px;}"]);
const Collapse = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListedLinks__Collapse",
  componentId: "sc-1uml5sz-3"
})(["transition:max-height 0.2s linear;overflow:hidden;", ";", ";"], ({
  size
}) => size ? 'max-height:' + (size + 'px;') : null, ({
  arrowActive
}) => !arrowActive ? 'max-height: 0' : null);
const CollapseContent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ListedLinks__CollapseContent",
  componentId: "sc-1uml5sz-4"
})(["margin-top:6px;"]);
/* harmony default export */ var ListedLinks_ListedLinks = (ListedLinks);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/ListedLinks/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Customers.tsx









function CustomerServices() {
  const footer = (0,store/* useTypedSelector */.ix)(state => (0,menus/* selectMenuItemListByAlias */.HC)(state, 'footer'));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Customers_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        children: footer && /*#__PURE__*/(0,jsx_runtime.jsx)(ListedLinks_ListedLinks, {
          data: footer[0].children,
          title: footer[0].label
        })
      })
    })
  });
}

const Customers_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Customers__Component",
  componentId: "sc-axl2gs-0"
})([""]);
const Section = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Customers__Section",
  componentId: "sc-axl2gs-1"
})(["padding:10px 0;border-bottom:1px solid ", ";"], theme/* colors.grayDivider */.O9.grayDivider);
/* harmony default export */ var Customers = (CustomerServices);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Catalog/Catalog.tsx









function Catalog() {
  var _footer$1$children, _footer$1$label;

  const footer = (0,store/* useTypedSelector */.ix)(state => (0,menus/* selectMenuItemListByAlias */.HC)(state, 'footer'));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Section, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListedLinks_ListedLinks, {
          data: (_footer$1$children = footer === null || footer === void 0 ? void 0 : footer[1].children) !== null && _footer$1$children !== void 0 ? _footer$1$children : [],
          title: (_footer$1$label = footer === null || footer === void 0 ? void 0 : footer[1].label) !== null && _footer$1$label !== void 0 ? _footer$1$label : ''
        })
      })
    })
  });
}

const Catalog_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Component",
  componentId: "sc-1isu9nh-0"
})([""]);
const Catalog_Section = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Catalog__Section",
  componentId: "sc-1isu9nh-1"
})(["padding:10px 0;border-bottom:1px solid ", ";"], theme/* colors.grayDivider */.O9.grayDivider);
/* harmony default export */ var Catalog_Catalog = (Catalog);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Catalog/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/Footer/Monitor.icon/monitor.svg
function monitor_extends() { monitor_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return monitor_extends.apply(this, arguments); }



var monitor_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H5V14H3C2.4 14 2 14.4 2 15C2 15.6 2.4 16 3 16H13C13.6 16 14 15.6 14 15C14 14.4 13.6 14 13 14H11V12H14C15.1 12 16 11.1 16 10V2C16 0.9 15.1 0 14 0ZM9 14H7V12H9V14ZM14 10H2V2H14V10Z",
  fill: "black"
});

function SvgMonitor({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", monitor_extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, monitor_ref);
}

/* harmony default export */ var monitor = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAwSDJDMC45IDAgMCAwLjkgMCAyVjEwQzAgMTEuMSAwLjkgMTIgMiAxMkg1VjE0SDNDMi40IDE0IDIgMTQuNCAyIDE1QzIgMTUuNiAyLjQgMTYgMyAxNkgxM0MxMy42IDE2IDE0IDE1LjYgMTQgMTVDMTQgMTQuNCAxMy42IDE0IDEzIDE0SDExVjEySDE0QzE1LjEgMTIgMTYgMTEuMSAxNiAxMFYyQzE2IDAuOSAxNS4xIDAgMTQgMFpNOSAxNEg3VjEySDlWMTRaTTE0IDEwSDJWMkgxNFYxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=");

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Desktop/Desktop.tsx










function Desktop() {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopLinkSection, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Desktop_Component, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Desktop_Icon, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgMonitor, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: "https://dverione.com.ua",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: t('full_link')
          })
        })]
      })
    })
  });
}

/* harmony default export */ var Desktop_Desktop = (Desktop);
const Desktop_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Desktop__Component",
  componentId: "sc-iyvg9u-0"
})(["cursor:pointer;display:inline-flex;align-items:center;font-weight:500;font-size:12px;line-height:18px;color:", ";"], theme/* colors.black100 */.O9.black100);
const DesktopLinkSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Desktop__DesktopLinkSection",
  componentId: "sc-iyvg9u-1"
})(["padding:10px 0;border-bottom:1px solid ", ";"], theme/* colors.grayDivider */.O9.grayDivider);
const Desktop_Icon = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Desktop__Icon",
  componentId: "sc-iyvg9u-2"
})(["display:flex;align-items:center;justify-content:center;margin-right:10px;div{font-style:normal;font-weight:normal;font-size:12px;line-height:18px;color:", ";}"], theme/* colors.black */.O9.black);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Desktop/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/About/About.tsx







function About() {
  const about = (0,hooks/* useSettingItem */.qT)('FOOTER_COPYRIGHT');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(About_DesktopLinkSection, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AboutDescription, {
        children: about
      })
    })
  });
}

const About_DesktopLinkSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "About__DesktopLinkSection",
  componentId: "sc-1grlwq8-0"
})(["padding:10px 0 5px;border-bottom:1px solid ", ";"], theme/* colors.grayDivider */.O9.grayDivider);
const AboutDescription = styled_components_browser_esm["default"].span.withConfig({
  displayName: "About__AboutDescription",
  componentId: "sc-1grlwq8-1"
})(["font-style:normal;font-weight:normal;font-size:11px;line-height:18px;color:", ";"], theme/* colors.black */.O9.black);
/* harmony default export */ var About_About = (About);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/About/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Tager/TagerInfo.tsx





function TagerInfo() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TagerInfo_Component, {});
}

/* harmony default export */ var Tager_TagerInfo = (TagerInfo);
const TagerInfo_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TagerInfo__Component",
  componentId: "sc-1wp8m8g-0"
})(["padding:10px 0 5px;*{color:#000;font-size:13px;}span:hover b{color:", ";}span{cursor:pointer;}"], theme/* colors.darkRed */.O9.darkRed);
const Highlight = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TagerInfo__Highlight",
  componentId: "sc-1wp8m8g-1"
})(["font-weight:600;text-transform:uppercase;"]);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/components/Tager/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/Footer.tsx












function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Footer_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Contacts_Contacts, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Customers, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Catalog_Catalog, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop_Desktop, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(About_About, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Tager_TagerInfo, {})]
    })
  });
}

const Footer_Component = styled_components_browser_esm["default"].footer.withConfig({
  displayName: "Footer__Component",
  componentId: "sc-1qboum1-0"
})(["padding:15px 0 8px;margin-top:30px;background-color:", ";"], theme/* colors.grayFooterBack */.O9.grayFooterBack);
const Footer_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Footer__Content",
  componentId: "sc-1qboum1-1"
})([""]);
/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ./src/components/Layout/components/Footer/index.ts

;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx








function Layout({
  children
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Header_Header, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Footer, {})]
  });
}

/* harmony default export */ var Layout_Layout = (Layout);
const Layout_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Layout__Container",
  componentId: "sc-ehwo4c-0"
})(["background-color:", ";min-height:100vh;display:flex;flex-direction:column;width:100%;max-width:1260px;margin:0 auto;"], theme/* colors.white */.O9.white);
const Main = styled_components_browser_esm["default"].main.withConfig({
  displayName: "Layout__Main",
  componentId: "sc-ehwo4c-1"
})(["margin-top:45px;flex:1 0 auto;display:flex;flex-direction:column;@media (min-width:", "px){margin-top:80px;}@media (min-width:", "px){margin-top:70px;}@media (min-width:", "px){margin-top:60px;}"], theme/* breakpoints.laptop */.AV.laptop, theme/* breakpoints.tabletLarge */.AV.tabletLarge, theme/* breakpoints.tabletSmall */.AV.tabletSmall);

/***/ }),

/***/ 41880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(851);


/***/ }),

/***/ 3570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export linkConverter */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




const linkConverter = link => link;
const TagerLink = (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .createLinkComponent */ .Hw)({
  converter: linkConverter
});

const Link = props => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TagerLink, _objectSpread({}, props));

/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 38365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Mts_Mts; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
;// CONCATENATED MODULE: ./src/assets/svg/Footer/Mts.icon/Mts.logo.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M14 18H4C1.8 18 0 16.2 0 14V4C0 1.8 1.8 0 4 0H14C16.2 0 18 1.8 18 4V14C18 16.2 16.2 18 14 18Z",
  fill: "#E21E1E"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M13.5 10.2C13.5 12.6 12.1 15 9 15C5.9 15 4.5 12.6 4.5 10.2C4.5 6.8 6.9 3 9 3C11.1 3 13.5 6.8 13.5 10.2Z",
  fill: "white"
});

function SvgMtslogo({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

/* harmony default export */ var Mts_logo = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDE4SDRDMS44IDE4IDAgMTYuMiAwIDE0VjRDMCAxLjggMS44IDAgNCAwSDE0QzE2LjIgMCAxOCAxLjggMTggNFYxNEMxOCAxNi4yIDE2LjIgMTggMTQgMThaIiBmaWxsPSIjRTIxRTFFIi8+CjxwYXRoIGQ9Ik0xMy41IDEwLjJDMTMuNSAxMi42IDEyLjEgMTUgOSAxNUM1LjkgMTUgNC41IDEyLjYgNC41IDEwLjJDNC41IDYuOCA2LjkgMyA5IDNDMTEuMSAzIDEzLjUgNi44IDEzLjUgMTAuMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Mts/Mts.tsx








function Mts({
  title
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, {
      to: `tel:${title}`,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
        src: Mts_logo
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: title
      })]
    })
  });
}

/* harmony default export */ var Mts_Mts = (Mts);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Mts__Component",
  componentId: "sc-qbr8tj-0"
})(["cursor:pointer;display:flex;align-items:center;min-height:34px;min-width:140px;max-width:320px;img{height:18px;}span{font-style:normal;font-weight:600;font-size:11px;line-height:20px;margin-left:4px;white-space:nowrap;}& > a{display:flex;}"]);
;// CONCATENATED MODULE: ./src/components/Mts/index.ts


/***/ }),

/***/ 97377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ PlainPicture; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63394);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84229);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


const _excluded = ["src"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




const MEDIA_QUERY_LIST = [{
  name: 'desktop',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.desktop */ .AV.desktop
  })
}, {
  name: 'laptop',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.laptop */ .AV.laptop
  })
}, {
  name: 'tabletLarge',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tabletLarge */ .AV.tabletLarge
  })
}, {
  name: 'tabletSmall',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tabletSmall */ .AV.tabletSmall
  })
}, {
  name: 'mobileLarge',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: 480
  })
}, {
  name: 'mobileSmall',
  value: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createMediaQuery */ .Ne)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobileSmall */ .AV.mobileSmall
  })
}];
const BasePlainPicture = (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createPlainPictureComponent */ .yb)({
  mediaQueryList: MEDIA_QUERY_LIST
});
function PlainPicture(_ref) {
  let {
    src
  } = _ref,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BasePlainPicture, _objectSpread(_objectSpread({}, props), {}, {
    src: src === null || src === void 0 ? void 0 : src.replace('http://', 'https://')
  }));
}
const Picture = (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_1__/* .createPictureComponent */ .o4)({
  mediaQueryList: MEDIA_QUERY_LIST
});
/* harmony default export */ __webpack_exports__["Z"] = (Picture);

/***/ }),

/***/ 63181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ convertLabel; },
/* harmony export */   "n": function() { return /* binding */ variantCssMap; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84229);


const AVAILABILITY_VARIANT = {
  AVAILABLE: 'AVAILABLE',
  ON_REQUEST: 'ON_REQUEST',
  OUT_OF_ORDER: 'OUT_OF_ORDER',
  'PRE-ORDER': 'PRE-ORDER'
};
function convertLabel(t, availability) {
  switch (availability) {
    case AVAILABILITY_VARIANT.AVAILABLE:
      return t('orderType.in_stock');

    case AVAILABILITY_VARIANT.ON_REQUEST:
      return t('orderType.to_order');

    case AVAILABILITY_VARIANT.OUT_OF_ORDER:
      return t('orderType.out_of_stock');

    case AVAILABILITY_VARIANT['PRE-ORDER']:
      return t('orderType.pre_order');

    default:
      return null;
  }
}
const variantCssMap = {
  AVAILABLE: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(["color:", ";"], _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.green */ .O9.green),
  ON_REQUEST: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(["color:", ";"], _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.red */ .O9.red),
  OUT_OF_ORDER: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(["color:", ";"], _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray300 */ .O9.gray300),
  'PRE-ORDER': (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(["color:", ";"], _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.black */ .O9.black)
};

/***/ }),

/***/ 12199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SocialMediaLink_SocialMediaLink; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
;// CONCATENATED MODULE: ./src/assets/svg/Menu/viber.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#7B519D"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M28.8186 24.8403C28.2133 24.3561 27.487 23.8719 26.7607 23.3877C25.4292 22.4193 24.2187 22.4193 23.1293 23.8719C22.524 24.7192 21.7977 24.7192 20.9504 24.3561C18.6504 23.2666 16.9558 21.693 15.8663 19.393C15.3821 18.4247 15.3821 17.4563 16.4716 16.73C17.0768 16.3668 17.561 15.8826 17.561 15.0353C17.561 13.9458 14.8979 10.3144 13.8085 9.83017C13.3243 9.70913 12.9611 9.70913 12.4769 9.83017C10.056 10.6775 8.96652 12.7354 9.93491 15.0353C12.8401 22.1772 18.0452 27.1402 25.066 30.1664C25.4292 30.2875 25.9134 30.4085 26.1555 30.5296C27.7291 30.5296 29.6659 28.9559 30.1501 27.5033C30.7553 26.1718 29.6659 25.5665 28.8186 24.8403Z",
  fill: "#F1F2F2"
});

var _ref3 = /*#__PURE__*/react.createElement("path", {
  d: "M20.8293 10.4354C26.0344 11.2828 28.3344 13.7037 29.0607 18.9089C29.1817 19.393 28.9396 20.1193 29.6659 20.1193C30.3922 20.1193 30.1501 19.393 30.2711 18.9089C30.3922 14.0669 26.0344 9.46703 21.0714 9.34598C20.7083 9.34598 19.982 9.10388 19.8609 9.95122C19.7399 10.4354 20.4662 10.3144 20.8293 10.4354Z",
  fill: "#F1F2F2"
});

var _ref4 = /*#__PURE__*/react.createElement("path", {
  d: "M21.9188 11.888C21.4346 11.888 20.7083 11.6459 20.7083 12.2512C20.5872 12.9774 21.3135 12.8564 21.7977 12.9774C24.945 13.7037 26.1555 14.7932 26.6397 18.0615C26.7607 18.5457 26.5186 19.272 27.366 19.1509C27.9712 19.0299 27.7291 18.4247 27.7291 18.0615C27.6081 15.0353 25.066 12.2511 21.9188 11.888Z",
  fill: "#F1F2F2"
});

var _ref5 = /*#__PURE__*/react.createElement("path", {
  d: "M22.1609 14.309C21.7977 14.309 21.5556 14.309 21.4346 14.6721C21.1925 15.1563 21.6767 15.2774 22.0398 15.3984C23.3714 15.6405 24.0977 16.3668 24.2187 17.6984C24.2187 18.0615 24.4608 18.3036 24.8239 18.3036C25.3081 18.3036 25.3081 17.8194 25.3081 17.4563C25.1871 16.0037 23.6135 14.309 22.1609 14.309Z",
  fill: "#F1F2F2"
});

function SvgViber({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
}

/* harmony default export */ var viber = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/assets/svg/Menu/whatsapp.svg
function whatsapp_extends() { whatsapp_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return whatsapp_extends.apply(this, arguments); }



var whatsapp_ref = /*#__PURE__*/react.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#38B23B"
});

var whatsapp_ref2 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3333 22.1667C25.0833 22 23.75 21.3333 23.5 21.1667C23.25 21.0833 23.0833 21 22.8333 21.25C22.6667 21.5 22.0833 22.1667 21.9167 22.3333C21.75 22.5 21.5833 22.5 21.3333 22.4167C21.0833 22.25 20.1667 21.9167 19.1667 20.9167C18.3333 20.1667 17.8333 19.25 17.6667 18.9167C17.5 18.6667 17.6667 18.5 17.8333 18.3333C18 18.25 18.0833 18 18.25 17.8333C18.4167 17.6667 18.4167 17.5833 18.5833 17.4167C18.6667 17.25 18.6667 17.0833 18.5833 16.9167C18.5 16.75 18 15.4167 17.8333 14.8333C17.5833 14.25 17.4167 14.3333 17.25 14.3333C17.0833 14.3333 16.9167 14.3333 16.75 14.25C16.5833 14.25 16.25 14.3333 16 14.5833C15.75 14.8333 15 15.5 14.9167 16.8333C14.8333 18.1667 15.8333 19.5833 15.9167 19.75C16.0833 19.9167 17.75 22.9167 20.5 24.1667C23.25 25.4167 23.3333 25 23.8333 25C24.3333 25 25.5 24.4167 25.75 23.75C26 23.0833 26 22.5833 26 22.4167C25.75 22.4167 25.5833 22.3333 25.3333 22.1667ZM20.1667 28.8333C18.3333 28.8333 16.5833 28.25 15.1667 27.3333L11.6667 28.4167L12.8333 25.0833C11.75 23.5833 11.0833 21.75 11.0833 19.75C11.0833 14.75 15.1667 10.6667 20.1667 10.6667C25.1667 10.6667 29.25 14.75 29.25 19.75C29.25 24.75 25.25 28.8333 20.1667 28.8333ZM20.1667 8.83333C14.1667 8.83333 9.25 13.75 9.25 19.75C9.25 21.8333 9.83334 23.75 10.8333 25.4167L8.83334 31.25L14.8333 29.3333C16.4167 30.1667 18.1667 30.6667 20.0833 30.6667C26.0833 30.6667 31 25.75 31 19.75C31.0833 13.6667 26.25 8.83333 20.1667 8.83333Z",
  fill: "#F1F2F2"
});

function SvgWhatsapp({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", whatsapp_extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, whatsapp_ref, whatsapp_ref2);
}

/* harmony default export */ var whatsapp = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/assets/svg/Menu/telegram.svg
function telegram_extends() { telegram_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return telegram_extends.apply(this, arguments); }



var telegram_ref = /*#__PURE__*/react.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#40B0EF"
});

var telegram_ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M30.6667 12.1667C30.5833 12.6667 30.5 13.25 30.3333 13.8333C29.3333 18.5 28.3333 23.0833 27.4167 27.75C27.3333 28 27.3333 28.25 27.1667 28.5C26.9167 28.9167 26.5833 29 26.1667 28.9167C25.9167 28.8333 25.6667 28.75 25.4167 28.5833C23.9167 27.5 22.4167 26.4167 21 25.25C20.8333 25.0833 20.6667 25.0833 20.5833 25.25C19.8333 26 19.0833 26.6667 18.4167 27.4167C18.1667 27.6667 17.8333 27.8333 17.4167 27.8333C17.1667 27.8333 17 27.6667 16.9167 27.4167C16.5 26 16 24.5833 15.5 23.1667C15.3333 22.6667 15.1667 22.1667 15 21.75C14.9167 21.5833 14.8333 21.5 14.6667 21.4167C13.25 21 11.75 20.5 10.3333 20.0833C10.1667 20 9.91666 20 9.74999 19.8333C9.33333 19.5833 9.33333 19.25 9.66666 18.9167C9.91666 18.6667 10.25 18.5833 10.5 18.4167C12.5 17.6667 14.4167 16.9167 16.4167 16.1667C20.6667 14.5 24.9167 12.8333 29.25 11.25H29.3333C30.0833 10.8333 30.6667 11.25 30.6667 12.1667ZM17.25 26.5C17.3333 26.5 17.3333 26.4167 17.3333 26.3333C17.4167 25.25 17.5 24.25 17.5833 23.1667C17.5833 22.9167 17.6667 22.75 17.9167 22.5C20.6667 20 23.5 17.5 26.25 15C26.4167 14.8333 26.5833 14.6667 26.75 14.5C26.8333 14.4167 26.9167 14.3333 26.8333 14.25C26.75 14.1667 26.6667 14.1667 26.5833 14.1667C26.3333 14.1667 26.1667 14.3333 26 14.4167C22.5833 16.5833 19.1667 18.75 15.75 20.9167C15.5833 21 15.5 21.1667 15.5833 21.3333C16 22.5833 16.4167 23.8333 16.8333 25.1667C17 25.6667 17.1667 26.0833 17.25 26.5Z",
  fill: "#FEFEFE"
});

function SvgTelegram({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", telegram_extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, telegram_ref, telegram_ref2);
}

/* harmony default export */ var telegram = ("data:image/svg+xml;base64,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");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SocialMediaLink/SocialMediaLink.tsx








function SocialMediaLink({
  type,
  reference
}) {
  switch (type) {
    case 'Viber':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: `viber://add?number=${reference}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgViber, {})
        })
      });

    case 'Telegram':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: `https://t.me/${reference}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgTelegram, {})
        })
      });

    case 'WhatsUp':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: `https://wa.me/${reference}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgWhatsapp, {})
        })
      });

    default:
      return null;
  }
}

const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SocialMediaLink__Component",
  componentId: "sc-7n9mry-0"
})([""]);
/* harmony default export */ var SocialMediaLink_SocialMediaLink = (SocialMediaLink);
;// CONCATENATED MODULE: ./src/components/SocialMediaLink/index.ts


/***/ }),

/***/ 66595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Overlay; },
  "Z": function() { return /* reexport */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Spinner/Spinner.tsx





function Overlay({
  className,
  children
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OverlayBlock, {
    className: className,
    children: children
  });
}

function Spinner({
  className,
  absolute = true,
  text,
  color = 'primary'
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    className: className,
    absolute: absolute,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Circle, {
      color: color
    }), text ? /*#__PURE__*/(0,jsx_runtime.jsx)(StatusText, {
      children: text
    }) : null]
  });
}

const spin = (0,styled_components_browser_esm.keyframes)(["from{transform:rotate(0)}to{transform:rotate(360deg)}"]);
const colorMap = {
  primary: '#860935',
  gray: '#a8a8a8'
};
const Circle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Spinner__Circle",
  componentId: "sc-10amw1v-0"
})(["display:block;width:25px;height:25px;margin:0 auto;border:3px solid ", ";border-top:3px solid ", ";border-radius:50%;animation:", " 1s infinite linear;"], theme/* colors.gray */.O9.gray, props => colorMap[props.color], spin);
const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Spinner__Container",
  componentId: "sc-10amw1v-1"
})(["position:relative;z-index:5;", ";"], props => props.absolute ? (0,styled_components_browser_esm.css)(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]) : '');
const StatusText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Spinner__StatusText",
  componentId: "sc-10amw1v-2"
})(["display:block;font-weight:bold;margin-top:10px;"]);
const OverlayBlock = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Spinner__OverlayBlock",
  componentId: "sc-10amw1v-3"
})(["position:absolute;top:0;right:0;bottom:0;left:0;background-color:", ";z-index:10;border-radius:5px;"], theme/* colors.white */.O9.white);
/* harmony default export */ var Spinner_Spinner = (Spinner);
;// CONCATENATED MODULE: ./src/components/Spinner/index.ts



/***/ }),

/***/ 75901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ validatePhone; },
/* harmony export */   "G": function() { return /* binding */ areAllErrorsVisible; }
/* harmony export */ });
/* harmony import */ var libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97484);

function validatePhone(phone) {
  var _parsePhoneNumber, _parsePhoneNumber2;

  return !!((_parsePhoneNumber = (0,libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(phone, 'BY')) !== null && _parsePhoneNumber !== void 0 && _parsePhoneNumber.isValid() || (_parsePhoneNumber2 = (0,libphonenumber_js_max__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(phone, 'RU')) !== null && _parsePhoneNumber2 !== void 0 && _parsePhoneNumber2.isValid());
}
const areAllErrorsVisible = (errors, touched) => Object.keys(errors).every(name => !!touched[name]);

/***/ }),

/***/ 28560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ TextInput_formik; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svg/cart_calc.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M15.880,4.392 L14.884,9.392 C14.698,10.327 13.881,11.000 12.932,11.000 L3.971,11.000 C2.871,11.000 1.980,10.104 1.980,9.000 L1.980,4.000 L1.980,2.000 L0.984,2.000 C0.434,2.000 -0.012,1.552 -0.012,1.000 C-0.012,0.447 0.434,-0.000 0.984,-0.000 L2.975,-0.000 C3.525,-0.000 3.971,0.447 3.971,1.000 L3.971,2.000 L13.927,2.000 C14.524,2.000 15.089,2.268 15.467,2.732 C15.846,3.195 15.997,3.804 15.880,4.392 ZM3.971,4.000 L3.971,9.000 L12.932,9.000 L13.927,4.000 L3.971,4.000 ZM2.975,12.000 C4.075,12.000 4.967,12.895 4.967,14.000 C4.967,15.104 4.075,16.000 2.975,16.000 C1.875,16.000 0.984,15.104 0.984,14.000 C0.984,12.895 1.875,12.000 2.975,12.000 ZM12.932,12.000 C14.031,12.000 14.923,12.895 14.923,14.000 C14.923,15.104 14.031,16.000 12.932,16.000 C11.832,16.000 10.940,15.104 10.940,14.000 C10.940,12.895 11.832,12.000 12.932,12.000 Z"
});

function SvgCartCalc({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    fill: "rgb(0, 0, 0)",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var cart_calc = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIGZpbGw9InJnYigwLCAwLCAwKSI+CiAgPHBhdGggZD0iTTE1Ljg4MCw0LjM5MiBMMTQuODg0LDkuMzkyIEMxNC42OTgsMTAuMzI3IDEzLjg4MSwxMS4wMDAgMTIuOTMyLDExLjAwMCBMMy45NzEsMTEuMDAwIEMyLjg3MSwxMS4wMDAgMS45ODAsMTAuMTA0IDEuOTgwLDkuMDAwIEwxLjk4MCw0LjAwMCBMMS45ODAsMi4wMDAgTDAuOTg0LDIuMDAwIEMwLjQzNCwyLjAwMCAtMC4wMTIsMS41NTIgLTAuMDEyLDEuMDAwIEMtMC4wMTIsMC40NDcgMC40MzQsLTAuMDAwIDAuOTg0LC0wLjAwMCBMMi45NzUsLTAuMDAwIEMzLjUyNSwtMC4wMDAgMy45NzEsMC40NDcgMy45NzEsMS4wMDAgTDMuOTcxLDIuMDAwIEwxMy45MjcsMi4wMDAgQzE0LjUyNCwyLjAwMCAxNS4wODksMi4yNjggMTUuNDY3LDIuNzMyIEMxNS44NDYsMy4xOTUgMTUuOTk3LDMuODA0IDE1Ljg4MCw0LjM5MiBaTTMuOTcxLDQuMDAwIEwzLjk3MSw5LjAwMCBMMTIuOTMyLDkuMDAwIEwxMy45MjcsNC4wMDAgTDMuOTcxLDQuMDAwIFpNMi45NzUsMTIuMDAwIEM0LjA3NSwxMi4wMDAgNC45NjcsMTIuODk1IDQuOTY3LDE0LjAwMCBDNC45NjcsMTUuMTA0IDQuMDc1LDE2LjAwMCAyLjk3NSwxNi4wMDAgQzEuODc1LDE2LjAwMCAwLjk4NCwxNS4xMDQgMC45ODQsMTQuMDAwIEMwLjk4NCwxMi44OTUgMS44NzUsMTIuMDAwIDIuOTc1LDEyLjAwMCBaTTEyLjkzMiwxMi4wMDAgQzE0LjAzMSwxMi4wMDAgMTQuOTIzLDEyLjg5NSAxNC45MjMsMTQuMDAwIEMxNC45MjMsMTUuMTA0IDE0LjAzMSwxNi4wMDAgMTIuOTMyLDE2LjAwMCBDMTEuODMyLDE2LjAwMCAxMC45NDAsMTUuMTA0IDEwLjk0MCwxNC4wMDAgQzEwLjk0MCwxMi44OTUgMTEuODMyLDEyLjAwMCAxMi45MzIsMTIuMDAwIFoiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/profile.svg
function profile_extends() { profile_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return profile_extends.apply(this, arguments); }



var profile_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  d: "M11.757,8.263 C12.521,7.385 13.000,6.252 13.000,5.000 C13.000,2.243 10.757,-0.000 8.000,-0.000 C5.243,-0.000 3.000,2.243 3.000,5.000 C3.000,6.252 3.479,7.385 4.243,8.263 C1.789,9.017 -0.000,11.303 -0.000,14.000 C-0.000,15.104 0.895,16.000 2.000,16.000 L12.000,16.000 L14.000,16.000 C15.104,16.000 16.000,15.104 16.000,14.000 C16.000,11.303 14.210,9.017 11.757,8.263 ZM8.000,2.000 C9.660,2.000 11.000,3.340 11.000,5.000 C11.000,6.660 9.660,8.000 8.000,8.000 C6.340,8.000 5.000,6.660 5.000,5.000 C5.000,3.340 6.340,2.000 8.000,2.000 ZM12.000,14.000 L2.000,14.000 C2.000,11.790 3.791,10.000 6.000,10.000 L10.000,10.000 C12.209,10.000 14.000,11.790 14.000,14.000 L12.000,14.000 Z"
});

function SvgProfile({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", profile_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    fill: "rgb(134, 9, 53)",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, profile_ref);
}

/* harmony default export */ var profile = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIGZpbGw9InJnYigxMzQsIDksIDUzKSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICBkPSJNMTEuNzU3LDguMjYzIEMxMi41MjEsNy4zODUgMTMuMDAwLDYuMjUyIDEzLjAwMCw1LjAwMCBDMTMuMDAwLDIuMjQzIDEwLjc1NywtMC4wMDAgOC4wMDAsLTAuMDAwIEM1LjI0MywtMC4wMDAgMy4wMDAsMi4yNDMgMy4wMDAsNS4wMDAgQzMuMDAwLDYuMjUyIDMuNDc5LDcuMzg1IDQuMjQzLDguMjYzIEMxLjc4OSw5LjAxNyAtMC4wMDAsMTEuMzAzIC0wLjAwMCwxNC4wMDAgQy0wLjAwMCwxNS4xMDQgMC44OTUsMTYuMDAwIDIuMDAwLDE2LjAwMCBMMTIuMDAwLDE2LjAwMCBMMTQuMDAwLDE2LjAwMCBDMTUuMTA0LDE2LjAwMCAxNi4wMDAsMTUuMTA0IDE2LjAwMCwxNC4wMDAgQzE2LjAwMCwxMS4zMDMgMTQuMjEwLDkuMDE3IDExLjc1Nyw4LjI2MyBaTTguMDAwLDIuMDAwIEM5LjY2MCwyLjAwMCAxMS4wMDAsMy4zNDAgMTEuMDAwLDUuMDAwIEMxMS4wMDAsNi42NjAgOS42NjAsOC4wMDAgOC4wMDAsOC4wMDAgQzYuMzQwLDguMDAwIDUuMDAwLDYuNjYwIDUuMDAwLDUuMDAwIEM1LjAwMCwzLjM0MCA2LjM0MCwyLjAwMCA4LjAwMCwyLjAwMCBaTTEyLjAwMCwxNC4wMDAgTDIuMDAwLDE0LjAwMCBDMi4wMDAsMTEuNzkwIDMuNzkxLDEwLjAwMCA2LjAwMCwxMC4wMDAgTDEwLjAwMCwxMC4wMDAgQzEyLjIwOSwxMC4wMDAgMTQuMDAwLDExLjc5MCAxNC4wMDAsMTQuMDAwIEwxMi4wMDAsMTQuMDAwIFoiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/phone-1.svg
function phone_1_extends() { phone_1_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_1_extends.apply(this, arguments); }



var phone_1_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  d: "M15.898,11.630 L15.128,13.950 C14.951,14.484 14.556,14.919 14.042,15.148 C12.769,15.713 11.409,16.000 9.999,16.000 C7.507,16.000 5.118,15.077 3.279,13.406 C3.152,13.292 3.037,13.178 2.939,13.080 C2.360,12.514 1.853,11.871 1.440,11.183 C1.306,10.963 1.175,10.720 1.052,10.462 C0.352,9.078 -0.003,7.577 -0.003,6.000 C-0.003,4.591 0.283,3.231 0.849,1.958 C1.078,1.444 1.513,1.050 2.047,0.872 L4.367,0.102 C4.577,0.033 4.789,-0.000 4.998,-0.000 C5.835,-0.000 6.616,0.530 6.895,1.368 L7.896,4.368 C8.210,5.312 7.783,6.344 6.892,6.789 L6.165,7.153 C6.353,7.780 6.696,8.354 7.179,8.832 C7.649,9.306 8.220,9.647 8.846,9.833 L9.210,9.106 C9.556,8.412 10.259,8.000 10.999,8.000 C11.209,8.000 11.422,8.033 11.631,8.103 L14.632,9.103 C15.679,9.452 16.246,10.583 15.898,11.630 ZM13.999,11.000 L10.999,10.000 L9.999,12.000 C8.338,12.000 6.838,11.330 5.758,10.240 C4.667,9.160 3.997,7.660 3.997,6.000 L5.998,5.000 L4.998,2.000 L2.677,2.770 C2.237,3.760 1.997,4.850 1.997,6.000 C1.997,7.290 2.297,8.500 2.847,9.580 C2.937,9.770 3.037,9.960 3.147,10.140 C3.477,10.690 3.877,11.200 4.337,11.650 C4.428,11.740 4.518,11.830 4.618,11.920 C6.038,13.210 7.928,14.000 9.999,14.000 C11.149,14.000 12.239,13.760 13.229,13.320 L13.999,11.000 Z"
});

function SvgPhone1({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", phone_1_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    fill: "rgb(134, 9, 53)",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, phone_1_ref);
}

/* harmony default export */ var phone_1 = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIGZpbGw9InJnYigxMzQsIDksIDUzKSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICBkPSJNMTUuODk4LDExLjYzMCBMMTUuMTI4LDEzLjk1MCBDMTQuOTUxLDE0LjQ4NCAxNC41NTYsMTQuOTE5IDE0LjA0MiwxNS4xNDggQzEyLjc2OSwxNS43MTMgMTEuNDA5LDE2LjAwMCA5Ljk5OSwxNi4wMDAgQzcuNTA3LDE2LjAwMCA1LjExOCwxNS4wNzcgMy4yNzksMTMuNDA2IEMzLjE1MiwxMy4yOTIgMy4wMzcsMTMuMTc4IDIuOTM5LDEzLjA4MCBDMi4zNjAsMTIuNTE0IDEuODUzLDExLjg3MSAxLjQ0MCwxMS4xODMgQzEuMzA2LDEwLjk2MyAxLjE3NSwxMC43MjAgMS4wNTIsMTAuNDYyIEMwLjM1Miw5LjA3OCAtMC4wMDMsNy41NzcgLTAuMDAzLDYuMDAwIEMtMC4wMDMsNC41OTEgMC4yODMsMy4yMzEgMC44NDksMS45NTggQzEuMDc4LDEuNDQ0IDEuNTEzLDEuMDUwIDIuMDQ3LDAuODcyIEw0LjM2NywwLjEwMiBDNC41NzcsMC4wMzMgNC43ODksLTAuMDAwIDQuOTk4LC0wLjAwMCBDNS44MzUsLTAuMDAwIDYuNjE2LDAuNTMwIDYuODk1LDEuMzY4IEw3Ljg5Niw0LjM2OCBDOC4yMTAsNS4zMTIgNy43ODMsNi4zNDQgNi44OTIsNi43ODkgTDYuMTY1LDcuMTUzIEM2LjM1Myw3Ljc4MCA2LjY5Niw4LjM1NCA3LjE3OSw4LjgzMiBDNy42NDksOS4zMDYgOC4yMjAsOS42NDcgOC44NDYsOS44MzMgTDkuMjEwLDkuMTA2IEM5LjU1Niw4LjQxMiAxMC4yNTksOC4wMDAgMTAuOTk5LDguMDAwIEMxMS4yMDksOC4wMDAgMTEuNDIyLDguMDMzIDExLjYzMSw4LjEwMyBMMTQuNjMyLDkuMTAzIEMxNS42NzksOS40NTIgMTYuMjQ2LDEwLjU4MyAxNS44OTgsMTEuNjMwIFpNMTMuOTk5LDExLjAwMCBMMTAuOTk5LDEwLjAwMCBMOS45OTksMTIuMDAwIEM4LjMzOCwxMi4wMDAgNi44MzgsMTEuMzMwIDUuNzU4LDEwLjI0MCBDNC42NjcsOS4xNjAgMy45OTcsNy42NjAgMy45OTcsNi4wMDAgTDUuOTk4LDUuMDAwIEw0Ljk5OCwyLjAwMCBMMi42NzcsMi43NzAgQzIuMjM3LDMuNzYwIDEuOTk3LDQuODUwIDEuOTk3LDYuMDAwIEMxLjk5Nyw3LjI5MCAyLjI5Nyw4LjUwMCAyLjg0Nyw5LjU4MCBDMi45MzcsOS43NzAgMy4wMzcsOS45NjAgMy4xNDcsMTAuMTQwIEMzLjQ3NywxMC42OTAgMy44NzcsMTEuMjAwIDQuMzM3LDExLjY1MCBDNC40MjgsMTEuNzQwIDQuNTE4LDExLjgzMCA0LjYxOCwxMS45MjAgQzYuMDM4LDEzLjIxMCA3LjkyOCwxNC4wMDAgOS45OTksMTQuMDAwIEMxMS4xNDksMTQuMDAwIDEyLjIzOSwxMy43NjAgMTMuMjI5LDEzLjMyMCBMMTMuOTk5LDExLjAwMCBaIi8+Cjwvc3ZnPgo=");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.style.ts


const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextInputstyle__Container",
  componentId: "sc-zrwvxn-0"
})(["position:relative;"]);

function getBorderColor(props = {}) {
  return props.invalid ? theme/* colors.red */.O9.red : props.active ? theme/* colors.gray500 */.O9.gray500 : theme/* colors.gray200 */.O9.gray200;
}

const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "TextInputstyle__Input",
  componentId: "sc-zrwvxn-1"
})(["width:100%;border:1px solid ", ";font-size:13px;line-height:24px;padding:7px 13px;border-radius:5px;", ";color:", ";&::placeholder{color:", ";opacity:0.5;}&:focus{border-color:", ";}"], ({
  invalid
}) => getBorderColor({
  invalid
}), props => props.withIcon ? (0,styled_components_browser_esm.css)(["padding-left:45px;"]) : '', props => props.invalid ? theme/* colors.red */.O9.red : theme/* colors.black */.O9.black, props => props.invalid ? theme/* colors.red */.O9.red : theme/* colors.black */.O9.black, ({
  invalid,
  readOnly
}) => getBorderColor({
  invalid,
  active: !readOnly
}));
const prefixCss = (0,styled_components_browser_esm.css)(["position:absolute;top:50%;transform:translateY(-50%);left:16px;pointer-events:none;fill:", ";"], theme/* colors.primary */.O9.primary);
const IconComponent = styled_components_browser_esm["default"].svg.withConfig({
  displayName: "TextInputstyle__IconComponent",
  componentId: "sc-zrwvxn-2"
})(["", ";"], prefixCss);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.tsx


const _excluded = ["className", "disabled", "invalid", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function getIconComponent(icon) {
  switch (icon) {
    case 'cart':
      return SvgCartCalc;

    case 'profile':
      return SvgProfile;

    case 'phone':
      return SvgPhone1;

    default:
      return null;
  }
}

function TextInput(_ref, ref) {
  let {
    className,
    disabled,
    invalid,
    icon
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const Icon = getIconComponent(icon);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    className: className,
    children: [Icon ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconComponent, {
      as: Icon
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Input, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      withIcon: Boolean(icon),
      disabled: disabled,
      invalid: invalid
    }))]
  });
}

/* harmony default export */ var TextInput_TextInput = (/*#__PURE__*/react.forwardRef(TextInput));
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/FormControl.tsx
var FormControl = __webpack_require__(98133);
;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.formik.tsx


const TextInput_formik_excluded = ["className", "name", "id", "parse", "error", "type", "hideError"];

function TextInput_formik_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextInput_formik_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextInput_formik_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextInput_formik_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function TextInputFormik(_ref) {
  let {
    className,
    name,
    id,
    parse,
    error: customError,
    type = 'text',
    hideError
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextInput_formik_excluded);

  const [field, meta, helpers] = (0,formik_esm/* useField */.U$)({
    name,
    type
  });
  const error = (customError !== null && customError !== void 0 ? customError : meta.touched) ? meta.error : '';
  const {
    value,
    onChange,
    onBlur
  } = field;
  const {
    setValue
  } = helpers;
  const handleChange = (0,react.useCallback)(event => {
    if (parse) {
      const parsedValue = parse(event.target.value, value);

      if (parsedValue !== value) {
        setValue(parsedValue);
      }
    } else {
      onChange(event);
    }
  }, [parse, value, setValue, onChange]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
    className: className,
    error: error,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput_TextInput, TextInput_formik_objectSpread({
      id: id,
      invalid: Boolean(error),
      name: name,
      type: type,
      value: value,
      onBlur: onBlur,
      onChange: handleChange
    }, rest))
  });
}

/* harmony default export */ var TextInput_formik = (TextInputFormik);
;// CONCATENATED MODULE: ./src/components/TextInput/index.ts



/***/ }),

/***/ 84229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O9": function() { return /* binding */ colors; },
/* harmony export */   "AV": function() { return /* binding */ breakpoints; }
/* harmony export */ });
/* unused harmony export fonts */
const colors = {
  white: '#fff',
  black: 'black',
  black100: '#101010',
  black200: '#262626',
  black300: '#3b3b3b',
  gray: '#f5f5f5',
  gray50: '#EFEFEF',
  gray100: '#e9e9e9',
  gray182: '#b6b6b6',
  gray200: '#d2d2d2',
  gray300: '#a8a8a8',
  gray400: '#5a5a5a',
  gray500: '#666666',
  gray237: '#EDEDED',
  gray700: '#6A6A6A',
  gray800: '#E6E6E6',
  gray900: '#626262',
  grayDark: '#5f5f5f',
  grayLight: '#999999',
  grayDivider: '#dadada',
  gray70: '#c6c6c6',
  grayLighter: '#E5E5E5',
  grayBackground: '#ECECEC',
  grayCart: '#f0f0f0',
  grayProductCard: '#e9e9e9',
  grayFooterBack: '#f6f6f6',
  darkGrey: '#686868',
  green: '#36ba5f',
  red: 'red',
  darkRed: '#860935',
  primary: 'var(--main-color, #860935)',
  primary100: 'var(--main-color-hover, #6a072a)'
};
/** Source: https://htmlacademy.ru/blog/useful/css/short-14 */

const fallbackFont = ['-apple-system', "'BlickMacSystemFont'", "'Segoe UI'", "'Roboto'", "'Oxygen'", "'Ubuntu'", "'Cantarell'", "'Fira Sans'", "'Droid Sans'", "'Helvetica Neue'", 'sans-serif'].join(',');
const fonts = {
  Montserrat: `'Montserrat', ${fallbackFont}`
};
/**
 * Reference - Screen Resolution Stats Worldwide:
 * https://gs.statcounter.com/screen-resolution-stats
 *
 * 16px - scrollbar width on Windows,
 * some browsers doesn't include scrollbar width when calculate media queries
 */

const breakpoints = {
  /** iPhone 5/SE */
  mobileSmall: 320,

  /** iPhone 6/7/8/X */
  mobileMedium: 375,

  /** iPhone 6/7/8 Plus */
  mobileLarge: 414,

  /** iPad 1, 2, Mini and Air */
  tabletSmall: 768,
  tabletLarge: 1024,

  /** 1280 - 16 = 1264 -> 1260 - more beautiful number :) */
  laptop: 1260,

  /** 1536 - 16 = 1520 -> 1500 - more beautiful number :) */
  desktop: 1500
};

/***/ }),

/***/ 88619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wo": function() { return /* reexport */ useCurrentPage/* useCurrentPage */.W; },
  "JP": function() { return /* reexport */ useLayoutPage; },
  "iX": function() { return /* reexport */ useMenuItem; },
  "qT": function() { return /* reexport */ useSettingItem; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/store/reducers/tager/pages.ts
var pages = __webpack_require__(55724);
// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
;// CONCATENATED MODULE: ./src/hooks/useLayoutPage.ts




function useLayoutPage() {
  const router = (0,next_router.useRouter)();
  const currentPath = (0,common/* convertSlugToPath */.L1)(router.query.slug);
  return (0,store/* useTypedSelector */.ix)(state => (0,pages/* selectPageByPath */.uK)(state, currentPath));
}
// EXTERNAL MODULE: ./src/hooks/useCurrentPage.ts
var useCurrentPage = __webpack_require__(47715);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/store/reducers/tager/settings.ts
var settings = __webpack_require__(35439);
;// CONCATENATED MODULE: ./src/hooks/useSettingItem.ts



function useSettingItem(key) {
  const settingItemList = (0,store/* useTypedSelector */.ix)(settings/* selectSettingItemList */.SR);
  return (0,web_modules_esm/* getSettingValueByKey */.Un)(settingItemList, key);
}
// EXTERNAL MODULE: ./src/store/reducers/tager/menus.ts
var menus = __webpack_require__(67463);
;// CONCATENATED MODULE: ./src/hooks/useMenuItem.ts


function useMenuItem(key) {
  return (0,store/* useTypedSelector */.ix)(state => (0,menus/* selectMenuItemListByAlias */.HC)(state, key));
}
;// CONCATENATED MODULE: ./src/hooks/index.ts





/***/ }),

/***/ 35535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useBodyPositionFixed; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useModalsOpen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73637);


function useBodyPositionFixed() {
  const {
    closeModalState,
    openModalState
  } = (0,_hooks_useModalsOpen__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const body = document.body;
    const offsetY = window.pageYOffset;
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';
    body.style.top = 'offsetYpx';
    openModalState();
    return () => {
      body.style.position = '';
      body.style.overflow = '';
      window.scrollTo(0, offsetY);
      closeModalState();
    };
  }, [closeModalState, openModalState]);
}

/***/ }),

/***/ 47715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useCurrentPage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var _store_reducers_tager_pages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55724);
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11402);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29116);




function useCurrentPage() {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  const currentPath = (0,_utils_common__WEBPACK_IMPORTED_MODULE_3__/* .convertSlugToPath */ .L1)(router.query.slug);
  const foundPage = (0,_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useTypedSelector */ .ix)(state => (0,_store_reducers_tager_pages__WEBPACK_IMPORTED_MODULE_1__/* .selectPageByPath */ .uK)(state, currentPath));

  if (!foundPage) {
    throw new Error(`Page not found: ${currentPath}`);
  }

  return foundPage;
}

/***/ }),

/***/ 73637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_ModalsOpenProvider_ModalsOpenProvider_ModalsOpenState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59180);



function UseModalsOpen() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_ModalsOpenProvider_ModalsOpenProvider_ModalsOpenState__WEBPACK_IMPORTED_MODULE_1__/* .ModalsOpenStateContext */ .P);

  if (!context) {
    throw new Error('use only provider hook');
  }

  return context;
}

/* harmony default export */ __webpack_exports__["Z"] = (UseModalsOpen);

/***/ }),

/***/ 77771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MenuItemTypes; },
/* harmony export */   "p": function() { return /* binding */ AvailabilityStatus; }
/* harmony export */ });
let MenuItemTypes;

(function (MenuItemTypes) {
  MenuItemTypes["Top"] = "top";
  MenuItemTypes["Main"] = "main";
  MenuItemTypes["Footer"] = "footer";
  MenuItemTypes["Catalog"] = "catalog";
})(MenuItemTypes || (MenuItemTypes = {}));

let AvailabilityStatus;

(function (AvailabilityStatus) {
  AvailabilityStatus["AVAILABLE"] = "AVAILABLE";
  AvailabilityStatus["ON_REQUEST"] = "ON_REQUEST";
  AvailabilityStatus["OUT_OF_ORDER"] = "OUT_OF_ORDER";
  AvailabilityStatus["PRE_ORDER"] = "PRE-ORDER";
})(AvailabilityStatus || (AvailabilityStatus = {}));

/***/ }),

/***/ 26542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ media; }
/* harmony export */ });
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63394);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84229);


/**
 * Reference: https://get.foundation/sites/docs/media-queries.html#working-with-media-queries
 *
 * Media queries name convention: {breakpoint + modifier}
 * Modifiers: "up" | "only" | "down" (default)
 * "down" is default modifier, because we use desktop-first approach
 *
 * Examples:
 *
 * "tablet", "tabletDown" - tablet or smaller
 * "tabletOnly" - only tablet
 * "tabletUp" - tablet or larger
 */

const media = {
  mobileSmall: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.mobileMedium */ .AV.mobileMedium
  }),
  mobileMedium: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.mobileLarge */ .AV.mobileLarge
  }),
  mobileMediumOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.mobileSmall */ .AV.mobileSmall,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.mobileLarge */ .AV.mobileLarge
  }),
  mobileLarge: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletSmall */ .AV.tabletSmall
  }),
  mobileLargeOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.mobileLarge */ .AV.mobileLarge,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletSmall */ .AV.tabletSmall
  }),
  mobile: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletSmall */ .AV.tabletSmall
  }),
  tabletSmall: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletLarge */ .AV.tabletLarge
  }),
  tabletSmallOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletSmall */ .AV.tabletSmall,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletLarge */ .AV.tabletLarge
  }),
  tabletLarge: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.laptop */ .AV.laptop
  }),
  tabletLargeOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletLarge */ .AV.tabletLarge,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.laptop */ .AV.laptop
  }),
  tablet: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.laptop */ .AV.laptop
  }),
  tabletOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.tabletSmall */ .AV.tabletSmall,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.laptop */ .AV.laptop
  }),
  laptop: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.desktop */ .AV.desktop
  }),
  laptopOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.laptop */ .AV.laptop,
    max: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.desktop */ .AV.desktop
  }),
  desktopOnly: (0,_tager_web_components__WEBPACK_IMPORTED_MODULE_0__/* .createMediaMixin */ .p4)({
    min: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.desktop */ .AV.desktop
  })
};

/***/ })

}]);